import _ from 'lodash-es';

var _ACCOUNT_TYPES_NAMES;

var ACCOUNT_TYPES_MAP = {
  Primary: 1,
  Editor: 2,
  SuperUser: 3,
  External: 4,
  Viewer: 5
};
var ACCOUNT_TYPES_NAMES = (_ACCOUNT_TYPES_NAMES = {}, _ACCOUNT_TYPES_NAMES[ACCOUNT_TYPES_MAP.Primary] = 'Admin', _ACCOUNT_TYPES_NAMES[ACCOUNT_TYPES_MAP.Editor] = 'Editor', _ACCOUNT_TYPES_NAMES[ACCOUNT_TYPES_MAP.SuperUser] = 'SuperUser', _ACCOUNT_TYPES_NAMES[ACCOUNT_TYPES_MAP.External] = 'External', _ACCOUNT_TYPES_NAMES[ACCOUNT_TYPES_MAP.Viewer] = 'Viewer', _ACCOUNT_TYPES_NAMES);
var CAN_EDIT_ACCOUNT_TYPES = [ACCOUNT_TYPES_MAP.Primary, ACCOUNT_TYPES_MAP.Editor, ACCOUNT_TYPES_MAP.SuperUser];
var ACCOUNT_CREATION_SOURCE = {
  SCIM: 'scim',
  SSO: 'sso'
};

var AUTH = {
  OAUTH_SECRET_CACHE_ID: 'oacck'
};
var AUTH_ERROR = {
  REFRESH_TOKEN: {
    ERROR_KEY_NAME: 'errorReason',
    ERROR_MSG: 'Invalid refresh token'
  }
};

var CUSTOM_DASHBOARD_INTERNAL_TYPES = {
  CUSTOM_PM_METRICS: 'customPmMetrics',
  TEAM_GOALS: 'teamGoals',
  REPORTED_METRICS: 'reportedMetrics'
};

var INVITATION_TYPE = {
  EMAIL: 'email',
  COLLABORATION: {
    SLACK: 'slack'
  }
};

var LICENSE_PLAN_NAMES = {
  FREE: 'free',
  PRO: 'pro',
  ENTERPRISE: 'enterprise'
};
var LICENSE_PLAN_TIER_TYPE = {
  TEAM: 'team',
  PAID: 'paid',
  TRAIL: 'trial'
};

var MESSAGE_TYPES = {
  NEW_REPOS: 'NEW_REPOS',
  UNTRACKED_REPOS: 'UNTRACKED_REPOS',
  REPO_AUTO_DISCOVERY: 'REPO_AUTO_DISCOVERY',
  REACHED_LIMIT_REPOS: 'REACHED_LIMIT_REPOS'
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var GOALS_METRIC_NAMES = {
  MERGED_LARGE_PRS: 'pull_request_size_larger_than_evaluation',
  MERGED_LONG_LIVING_PRS: 'pull_request_open_more_than_evaluation',
  MERGED_REVIEW_REQUEST_HANGING: 'hanging_pr_without_review_evaluation',
  MERGED_WITHOUT_REVIEW: 'material_pr_merged_without_review_evaluation',
  MERGED_WORK_AT_RISK_PRS: 'high_risk_pull_request_evaluation',
  MERGED_WITH_BASIC_REVIEW_PRS: 'material_pr_merged_with_superficial_review_evaluation',
  MERGED_LONG_REVIEW_PRS: 'review_too_long_pull_request_evaluation'
};

var PRODUCTIVITY_METRICS = {
  WORKERB_CONNECTED_CONTRIBUTORS: 'workerb.connected.contributors',
  WORKERB_CONNECTED_TEAMS: 'workerb.connected.teams',
  WORKERB_NOT_CONNECTED_CONTRIBUTORS: 'workerb.not.connected.contributors',
  WORKERB_NOT_CONNECTED_TEAMS: 'workerb.not.connected.teams',
  REPOSITORY_MONITORED: 'repository.monitored',
  REPOSITORY_GITSTREAM_AUTOMATED: 'repository.gitstream_automated',
  REPOSITORY_MONITORED_GITSTREAM_AUTOMATED: 'repository.monitored_and_gitstream_automated',
  REPOSITORY_NOT_MONITORED: 'repository.not_monitored',
  PR_APPROVED_WITH_SAFE_CHANGES: 'pr.approved.with_safe_changes',
  PR_APPROVED_WITHOUT_SAFE_CHANGES: 'pr.approved.without_safe_changes',
  PR_APPROVED_WITH_SAFE_CHANGES_ESTIMATED_REVIEW_TIME: 'pr.approved.with_safe_changes.estimated_review_time',
  PR_APPROVED_WITH_SAFE_CHANGES_ESTIMATED_TIME_SAVED: 'pr.approved.with_safe_changes.estimated_time_saved',
  PR_APPROVED_BOT_GENERATED: 'pr.approved.bot_generated',
  PR_APPROVED_MANUAL_GENERATED: 'pr.approved.manual_generated',
  PR_APPROVED_BOT_GENERATED_ESTIMATED_REVIEW_TIME: 'pr.approved.bot_generated.estimated_review_time',
  PR_APPROVED_BOT_GENERATED_ESTIMATED_TIME_SAVED: 'pr.approved.bot_generated.estimated_time_saved'
};

var metricNames = /*#__PURE__*/_extends({
  TIME_TO_PR: 'branch.time_to_pr',
  TIME_TO_PR_MERGED: 'branch.merged.time_to_pr',
  TIME_TO_REVIEW: 'branch.time_to_review',
  TIME_TO_REVIEW_MERGED: 'branch.merged.time_to_review',
  TIME_TO_PROD: 'branch.time_to_prod',
  REVIEW_TIME: 'branch.review_time',
  REVIEW_TIME_MERGED: 'branch.merged.review_time',
  ACTIVE_BRANCHES: 'branch.state.active',
  DELETED_BRANCHES: 'branch.state.deleted',
  MERGED_BRANCHES: 'branch.state.merged',
  DEPLOYED_BRANCHES: 'branch.state.deployed',
  DONE_BRANCHES: 'branch.state.computed.done',
  CYCLE_TIME: 'branch.computed.cycle_time',
  SUM_OF_COMPONENTS_CYCLE_TIME: 'branch.cycle_time.sum_of_components',
  ACTIVE_DAYS: 'commit.activity_days',
  NEW_WORK: 'commit.activity.new_work.count',
  REWORK: 'commit.activity.rework.count',
  REFACTOR: 'commit.activity.refactor.count',
  TOTAL_ACTIVITY: 'commit.activity.total.count',
  COMMIT_CODE_CHANGES: 'commit.total_changes',
  COMMIT_COUNT: 'commit.total.count',
  REVIEWS: 'pr.reviews',
  REVIEW_DEPTH: 'pr.review_depth',
  PR_REVIEWED: 'pr.reviewed',
  CONTRIBUTOR_CODING_DAYS: 'contributor.coding_days',
  PR_NEW: 'pr.new',
  PR_SIZE: 'pr.merged.size',
  PR_MERGED: 'pr.merged',
  PR_MERGED_WITHOUT_REVIEW: 'pr.merged.without.review.count',
  RELEASES_COUNT: 'releases.count',
  RELEASES_AVG: 'releases.avg',
  COMMIT_INVOLVED_REPOS_COUNT: 'commit.involved.repos.count',
  PM_ISSUE_COUNT: 'pm.issue.count',
  PM_ISSUE_STATE_TRANSITION: 'pm.issue.state_transition',
  PM_ISSUE_STATE_CATEGORY_TRANSITION: 'pm.issue.state_category_transition',
  BRANCH_TIME_TO_MERGE: 'branch.time_to_merge',
  BRANCH_TIME_TO_APPROVE: 'branch.time_to_approve',
  PM_MTTR: 'pm.mttr',
  PM_CFR: 'pm.cfr.issues.done',
  BRANCH_TIME_TO_RELEASE: 'branch.time_to_release',
  PR_MATURITY_RATIO: 'pr.maturity_ratio',
  BUGS_COMPLETED: 'bug_completed',
  BUGS_IN_PROGRESS: 'bug_wip',
  STORIES_COMPLETED: 'story_completed',
  ACTIVE_CONTRIBUTORS: 'commit.active_contributors',
  PM_CUSTOM: 'pm_custom',
  REPORTED_CUSTOM: 'reported.custom',
  CODE_CHURN_REWORK: 'commit.code_churn.rework',
  CODE_CHURN_REFACTOR: 'commit.code_churn.refactor',
  PR_REVIEWER_TIME_TO_REVIEW: 'pr.reviewer.time_to_review',
  PR_REVIEWER_TIME_TO_APPROVE: 'pr.reviewer.time_to_approve'
}, GOALS_METRIC_NAMES, PRODUCTIVITY_METRICS);

var metricsScales = {
  TIME: 'time',
  FREQUENCY: 'frequency',
  CODE_CHANGES: 'code_changes',
  PERCENTAGE: 'percentage'
};

var _METRICS_BENCHMARKS, _CYCLE_TIME_METRICS_B, _metricNames$CYCLE_TI, _metricNames$TIME_TO_, _metricNames$TIME_TO_2, _metricNames$REVIEW_T, _metricNames$TIME_TO_3, _metricNames$BRANCH_T, _metricNames$BRANCH_T2, _metricNames$PR_MATUR, _metricNames$PM_MTTR, _metricNames$PM_CFR, _metricNames$REWORK, _metricNames$REFACTOR, _metricNames$PR_SIZE, _ORG_SIZE_METRICS_BEN, _metricNames$TIME_TO_4, _metricNames$TIME_TO_5, _metricNames$REVIEW_T2, _metricNames$TIME_TO_6, _ORG_SIZE_CYCLE_TIME_;
var METRICS_BENCHMARKS = (_METRICS_BENCHMARKS = {}, _METRICS_BENCHMARKS[metricNames.CYCLE_TIME] = {
  unit: 'hours',
  scale: metricsScales.TIME,
  description: "measures the time it takes for a single engineering task to go through the different phases of the delivery process from 'code' to 'production'.",
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 73 * 60,
    range_text: 'Up to 73 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 73 * 60,
    max_value: 155 * 60,
    range_text: '73 - 155 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 155 * 60,
    max_value: 304 * 60,
    range_text: '155 - 304 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 304 * 60,
    max_value: null,
    range_text: '304 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 19 * 60,
    range_text: 'Up to 19 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 19 * 60,
    max_value: 66 * 60,
    range_text: '19 - 66 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 66 * 60,
    max_value: 218 * 60,
    range_text: '66 - 218 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 218 * 60,
    max_value: null,
    range_text: '218 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 0.65 * 60,
    range_text: 'Up to 39 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 0.65 * 60,
    max_value: 2.25 * 60,
    range_text: '39 - 135 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 2.25 * 60,
    max_value: 29 * 60,
    range_text: '2.25 - 29 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 29 * 60,
    max_value: null,
    range_text: '29 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 186 * 60,
    range_text: 'Up to 186 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 186 * 60,
    max_value: 433 * 60,
    range_text: '186 - 433 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 433 * 60,
    max_value: 736 * 60,
    range_text: '433 - 736 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 736 * 60,
    max_value: null,
    range_text: '736 hours or more'
  }]
}, _METRICS_BENCHMARKS[metricNames.TIME_TO_PR] = {
  unit: 'hours',
  scale: metricsScales.TIME,
  description: "measures the time it takes from the first commit until a pull request is issued. Short Coding Time correlates to low WIP, small PR size and clear requirements.",
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 19 * 60,
    range_text: 'Up to 19 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 19 * 60,
    max_value: 44 * 60,
    range_text: '19 - 44 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 44 * 60,
    max_value: 99 * 60,
    range_text: '44 - 99 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 99 * 60,
    max_value: null,
    range_text: '99 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 0.5 * 60,
    range_text: 'Up to 0.5 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 0.5 * 60,
    max_value: 2.5 * 60,
    range_text: '0.5 - 2.5 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 2.5 * 60,
    max_value: 24 * 60,
    range_text: '2.5 - 24 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 24 * 60,
    max_value: null,
    range_text: '24 hours or more'
  }]
}, _METRICS_BENCHMARKS[metricNames.TIME_TO_REVIEW] = {
  unit: 'hours',
  scale: metricsScales.TIME,
  description: "measures the time a pull request waits for someone to start reviewing it. Low Pickup Time represents strong teamwork and a healthy review process.",
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 7 * 60,
    range_text: 'Up to 7 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 7 * 60,
    max_value: 13 * 60,
    range_text: '7 - 13 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 13 * 60,
    max_value: 24 * 60,
    range_text: '13 - 24 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 24 * 60,
    max_value: null,
    range_text: '24 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 0.2 * 60,
    range_text: 'Up to 12 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 0.2 * 60,
    max_value: 0.3 * 60,
    range_text: '12 - 18 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 0.3 * 60,
    max_value: 0.7 * 60,
    range_text: '18 - 42 minutes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 0.7 * 60,
    max_value: null,
    range_text: '42 minutes or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 1 * 60,
    range_text: 'Up to 1 hour'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 1 * 60,
    max_value: 3 * 60,
    range_text: '1 - 3 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 3 * 60,
    max_value: 14 * 60,
    range_text: '3 - 14 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 14 * 60,
    max_value: null,
    range_text: '14 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 15 * 60,
    range_text: 'Up to 15 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 15 * 60,
    max_value: 23 * 60,
    range_text: '15 - 23 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 23 * 60,
    max_value: 51 * 60,
    range_text: '23 - 51 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 51 * 60,
    max_value: null,
    range_text: '51 hours or more'
  }]
}, _METRICS_BENCHMARKS[metricNames.REVIEW_TIME] = {
  unit: 'hours',
  scale: metricsScales.TIME,
  description: "measures the time it takes to complete a code review and get a pull request merged. Low Review Time represents strong teamwork and a healthy review process.",
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 5 * 60,
    range_text: 'Up to 5 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 5 * 60,
    max_value: 14 * 60,
    range_text: '5 - 14 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 14 * 60,
    max_value: 29 * 60,
    range_text: '14 - 29 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 29 * 60,
    max_value: null,
    range_text: '29 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 0.06 * 60,
    range_text: 'Up to ~4 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 0.06 * 60,
    max_value: 0.25 * 60,
    range_text: '~4 - 15 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 0.25 * 60,
    max_value: 0.9 * 60,
    range_text: '15 - 54 minutes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 0.9 * 60,
    max_value: null,
    range_text: '54 minutes or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 0.5 * 60,
    range_text: 'Up to 0.5 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 0.5 * 60,
    max_value: 3 * 60,
    range_text: '0.5 - 3 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 3 * 60,
    max_value: 18 * 60,
    range_text: '3 - 18 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 18 * 60,
    max_value: null,
    range_text: '18 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 11 * 60,
    range_text: 'Up to 11 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 11 * 60,
    max_value: 29 * 60,
    range_text: '11 - 29 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 29 * 60,
    max_value: 73 * 60,
    range_text: '29 - 73 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 73 * 60,
    max_value: null,
    range_text: '73 hours or more'
  }]
}, _METRICS_BENCHMARKS[metricNames.TIME_TO_PROD] = {
  unit: 'hours',
  scale: metricsScales.TIME,
  description: "measures the time from when a branch is merged to when the code is released. Low deploy time correlates to high deployment frequency.",
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 6 * 60,
    range_text: 'Up to 6 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 6 * 60,
    max_value: 50 * 60,
    range_text: '6 - 50 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 50 * 60,
    max_value: 137 * 60,
    range_text: '50 - 137 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 137 * 60,
    max_value: null,
    range_text: '137 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 0.3 * 60,
    range_text: 'Up to 18 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 0.3 * 60,
    max_value: 5.9 * 60,
    range_text: '18 - 354 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 5.9 * 60,
    max_value: 71 * 60,
    range_text: '~6 - 71 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 71 * 60,
    max_value: null,
    range_text: '71 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 3 * 60,
    range_text: 'Up to 3 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 3 * 60,
    max_value: 69 * 60,
    range_text: '3 - 69 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 69 * 60,
    max_value: 197 * 60,
    range_text: '69 - 197 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 197 * 60,
    max_value: null,
    range_text: '197 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 27 * 60,
    range_text: 'Up to 27 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 27 * 60,
    max_value: 213 * 60,
    range_text: '27 - 213 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 213 * 60,
    max_value: 381 * 60,
    range_text: '213 - 381 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 381 * 60,
    max_value: null,
    range_text: '381 hours or more'
  }]
}, _METRICS_BENCHMARKS[metricNames.RELEASES_COUNT] = {
  unit: 'days',
  scale: metricsScales.FREQUENCY,
  granularity: 'week',
  description: "measures how often code is released. Elite Deploy Frequency represents a stable and healthy continuous delivery pipeline.",
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: 17,
    max_value: null,
    range_text: '17 deployments/week or more'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 5,
    max_value: 17,
    range_text: '5 - 17 deployments/week'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 1,
    max_value: 5,
    range_text: '1 - 5 deployments/week'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: null,
    max_value: 1,
    range_text: '< 1 / week'
  }]
}, _METRICS_BENCHMARKS[metricNames.PR_SIZE] = {
  unit: 'code changes',
  unitDescription: 'code changes',
  scale: metricsScales.CODE_CHANGES,
  description: "measures the number of code lines modified in a pull request. Smaller pull requests are easier to review, safer to merge, correlate to lower Cycle Time.",
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 219,
    range_text: '219 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 219,
    max_value: 395,
    range_text: '219 - 395 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 395,
    max_value: 793,
    range_text: '395 - 793 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 793,
    max_value: null,
    range_text: '793 code changes or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 20,
    range_text: '20 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 20,
    max_value: 30,
    range_text: '20 - 30 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 30,
    max_value: 44,
    range_text: '30 - 44 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 44,
    max_value: null,
    range_text: '44 code changes or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 98,
    range_text: '98 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 98,
    max_value: 148,
    range_text: '98 - 148 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 148,
    max_value: 218,
    range_text: '148 - 218 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 218,
    max_value: null,
    range_text: '218 code changes or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 378,
    range_text: '378 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 378,
    max_value: 522,
    range_text: '378 - 522 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 522,
    max_value: 738,
    range_text: '522 - 738 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 738,
    max_value: null,
    range_text: '738 code changes or more'
  }]
}, _METRICS_BENCHMARKS[metricNames.REWORK] = {
  unit: '%',
  scale: metricsScales.PERCENTAGE,
  description: "measures the amount of changes made to code that is less than 21 days old. High rework rates signal code churn and is a leading indicator of quality issues",
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 2,
    range_text: '2% or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 2,
    max_value: 5,
    range_text: '2% - 5%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 5,
    max_value: 7,
    range_text: '5% - 7%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 7,
    max_value: null,
    range_text: '7% or more'
  }]
}, _METRICS_BENCHMARKS[metricNames.REFACTOR] = {
  unit: '%',
  scale: metricsScales.PERCENTAGE,
  description: "measures the amount of changes made to code that is more than 21 days old. A large amount of refactoring in a single release is not recommended, as these changes have a higher probability of harming existing functionality.",
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 9,
    range_text: '9% or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 9,
    max_value: 15,
    range_text: '9% - 15%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 15,
    max_value: 21,
    range_text: '15% - 21%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 21,
    max_value: null,
    range_text: '21% or more'
  }]
}, _METRICS_BENCHMARKS[metricNames.PM_CFR] = {
  unit: '%',
  scale: metricsScales.PERCENTAGE,
  description: "measures the percentage of deployments causing a failure in production. LinearB calculates this metric based on the number of \"production incidents\" defined in your project management tool divided by the number of deployments.",
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 1,
    range_text: '1% or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 1,
    max_value: 8,
    range_text: '1% - 8%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 8,
    max_value: 39,
    range_text: '8% - 39%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 39,
    max_value: null,
    range_text: '39% or more'
  }]
}, _METRICS_BENCHMARKS[metricNames.PM_MTTR] = {
  unit: 'hours',
  scale: metricsScales.TIME,
  description: "measures the average time it takes to restore from a failure of the system or one of its components. LinearB calculates this metric based on the time a \"production bug\" spends in the \"in progress\" state.",
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 7 * 60,
    range_text: '7 hours or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 7 * 60,
    max_value: 9 * 60,
    range_text: '7 - 9 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 9 * 60,
    max_value: 10 * 60,
    range_text: '9 - 10 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 10 * 60,
    max_value: null,
    range_text: '10 hours or more'
  }]
}, _METRICS_BENCHMARKS);
var CYCLE_TIME_METRICS_BENCHMARKS_VALUES = (_CYCLE_TIME_METRICS_B = {}, _CYCLE_TIME_METRICS_B[metricNames.TIME_TO_PR] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 19 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 44 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 99 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 99 * 60;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 0.5 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 2.5 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 24 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 24 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 0.02 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 0.05 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 99 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 99 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 0.5 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 2.5 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 24 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 24 * 60;
    }
  }
}, _CYCLE_TIME_METRICS_B[metricNames.TIME_TO_REVIEW] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 7 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 13 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 24 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 24 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 0.2 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 0.3 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 0.7 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 0.7 * 60;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 1 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 3 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 14 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 14 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 15 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 23 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 51 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 51 * 60;
    }
  }
}, _CYCLE_TIME_METRICS_B[metricNames.TIME_TO_PROD] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 6 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 50 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 137 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 137 * 60;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 3 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 69 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 197 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 197 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 0.3 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 5.9 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 71 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 71 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 27 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 213 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 381 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 381 * 60;
    }
  }
}, _CYCLE_TIME_METRICS_B[metricNames.REVIEW_TIME] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 5 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 14 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 29 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 29 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 19 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 44 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 99 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 99 * 60;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 0.5 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 3 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 18 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 18 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 0.5 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 2.5 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 24 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 24 * 60;
    }
  }
}, _CYCLE_TIME_METRICS_B);
var BENCHMARKS_STATES = {
  ELITE: 'Elite',
  GOOD: 'Good',
  FAIR: 'Fair',
  POOR: 'Poor',
  N_A: 'N/A'
};
var BENCHMARK_ORG_SIZE_KEYS = {
  startup: '1_200',
  scale_up: '201_1000',
  enterprise: '1000+',
  all: 'all'
}; // when adding metric to this object, need to also add to metricDisplayValues in constants/metrics/displays.ts

var ORG_SIZE_METRICS_BENCHMARKS = (_ORG_SIZE_METRICS_BEN = {}, _ORG_SIZE_METRICS_BEN[metricNames.CYCLE_TIME] = (_metricNames$CYCLE_TI = {
  unit: 'hours',
  scale: metricsScales.TIME,
  description: "measures the time it takes for a single engineering task to go through the different phases of the delivery process from 'code' to 'production'."
}, _metricNames$CYCLE_TI[BENCHMARK_ORG_SIZE_KEYS.all] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 50 * 60,
    range_text: 'Up to 50 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 50 * 60,
    max_value: 91 * 60,
    range_text: '50 - 91 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 91 * 60,
    max_value: 156 * 60,
    range_text: '91 - 156 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 156 * 60,
    max_value: null,
    range_text: '156 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 3 * 60,
    range_text: 'Up to 3 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 3 * 60,
    max_value: 19 * 60,
    range_text: '3 - 19 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 19 * 60,
    max_value: 46 * 60,
    range_text: '19 - 46 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 46 * 60,
    max_value: null,
    range_text: '46 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 26 * 60,
    range_text: 'Up to 26 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 26 * 60,
    max_value: 81 * 60,
    range_text: '26 - 81 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 81 * 60,
    max_value: 167 * 60,
    range_text: '81 - 167 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 167 * 60,
    max_value: null,
    range_text: '167 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 119 * 60,
    range_text: 'Up to 119 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 119 * 60,
    max_value: 219 * 60,
    range_text: '119 - 219 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 219 * 60,
    max_value: 410 * 60,
    range_text: '219 - 410 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 410 * 60,
    max_value: null,
    range_text: '410 hours or more'
  }]
}, _metricNames$CYCLE_TI[BENCHMARK_ORG_SIZE_KEYS.enterprise] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 62 * 60,
    range_text: 'Up to 62 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 62 * 60,
    max_value: 103 * 60,
    range_text: '62 - 103 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 103 * 60,
    max_value: 167 * 60,
    range_text: '103 - 167 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 167 * 60,
    max_value: null,
    range_text: '167 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 2 * 60,
    range_text: 'Up to 2 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 2 * 60,
    max_value: 16 * 60,
    range_text: '2 - 16 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 16 * 60,
    max_value: 39 * 60,
    range_text: '16 - 39 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 39 * 60,
    max_value: null,
    range_text: '39 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 27 * 60,
    range_text: 'Up to 27 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 27 * 60,
    max_value: 98 * 60,
    range_text: '27 - 98 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 98 * 60,
    max_value: 174 * 60,
    range_text: '98 - 174 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 174 * 60,
    max_value: null,
    range_text: '174 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 145 * 60,
    range_text: 'Up to 145 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 145 * 60,
    max_value: 264 * 60,
    range_text: '145 - 264 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 264 * 60,
    max_value: 467 * 60,
    range_text: '264 - 467 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 467 * 60,
    max_value: null,
    range_text: '467 hours or more'
  }]
}, _metricNames$CYCLE_TI[BENCHMARK_ORG_SIZE_KEYS.scale_up] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 65 * 60,
    range_text: 'Up to 65 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 65 * 60,
    max_value: 102 * 60,
    range_text: '65 - 102 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 102 * 60,
    max_value: 165 * 60,
    range_text: '102 - 165 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 165 * 60,
    max_value: null,
    range_text: '165 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 4 * 60,
    range_text: 'Up to 4 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 4 * 60,
    max_value: 20 * 60,
    range_text: '4 - 20 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 20 * 60,
    max_value: 47 * 60,
    range_text: '20 - 47 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 47 * 60,
    max_value: null,
    range_text: '47 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 47 * 60,
    range_text: 'Up to 47 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 47 * 60,
    max_value: 94 * 60,
    range_text: '47 - 94 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 94 * 60,
    max_value: 172 * 60,
    range_text: '94 - 172 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 172 * 60,
    max_value: null,
    range_text: '172 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 147 * 60,
    range_text: 'Up to 147 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 147 * 60,
    max_value: 262 * 60,
    range_text: '147 - 262 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 262 * 60,
    max_value: 423 * 60,
    range_text: '262 - 423 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 423 * 60,
    max_value: null,
    range_text: '423 hours or more'
  }]
}, _metricNames$CYCLE_TI[BENCHMARK_ORG_SIZE_KEYS.startup] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 48 * 60,
    range_text: 'Up to 48 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 48 * 60,
    max_value: 90 * 60,
    range_text: '48 - 90 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 90 * 60,
    max_value: 157 * 60,
    range_text: '90 - 157 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 157 * 60,
    max_value: null,
    range_text: '157 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 3 * 60,
    range_text: 'Up to 3 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 3 * 60,
    max_value: 19 * 60,
    range_text: '3 - 19 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 19 * 60,
    max_value: 48 * 60,
    range_text: '19 - 48 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 48 * 60,
    max_value: null,
    range_text: '48 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 26 * 60,
    range_text: 'Up to 26 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 26 * 60,
    max_value: 79 * 60,
    range_text: '26 - 79 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 79 * 60,
    max_value: 171 * 60,
    range_text: '79 - 171 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 171 * 60,
    max_value: null,
    range_text: '171 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 118 * 60,
    range_text: 'Up to 118 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 118 * 60,
    max_value: 217 * 60,
    range_text: '118 - 217 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 217 * 60,
    max_value: 410 * 60,
    range_text: '217 - 410 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 410 * 60,
    max_value: null,
    range_text: '410 hours or more'
  }]
}, _metricNames$CYCLE_TI), _ORG_SIZE_METRICS_BEN[metricNames.TIME_TO_PR] = (_metricNames$TIME_TO_ = {
  unit: 'hours',
  scale: metricsScales.TIME,
  description: "measures the time it takes from the first commit until a pull request is issued. Short Coding Time correlates to low WIP, small PR size and clear requirements."
}, _metricNames$TIME_TO_[BENCHMARK_ORG_SIZE_KEYS.all] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 19 * 60,
    range_text: 'Up to 19 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 19 * 60,
    max_value: 35 * 60,
    range_text: '19 - 35 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 35 * 60,
    max_value: 66 * 60,
    range_text: '35 - 66 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 66 * 60,
    max_value: null,
    range_text: '66 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 4,
    range_text: 'Up to 4 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 4,
    max_value: 8,
    range_text: '4 - 8 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 8,
    max_value: 20,
    range_text: '8 - 20 minutes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 20,
    max_value: null,
    range_text: '20 minutes or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 1 * 60,
    range_text: 'Up to 1 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 1 * 60,
    max_value: 5 * 60,
    range_text: '1 - 5 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 5 * 60,
    max_value: 23 * 60,
    range_text: '5 - 23 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 23 * 60,
    max_value: null,
    range_text: '23 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 26 * 60,
    range_text: 'Up to 26 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 26 * 60,
    max_value: 73 * 60,
    range_text: '26 - 73 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 73 * 60,
    max_value: 146 * 60,
    range_text: '73 - 146 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 146 * 60,
    max_value: null,
    range_text: '146 hours or more'
  }]
}, _metricNames$TIME_TO_[BENCHMARK_ORG_SIZE_KEYS.enterprise] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 28 * 60,
    range_text: 'Up to 28 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 28 * 60,
    max_value: 53 * 60,
    range_text: '28 - 53 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 53 * 60,
    max_value: 98 * 60,
    range_text: '53 - 98 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 98 * 60,
    max_value: null,
    range_text: '98 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 4,
    range_text: 'Up to 4 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 4,
    max_value: 9,
    range_text: '4 - 9 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 9,
    max_value: 26,
    range_text: '9 - 26 minutes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 26,
    max_value: null,
    range_text: '26 minutes or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 2 * 60,
    range_text: 'Up to 2 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 2 * 60,
    max_value: 10 * 60,
    range_text: '2 - 10 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 10 * 60,
    max_value: 28 * 60,
    range_text: '10- 28 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 28 * 60,
    max_value: null,
    range_text: '28 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 48 * 60,
    range_text: 'Up to 48 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 48 * 60,
    max_value: 115 * 60,
    range_text: '48 - 115 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 115 * 60,
    max_value: 195 * 60,
    range_text: '115 - 195 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 195 * 60,
    max_value: null,
    range_text: '195 hours or more'
  }]
}, _metricNames$TIME_TO_[BENCHMARK_ORG_SIZE_KEYS.scale_up] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 24 * 60,
    range_text: 'Up to 24 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 24 * 60,
    max_value: 44 * 60,
    range_text: '24 - 44 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 44 * 60,
    max_value: 88 * 60,
    range_text: '44 - 88 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 88 * 60,
    max_value: null,
    range_text: '88 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 4,
    range_text: 'Up to 4 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 4,
    max_value: 9,
    range_text: '4 - 9 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 9,
    max_value: 27,
    range_text: '9 - 27 minutes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 27,
    max_value: null,
    range_text: '27 minutes or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 3 * 60,
    range_text: 'Up to 3 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 3 * 60,
    max_value: 7 * 60,
    range_text: '3 - 7 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 7 * 60,
    max_value: 28 * 60,
    range_text: '7 - 28 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 28 * 60,
    max_value: null,
    range_text: '28 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 42 * 60,
    range_text: 'Up to 42 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 42 * 60,
    max_value: 94 * 60,
    range_text: '42 - 94 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 94 * 60,
    max_value: 173 * 60,
    range_text: '94 - 173 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 173 * 60,
    max_value: null,
    range_text: '173 hours or more'
  }]
}, _metricNames$TIME_TO_[BENCHMARK_ORG_SIZE_KEYS.startup] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 18 * 60,
    range_text: 'Up to 18 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 18 * 60,
    max_value: 33 * 60,
    range_text: '18 - 33 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 33 * 60,
    max_value: 61 * 60,
    range_text: '33 - 61 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 61 * 60,
    max_value: null,
    range_text: '61 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 4,
    range_text: 'Up to 4 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 4,
    max_value: 9,
    range_text: '4 - 9 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 9,
    max_value: 20,
    range_text: '9 - 20 minutes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 20,
    max_value: null,
    range_text: '20 minutes or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 1 * 60,
    range_text: 'Up to 1 hour'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 1 * 60,
    max_value: 5 * 60,
    range_text: '1 - 5 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 5 * 60,
    max_value: 22 * 60,
    range_text: '5 - 22 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 22 * 60,
    max_value: null,
    range_text: '22 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 26 * 60,
    range_text: 'Up to 26 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 26 * 60,
    max_value: 71 * 60,
    range_text: '26 - 71 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 71 * 60,
    max_value: 142 * 60,
    range_text: '71 - 142 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 142 * 60,
    max_value: null,
    range_text: '142 hours or more'
  }]
}, _metricNames$TIME_TO_), _ORG_SIZE_METRICS_BEN[metricNames.TIME_TO_REVIEW] = (_metricNames$TIME_TO_2 = {
  unit: 'hours',
  scale: metricsScales.TIME,
  description: "measures the time a pull request waits for someone to start reviewing it. Low Pickup Time represents strong teamwork and a healthy review process."
}, _metricNames$TIME_TO_2[BENCHMARK_ORG_SIZE_KEYS.all] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 8 * 60,
    range_text: 'Up to 8 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 8 * 60,
    max_value: 15 * 60,
    range_text: '8 - 15 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 15 * 60,
    max_value: 23 * 60,
    range_text: '15 - 23 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 23 * 60,
    max_value: null,
    range_text: '23 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 12,
    range_text: 'Up to 12 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 12,
    max_value: 27,
    range_text: '12 - 27 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 27,
    max_value: 60,
    range_text: '27 - 60 minutes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 60,
    max_value: null,
    range_text: '60 minutes or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 75,
    range_text: 'Up to 75 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 75,
    max_value: 6 * 60,
    range_text: '75 minutes - 6 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 6 * 60,
    max_value: 16 * 60,
    range_text: '6 - 16 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 16 * 60,
    max_value: null,
    range_text: '16 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 16 * 60,
    range_text: 'Up to 16 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 16 * 60,
    max_value: 26 * 60,
    range_text: '16 - 26 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 26 * 60,
    max_value: 63 * 60,
    range_text: '26 - 63 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 63 * 60,
    max_value: null,
    range_text: '63 hours or more'
  }]
}, _metricNames$TIME_TO_2[BENCHMARK_ORG_SIZE_KEYS.enterprise] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 9 * 60,
    range_text: 'Up to 9 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 9 * 60,
    max_value: 15 * 60,
    range_text: '9 - 15 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 15 * 60,
    max_value: 22 * 60,
    range_text: '15 - 22 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 22 * 60,
    max_value: null,
    range_text: '22 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 11,
    range_text: 'Up to 11 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 11,
    max_value: 22,
    range_text: '11 - 22 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 22,
    max_value: 47,
    range_text: '22 - 47 minutes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 47,
    max_value: null,
    range_text: '47 minutes or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 78,
    range_text: 'Up to 78 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 78,
    max_value: 5 * 60,
    range_text: '78 minutes - 5 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 5 * 60,
    max_value: 15 * 60,
    range_text: '5 - 15 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 15 * 60,
    max_value: null,
    range_text: '15 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 17 * 60,
    range_text: 'Up to 17 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 17 * 60,
    max_value: 25 * 60,
    range_text: '17 - 25 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 25 * 60,
    max_value: 57 * 60,
    range_text: '25 - 57 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 57 * 60,
    max_value: null,
    range_text: '57 hours or more'
  }]
}, _metricNames$TIME_TO_2[BENCHMARK_ORG_SIZE_KEYS.scale_up] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 9 * 60,
    range_text: 'Up to 9 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 9 * 60,
    max_value: 17 * 60,
    range_text: '9 - 17 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 17 * 60,
    max_value: 25 * 60,
    range_text: '17 - 25 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 25 * 60,
    max_value: null,
    range_text: '25 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 11,
    range_text: 'Up to 11 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 11,
    max_value: 31,
    range_text: '11 - 31 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 31,
    max_value: 57,
    range_text: '31 - 57 minutes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 57,
    max_value: null,
    range_text: '57 minutes or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 65,
    range_text: 'Up to 65 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 65,
    max_value: 6 * 60,
    range_text: '65 minutes - 6 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 6 * 60,
    max_value: 17 * 60,
    range_text: '6 - 17 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 17 * 60,
    max_value: null,
    range_text: '17 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 18 * 60,
    range_text: 'Up to 18 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 18 * 60,
    max_value: 27 * 60,
    range_text: '18 - 27 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 27 * 60,
    max_value: 66 * 60,
    range_text: '27 - 66 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 66 * 60,
    max_value: null,
    range_text: '66 hours or more'
  }]
}, _metricNames$TIME_TO_2[BENCHMARK_ORG_SIZE_KEYS.startup] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 8 * 60,
    range_text: 'Up to 8 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 8 * 60,
    max_value: 15 * 60,
    range_text: '8 - 15 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 15 * 60,
    max_value: 23 * 60,
    range_text: '15 - 23 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 23 * 60,
    max_value: null,
    range_text: '23 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 14,
    range_text: 'Up to 14 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 14,
    max_value: 29,
    range_text: '14 - 29 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 29,
    max_value: 66,
    range_text: '29 - 66 minutes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 66,
    max_value: null,
    range_text: '66 minutes or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 88,
    range_text: 'Up to 88 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 88,
    max_value: 6 * 60,
    range_text: '88 minutes - 6 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 6 * 60,
    max_value: 17 * 60,
    range_text: '6 - 17 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 17 * 60,
    max_value: null,
    range_text: '17 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 17 * 60,
    range_text: 'Up to 17 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 17 * 60,
    max_value: 26 * 60,
    range_text: '17 - 26 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 26 * 60,
    max_value: 64 * 60,
    range_text: '26 - 64 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 64 * 60,
    max_value: null,
    range_text: '64 hours or more'
  }]
}, _metricNames$TIME_TO_2), _ORG_SIZE_METRICS_BEN[metricNames.REVIEW_TIME] = (_metricNames$REVIEW_T = {
  unit: 'hours',
  scale: metricsScales.TIME,
  description: "measures the time it takes to complete a code review and get a pull request merged. Low Review Time represents strong teamwork and a healthy review process."
}, _metricNames$REVIEW_T[BENCHMARK_ORG_SIZE_KEYS.all] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 12 * 60,
    range_text: 'Up to 12 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 12 * 60,
    max_value: 22 * 60,
    range_text: '12 - 22 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 22 * 60,
    max_value: 37 * 60,
    range_text: '22 - 37 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 37 * 60,
    max_value: null,
    range_text: '37 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 20,
    range_text: 'Up to 20 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 20,
    max_value: 60,
    range_text: '20 - 60 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 1 * 60,
    max_value: 3 * 60,
    range_text: '1 - 3 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 3 * 60,
    max_value: null,
    range_text: '3 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 3 * 60,
    range_text: 'Up to 3 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 3 * 60,
    max_value: 14 * 60,
    range_text: '3 - 14 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 14 * 60,
    max_value: 24 * 60,
    range_text: '14 - 24 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 24 * 60,
    max_value: null,
    range_text: '24 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 21 * 60,
    range_text: 'Up to 21 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 21 * 60,
    max_value: 51 * 60,
    range_text: '21 - 51 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 51 * 60,
    max_value: 96 * 60,
    range_text: '51 - 96 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 96 * 60,
    max_value: null,
    range_text: '96 hours or more'
  }]
}, _metricNames$REVIEW_T[BENCHMARK_ORG_SIZE_KEYS.enterprise] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 13 * 60,
    range_text: 'Up to 13 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 13 * 60,
    max_value: 24 * 60,
    range_text: '13 - 24 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 24 * 60,
    max_value: 36 * 60,
    range_text: '24 - 36 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 36 * 60,
    max_value: null,
    range_text: '36 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 20,
    range_text: 'Up to 20 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 20,
    max_value: 45,
    range_text: '20 - 45 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 45,
    max_value: 2 * 60,
    range_text: '45 minutes - 2 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 2 * 60,
    max_value: null,
    range_text: '2 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 3 * 60,
    range_text: 'Up to 3 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 3 * 60,
    max_value: 11 * 60,
    range_text: '3 - 11 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 11 * 60,
    max_value: 22 * 60,
    range_text: '11 - 22 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 22 * 60,
    max_value: null,
    range_text: '22 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 23 * 60,
    range_text: 'Up to 23 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 23 * 60,
    max_value: 49 * 60,
    range_text: '23 - 49 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 49 * 60,
    max_value: 94 * 60,
    range_text: '49 - 94 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 94 * 60,
    max_value: null,
    range_text: '94 hours or more'
  }]
}, _metricNames$REVIEW_T[BENCHMARK_ORG_SIZE_KEYS.scale_up] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 14 * 60,
    range_text: 'Up to 14 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 14 * 60,
    max_value: 26 * 60,
    range_text: '14 - 26 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 26 * 60,
    max_value: 41 * 60,
    range_text: '26 - 41 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 41 * 60,
    max_value: null,
    range_text: '41 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 21,
    range_text: 'Up to 21 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 21,
    max_value: 57,
    range_text: '21 - 57 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 57,
    max_value: 3 * 60,
    range_text: '57 minutes - 3 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 3 * 60,
    max_value: null,
    range_text: '3 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 3 * 60,
    range_text: 'Up to 3 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 3 * 60,
    max_value: 18 * 60,
    range_text: '3 - 18 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 18 * 60,
    max_value: 25 * 60,
    range_text: '18 - 25 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 25 * 60,
    max_value: null,
    range_text: '25 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 24 * 60,
    range_text: 'Up to 24 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 24 * 60,
    max_value: 69 * 60,
    range_text: '24 - 69 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 69 * 60,
    max_value: 100 * 60,
    range_text: '69 - 100 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 100 * 60,
    max_value: null,
    range_text: '100 hours or more'
  }]
}, _metricNames$REVIEW_T[BENCHMARK_ORG_SIZE_KEYS.startup] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 12 * 60,
    range_text: 'Up to 12 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 12 * 60,
    max_value: 21 * 60,
    range_text: '12 - 21 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 21 * 60,
    max_value: 36 * 60,
    range_text: '21 - 36 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 36 * 60,
    max_value: null,
    range_text: '36 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 23,
    range_text: 'Up to 23 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 23,
    max_value: 54,
    range_text: '23 - 54 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 54,
    max_value: 3 * 60,
    range_text: '54 minutes - 3 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 3 * 60,
    max_value: null,
    range_text: '3 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 3 * 60,
    range_text: 'Up to 3 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 3 * 60,
    max_value: 14 * 60,
    range_text: '3 - 14 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 14 * 60,
    max_value: 24 * 60,
    range_text: '14 - 24 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 24 * 60,
    max_value: null,
    range_text: '24 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 22 * 60,
    range_text: 'Up to 22 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 22 * 60,
    max_value: 50 * 60,
    range_text: '22 - 50 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 50 * 60,
    max_value: 95 * 60,
    range_text: '50 - 95 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 95 * 60,
    max_value: null,
    range_text: '95 hours or more'
  }]
}, _metricNames$REVIEW_T), _ORG_SIZE_METRICS_BEN[metricNames.TIME_TO_PROD] = (_metricNames$TIME_TO_3 = {
  unit: 'hours',
  scale: metricsScales.TIME,
  description: "measures the time from when a branch is merged to when the code is released. Low deploy time correlates to high deployment frequency."
}, _metricNames$TIME_TO_3[BENCHMARK_ORG_SIZE_KEYS.all] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 21 * 60,
    range_text: 'Up to 21 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 21 * 60,
    max_value: 77 * 60,
    range_text: '21 - 77 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 77 * 60,
    max_value: 163 * 60,
    range_text: '77 - 163 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 163 * 60,
    max_value: null,
    range_text: '163 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 50,
    range_text: 'Up to 50 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 50,
    max_value: 23 * 60,
    range_text: '50 minutes - 23 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 23 * 60,
    max_value: 116 * 60,
    range_text: '23 - 116 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 116 * 60,
    max_value: null,
    range_text: '116 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 6 * 60,
    range_text: 'Up to 6 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 6 * 60,
    max_value: 96 * 60,
    range_text: '6 - 96 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 96 * 60,
    max_value: 248 * 60,
    range_text: '96 - 248 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 248 * 60,
    max_value: null,
    range_text: '248 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 40 * 60,
    range_text: 'Up to 40 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 40 * 60,
    max_value: 198 * 60,
    range_text: '40 - 198 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 198 * 60,
    max_value: 420 * 60,
    range_text: '198 - 420 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 420 * 60,
    max_value: null,
    range_text: '420 hours or more'
  }]
}, _metricNames$TIME_TO_3[BENCHMARK_ORG_SIZE_KEYS.enterprise] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 44 * 60,
    range_text: 'Up to 44 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 44 * 60,
    max_value: 115 * 60,
    range_text: '44 - 115 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 115 * 60,
    max_value: 193 * 60,
    range_text: '115 - 193 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 193 * 60,
    max_value: null,
    range_text: '193 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 89,
    range_text: 'Up to 89 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 89,
    max_value: 45 * 60,
    range_text: '89 minutes - 45 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 45 * 60,
    max_value: 144 * 60,
    range_text: '45 - 144 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 144 * 60,
    max_value: null,
    range_text: '144 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 23 * 60,
    range_text: 'Up to 23 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 23 * 60,
    max_value: 166 * 60,
    range_text: '23 - 166 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 166 * 60,
    max_value: 300 * 60,
    range_text: '166 - 300 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 300 * 60,
    max_value: null,
    range_text: '300 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 103 * 60,
    range_text: 'Up to 103 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 103 * 60,
    max_value: 296 * 60,
    range_text: '103 - 296 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 296 * 60,
    max_value: 483 * 60,
    range_text: '296 - 483 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 483 * 60,
    max_value: null,
    range_text: '483 hours or more'
  }]
}, _metricNames$TIME_TO_3[BENCHMARK_ORG_SIZE_KEYS.scale_up] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 29 * 60,
    range_text: 'Up to 29 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 29 * 60,
    max_value: 88 * 60,
    range_text: '29 - 88 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 88 * 60,
    max_value: 166 * 60,
    range_text: '88 - 166 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 166 * 60,
    max_value: null,
    range_text: '166 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 86,
    range_text: 'Up to 86 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 86,
    max_value: 24 * 60,
    range_text: '86 minutes - 24 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 24 * 60,
    max_value: 120 * 60,
    range_text: '24 - 120 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 120 * 60,
    max_value: null,
    range_text: '120 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 16 * 60,
    range_text: 'Up to 16 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 16 * 60,
    max_value: 104 * 60,
    range_text: '16 - 104 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 104 * 60,
    max_value: 265 * 60,
    range_text: '104 - 265 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 265 * 60,
    max_value: null,
    range_text: '265 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 67 * 60,
    range_text: 'Up to 67 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 67 * 60,
    max_value: 219 * 60,
    range_text: '67 - 219 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 219 * 60,
    max_value: 435 * 60,
    range_text: '219 - 435 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 435 * 60,
    max_value: null,
    range_text: '435 hours or more'
  }]
}, _metricNames$TIME_TO_3[BENCHMARK_ORG_SIZE_KEYS.startup] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 19 * 60,
    range_text: 'Up to 19 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 19 * 60,
    max_value: 76 * 60,
    range_text: '19 - 76 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 76 * 60,
    max_value: 161 * 60,
    range_text: '76 - 161 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 161 * 60,
    max_value: null,
    range_text: '161 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 48,
    range_text: 'Up to 48 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 48,
    max_value: 23 * 60,
    range_text: '48 minutes - 23 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 23 * 60,
    max_value: 110 * 60,
    range_text: '23 - 110 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 110 * 60,
    max_value: null,
    range_text: '110 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 5 * 60,
    range_text: 'Up to 5 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 5 * 60,
    max_value: 96 * 60,
    range_text: '5 - 96 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 96 * 60,
    max_value: 245 * 60,
    range_text: '96 - 245 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 245 * 60,
    max_value: null,
    range_text: '245 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 31 * 60,
    range_text: 'Up to 31 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 31 * 60,
    max_value: 197 * 60,
    range_text: '31 - 197 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 197 * 60,
    max_value: 410 * 60,
    range_text: '197 - 410 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 410 * 60,
    max_value: null,
    range_text: '410 hours or more'
  }]
}, _metricNames$TIME_TO_3), _ORG_SIZE_METRICS_BEN[metricNames.BRANCH_TIME_TO_APPROVE] = (_metricNames$BRANCH_T = {
  unit: 'hours',
  scale: metricsScales.TIME,
  description: 'measures the time from the first comment on a pull request to when the PR gets final approve.'
}, _metricNames$BRANCH_T[BENCHMARK_ORG_SIZE_KEYS.all] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 15 * 60,
    range_text: 'Up to 15 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 15 * 60,
    max_value: 28 * 60,
    range_text: '15 - 28 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 28 * 60,
    max_value: 45 * 60,
    range_text: '28 - 45 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 45 * 60,
    max_value: null,
    range_text: '45 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 1 * 60,
    range_text: 'Up to 1 hour'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 1 * 60,
    max_value: 4 * 60,
    range_text: '1 - 4 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 4 * 60,
    max_value: 6 * 60,
    range_text: '4 - 6 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 6 * 60,
    max_value: null,
    range_text: '6 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 10 * 60,
    range_text: 'Up to 10 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 10 * 60,
    max_value: 23 * 60,
    range_text: '10 - 23 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 23 * 60,
    max_value: 41 * 60,
    range_text: '23 - 41 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 41 * 60,
    max_value: null,
    range_text: '41 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 31 * 60,
    range_text: 'Up to 31 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 31 * 60,
    max_value: 74 * 60,
    range_text: '31 - 74 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 74 * 60,
    max_value: 119 * 60,
    range_text: '74 - 119 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 119 * 60,
    max_value: null,
    range_text: '119 hours or more'
  }]
}, _metricNames$BRANCH_T[BENCHMARK_ORG_SIZE_KEYS.enterprise] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 15 * 60,
    range_text: 'Up to 15 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 15 * 60,
    max_value: 29 * 60,
    range_text: '15 - 29 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 29 * 60,
    max_value: 45 * 60,
    range_text: '29 - 45 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 45 * 60,
    max_value: null,
    range_text: '45 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 45,
    range_text: 'Up to 45 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 45,
    max_value: 3 * 60,
    range_text: '45 - 120 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 3 * 60,
    max_value: 6 * 60,
    range_text: '3 - 6 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 6 * 60,
    max_value: null,
    range_text: '6 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 10 * 60,
    range_text: 'Up to 10 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 10 * 60,
    max_value: 23 * 60,
    range_text: '10 - 23 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 23 * 60,
    max_value: 32 * 60,
    range_text: '23 - 32 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 32 * 60,
    max_value: null,
    range_text: '32 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 30 * 60,
    range_text: 'Up to 30 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 30 * 60,
    max_value: 75 * 60,
    range_text: '30 - 75 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 75 * 60,
    max_value: 117 * 60,
    range_text: '75 - 117 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 117 * 60,
    max_value: null,
    range_text: '117 hours or more'
  }]
}, _metricNames$BRANCH_T[BENCHMARK_ORG_SIZE_KEYS.scale_up] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 18 * 60,
    range_text: 'Up to 18 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 18 * 60,
    max_value: 32 * 60,
    range_text: '18 - 32 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 32 * 60,
    max_value: 49 * 60,
    range_text: '32 - 49 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 49 * 60,
    max_value: null,
    range_text: '49 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 1 * 60,
    range_text: 'Up to 1 hour'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 1 * 60,
    max_value: 4 * 60,
    range_text: '1 - 4 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 4 * 60,
    max_value: 6 * 60,
    range_text: '4 - 6 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 6 * 60,
    max_value: null,
    range_text: '6 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 15 * 60,
    range_text: 'Up to 15 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 15 * 60,
    max_value: 24 * 60,
    range_text: '15 - 24 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 24 * 60,
    max_value: 44 * 60,
    range_text: '24 - 44 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 44 * 60,
    max_value: null,
    range_text: '44 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 47 * 60,
    range_text: 'Up to 47 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 47 * 60,
    max_value: 85 * 60,
    range_text: '47 - 85 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 85 * 60,
    max_value: 123 * 60,
    range_text: '85 - 123 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 123 * 60,
    max_value: null,
    range_text: '123 hours or more'
  }]
}, _metricNames$BRANCH_T[BENCHMARK_ORG_SIZE_KEYS.startup] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 16 * 60,
    range_text: 'Up to 16 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 16 * 60,
    max_value: 27 * 60,
    range_text: '16 - 27 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 27 * 60,
    max_value: 44 * 60,
    range_text: '27 - 44 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 44 * 60,
    max_value: null,
    range_text: '44 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 65,
    range_text: 'Up to 65 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 65,
    max_value: 4 * 60,
    range_text: '65 minutes - 4 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 4 * 60,
    max_value: 6 * 60,
    range_text: '4 - 6 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 6 * 60,
    max_value: null,
    range_text: '6 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 12 * 60,
    range_text: 'Up to 12 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 12 * 60,
    max_value: 22 * 60,
    range_text: '12 - 22 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 22 * 60,
    max_value: 39 * 60,
    range_text: '22 - 39 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 39 * 60,
    max_value: null,
    range_text: '39 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 34 * 60,
    range_text: 'Up to 34 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 34 * 60,
    max_value: 72 * 60,
    range_text: '34 - 72 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 72 * 60,
    max_value: 118 * 60,
    range_text: '72 - 118 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 118 * 60,
    max_value: null,
    range_text: '118 hours or more'
  }]
}, _metricNames$BRANCH_T), _ORG_SIZE_METRICS_BEN[metricNames.BRANCH_TIME_TO_MERGE] = (_metricNames$BRANCH_T2 = {
  unit: 'hours',
  scale: metricsScales.TIME,
  description: "measures the time from final approval to when the PR is merged."
}, _metricNames$BRANCH_T2[BENCHMARK_ORG_SIZE_KEYS.all] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 7 * 60,
    range_text: 'Up to 7 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 7 * 60,
    max_value: 14 * 60,
    range_text: '7 - 14 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 14 * 60,
    max_value: 24 * 60,
    range_text: '14 - 24 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 24 * 60,
    max_value: null,
    range_text: '24 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 13,
    range_text: 'Up to 13 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 13,
    max_value: 31,
    range_text: '13 - 31 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 31,
    max_value: 2 * 60,
    range_text: '31 minutes - 2 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 2 * 60,
    max_value: null,
    range_text: '2 hour or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 2 * 60,
    range_text: 'Up to 2 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 2 * 60,
    max_value: 5 * 60,
    range_text: '2 - 5 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 5 * 60,
    max_value: 17 * 60,
    range_text: '5 - 17 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 17 * 60,
    max_value: null,
    range_text: '17 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 16 * 60,
    range_text: 'Up to 16 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 16 * 60,
    max_value: 24 * 60,
    range_text: '16 - 24 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 24 * 60,
    max_value: 64 * 60,
    range_text: '24 - 64 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 64 * 60,
    max_value: null,
    range_text: '64 hours or more'
  }]
}, _metricNames$BRANCH_T2[BENCHMARK_ORG_SIZE_KEYS.enterprise] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 7 * 60,
    range_text: 'Up to 7 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 7 * 60,
    max_value: 16 * 60,
    range_text: '7 - 16 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 16 * 60,
    max_value: 24 * 60,
    range_text: '16 - 24 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 24 * 60,
    max_value: null,
    range_text: '24 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 13,
    range_text: 'Up to 13 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 13,
    max_value: 28,
    range_text: '13 - 28 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 28,
    max_value: 1 * 60,
    range_text: '28 - 60 minutes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 1 * 60,
    max_value: null,
    range_text: '1 hour or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 65,
    range_text: 'Up to 65 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 65,
    max_value: 5 * 60,
    range_text: '65 minutes - 5 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 5 * 60,
    max_value: 14 * 60,
    range_text: '5 - 14 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 14 * 60,
    max_value: null,
    range_text: '14 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 17 * 60,
    range_text: 'Up to 17 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 17 * 60,
    max_value: 25 * 60,
    range_text: '17 - 25 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 25 * 60,
    max_value: 57 * 60,
    range_text: '25 - 57 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 57 * 60,
    max_value: null,
    range_text: '57 hours or more'
  }]
}, _metricNames$BRANCH_T2[BENCHMARK_ORG_SIZE_KEYS.scale_up] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 8 * 60,
    range_text: 'Up to 8 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 8 * 60,
    max_value: 18 * 60,
    range_text: '8 - 18 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 18 * 60,
    max_value: 29 * 60,
    range_text: '18 - 29 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 29 * 60,
    max_value: null,
    range_text: '29 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 14,
    range_text: 'Up to 14 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 14,
    max_value: 34,
    range_text: '14 - 34 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 34,
    max_value: 72,
    range_text: '34 - 72 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 72,
    max_value: null,
    range_text: '72 hours or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 75,
    range_text: 'Up to 75 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 75,
    max_value: 5 * 60,
    range_text: '75 minutes - 5 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 5 * 60,
    max_value: 18 * 60,
    range_text: '5 - 18 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 18 * 60,
    max_value: null,
    range_text: '18 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 17 * 60,
    range_text: 'Up to 17 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 17 * 60,
    max_value: 27 * 60,
    range_text: '17 - 27 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 27 * 60,
    max_value: 70 * 60,
    range_text: '27 - 70 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 70 * 60,
    max_value: null,
    range_text: '70 hours or more'
  }]
}, _metricNames$BRANCH_T2[BENCHMARK_ORG_SIZE_KEYS.startup] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 8 * 60,
    range_text: 'Up to 8 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 8 * 60,
    max_value: 14 * 60,
    range_text: '8 - 14 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 14 * 60,
    max_value: 25 * 60,
    range_text: '14 - 25 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 25 * 60,
    max_value: null,
    range_text: '25 hours or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 14,
    range_text: 'Up to 14 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 14,
    max_value: 31,
    range_text: '14 - 31 minutes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 31,
    max_value: 70,
    range_text: '31 - 70 minutes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 70,
    max_value: null,
    range_text: '70 minutes or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 77,
    range_text: 'Up to 77 minutes'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 77,
    max_value: 4 * 60,
    range_text: '77 minutes - 4 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 4 * 60,
    max_value: 17 * 60,
    range_text: '4 - 17 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 17 * 60,
    max_value: null,
    range_text: '17 hours or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 16 * 60,
    range_text: 'Up to 16 hours'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 16 * 60,
    max_value: 24 * 60,
    range_text: '16 - 24 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 24 * 60,
    max_value: 66 * 60,
    range_text: '24 - 66 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 66 * 60,
    max_value: null,
    range_text: '66 hours or more'
  }]
}, _metricNames$BRANCH_T2), _ORG_SIZE_METRICS_BEN[metricNames.PR_MATURITY_RATIO] = (_metricNames$PR_MATUR = {
  unit: '%',
  scale: metricsScales.PERCENTAGE,
  description: "measures the ratio between the total changes added to a PR branch after the PR was published and the total changes in the PR."
}, _metricNames$PR_MATUR[BENCHMARK_ORG_SIZE_KEYS.all] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: 91,
    max_value: null,
    range_text: '91% or more'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 84,
    max_value: 91,
    range_text: '84% - 91%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 77,
    max_value: 84,
    range_text: '77% - 84%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: null,
    max_value: 77,
    range_text: 'less than 77%'
  }]
}, _metricNames$PR_MATUR[BENCHMARK_ORG_SIZE_KEYS.enterprise] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: 92,
    max_value: null,
    range_text: '92% or more'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 87,
    max_value: 92,
    range_text: '87% - 92%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 80,
    max_value: 87,
    range_text: '80% - 87%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: null,
    max_value: 80,
    range_text: 'less than 80%'
  }]
}, _metricNames$PR_MATUR[BENCHMARK_ORG_SIZE_KEYS.scale_up] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: 90,
    max_value: null,
    range_text: '90% or more'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 83,
    max_value: 90,
    range_text: '83% - 90%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 76,
    max_value: 83,
    range_text: '76% - 82%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: null,
    max_value: 76,
    range_text: 'less than 76%'
  }]
}, _metricNames$PR_MATUR[BENCHMARK_ORG_SIZE_KEYS.startup] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: 91,
    max_value: null,
    range_text: '91% or more'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 84,
    max_value: 91,
    range_text: '84% - 91%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 77,
    max_value: 84,
    range_text: '77% - 84%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: null,
    max_value: 77,
    range_text: 'less than 77%'
  }]
}, _metricNames$PR_MATUR), _ORG_SIZE_METRICS_BEN[metricNames.PM_MTTR] = (_metricNames$PM_MTTR = {
  unit: 'hours',
  scale: metricsScales.TIME,
  description: "measures the average time it takes to restore from a failure of the system or one of its components. LinearB calculates this metric based on the time a \"production bug\" spends in the \"in progress\" state."
}, _metricNames$PM_MTTR[BENCHMARK_ORG_SIZE_KEYS.all] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 6 * 60,
    range_text: '6 hours or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 6 * 60,
    max_value: 12 * 60,
    range_text: '6 - 12 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 12 * 60,
    max_value: 30 * 60,
    range_text: '12 - 30 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 30 * 60,
    max_value: null,
    range_text: '30 hours or more'
  }]
}, _metricNames$PM_MTTR[BENCHMARK_ORG_SIZE_KEYS.enterprise] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 6 * 60,
    range_text: '6 hours or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 6 * 60,
    max_value: 13 * 60,
    range_text: '6 - 13 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 13 * 60,
    max_value: 50 * 60,
    range_text: '13 - 50 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 50 * 60,
    max_value: null,
    range_text: '50 hours or more'
  }]
}, _metricNames$PM_MTTR[BENCHMARK_ORG_SIZE_KEYS.scale_up] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 8 * 60,
    range_text: '8 hours or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 8 * 60,
    max_value: 13 * 60,
    range_text: '8 - 13 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 13 * 60,
    max_value: 35 * 60,
    range_text: '13 - 35 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 35 * 60,
    max_value: null,
    range_text: '35 hours or more'
  }]
}, _metricNames$PM_MTTR[BENCHMARK_ORG_SIZE_KEYS.startup] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 6 * 60,
    range_text: '6 hours or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 6 * 60,
    max_value: 12 * 60,
    range_text: '6 - 12 hours'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 12 * 60,
    max_value: 26 * 60,
    range_text: '12 - 26 hours'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 26 * 60,
    max_value: null,
    range_text: '26 hours or more'
  }]
}, _metricNames$PM_MTTR), _ORG_SIZE_METRICS_BEN[metricNames.PM_CFR] = (_metricNames$PM_CFR = {
  unit: '%',
  scale: metricsScales.PERCENTAGE,
  description: "measures the percentage of deployments causing a failure in production. LinearB calculates this metric based on the number of \"production incidents\" defined in your project management tool divided by the number of deployments."
}, _metricNames$PM_CFR[BENCHMARK_ORG_SIZE_KEYS.all] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 1,
    range_text: '1% or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 1,
    max_value: 5,
    range_text: '1% - 5%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 5,
    max_value: 23,
    range_text: '5% - 23%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 23,
    max_value: null,
    range_text: '23% or more'
  }]
}, _metricNames$PM_CFR[BENCHMARK_ORG_SIZE_KEYS.enterprise] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 1,
    range_text: '1% or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 1,
    max_value: 6,
    range_text: '1% - 6%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 6,
    max_value: 30,
    range_text: '6% - 30%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 30,
    max_value: null,
    range_text: '30% or more'
  }]
}, _metricNames$PM_CFR[BENCHMARK_ORG_SIZE_KEYS.scale_up] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 1,
    range_text: '1% or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 1,
    max_value: 4,
    range_text: '1% - 4%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 4,
    max_value: 15,
    range_text: '4% - 15%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 15,
    max_value: null,
    range_text: '15% or more'
  }]
}, _metricNames$PM_CFR[BENCHMARK_ORG_SIZE_KEYS.startup] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 1,
    range_text: '1% or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 1,
    max_value: 6,
    range_text: '1% - 6%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 6,
    max_value: 25,
    range_text: '6% - 25%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 25,
    max_value: null,
    range_text: '25% or more'
  }]
}, _metricNames$PM_CFR), _ORG_SIZE_METRICS_BEN[metricNames.REWORK] = (_metricNames$REWORK = {
  unit: '%',
  scale: metricsScales.PERCENTAGE,
  description: "measures the amount of changes made to code that is less than 21 days old. High rework rates signal code churn and is a leading indicator of quality issues"
}, _metricNames$REWORK[BENCHMARK_ORG_SIZE_KEYS.all] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 3,
    range_text: '3% or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 3,
    max_value: 6,
    range_text: '3% - 6%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 6,
    max_value: 7,
    range_text: '6% - 7%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 7,
    max_value: null,
    range_text: '7% or more'
  }]
}, _metricNames$REWORK[BENCHMARK_ORG_SIZE_KEYS.enterprise] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 4,
    range_text: '4% or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 4,
    max_value: 6,
    range_text: '4% - 6%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 6,
    max_value: 7,
    range_text: '6% - 7%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 7,
    max_value: null,
    range_text: '7% or more'
  }]
}, _metricNames$REWORK[BENCHMARK_ORG_SIZE_KEYS.scale_up] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 4,
    range_text: '4% or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 4,
    max_value: 6,
    range_text: '4% - 6%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 6,
    max_value: 7,
    range_text: '6% - 7%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 7,
    max_value: null,
    range_text: '7% or more'
  }]
}, _metricNames$REWORK[BENCHMARK_ORG_SIZE_KEYS.startup] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 3,
    range_text: '3% or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 3,
    max_value: 6,
    range_text: '3% - 6%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 6,
    max_value: 7,
    range_text: '6% - 7%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 7,
    max_value: null,
    range_text: '7% or more'
  }]
}, _metricNames$REWORK), _ORG_SIZE_METRICS_BEN[metricNames.REFACTOR] = (_metricNames$REFACTOR = {
  unit: '%',
  scale: metricsScales.PERCENTAGE,
  description: "measures the amount of changes made to code that is more than 21 days old. A large amount of refactoring in a single release is not recommended, as these changes have a higher probability of harming existing functionality."
}, _metricNames$REFACTOR[BENCHMARK_ORG_SIZE_KEYS.all] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 11,
    range_text: '11% or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 11,
    max_value: 17,
    range_text: '11% - 17%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 17,
    max_value: 20,
    range_text: '17% - 20%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 20,
    max_value: null,
    range_text: '20% or more'
  }]
}, _metricNames$REFACTOR[BENCHMARK_ORG_SIZE_KEYS.enterprise] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 11,
    range_text: '11% or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 11,
    max_value: 16,
    range_text: '11% - 16%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 16,
    max_value: 20,
    range_text: '16% - 20%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 20,
    max_value: null,
    range_text: '20% or more'
  }]
}, _metricNames$REFACTOR[BENCHMARK_ORG_SIZE_KEYS.scale_up] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 12,
    range_text: '12% or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 12,
    max_value: 17,
    range_text: '12% - 17%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 17,
    max_value: 21,
    range_text: '17% - 21%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 21,
    max_value: null,
    range_text: '21% or more'
  }]
}, _metricNames$REFACTOR[BENCHMARK_ORG_SIZE_KEYS.startup] = {
  "default": [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 11,
    range_text: '11% or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 11,
    max_value: 17,
    range_text: '11% - 17%'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 17,
    max_value: 21,
    range_text: '17% - 21%'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 21,
    max_value: null,
    range_text: '21% or more'
  }]
}, _metricNames$REFACTOR), _ORG_SIZE_METRICS_BEN[metricNames.PR_SIZE] = (_metricNames$PR_SIZE = {
  unit: 'code changes',
  unitDescription: 'code changes',
  scale: metricsScales.CODE_CHANGES,
  description: "measures the number of code lines modified in a pull request. Smaller pull requests are easier to review, safer to merge, correlate to lower Cycle Time."
}, _metricNames$PR_SIZE[BENCHMARK_ORG_SIZE_KEYS.all] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 194,
    range_text: '194 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 194,
    max_value: 340,
    range_text: '194 - 340 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 340,
    max_value: 661,
    range_text: '340 - 661 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 661,
    max_value: null,
    range_text: '661 code changes or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 18,
    range_text: '18 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 18,
    max_value: 31,
    range_text: '18 - 31 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 31,
    max_value: 47,
    range_text: '31 - 47 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 47,
    max_value: null,
    range_text: '47 code changes or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 85,
    range_text: '85 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 85,
    max_value: 139,
    range_text: '85 - 139 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 139,
    max_value: 209,
    range_text: '139 - 209 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 209,
    max_value: null,
    range_text: '209 code changes or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 310,
    range_text: '310 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 310,
    max_value: 471,
    range_text: '310 - 471 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 471,
    max_value: 717,
    range_text: '471 - 717 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 717,
    max_value: null,
    range_text: '717 code changes or more'
  }]
}, _metricNames$PR_SIZE[BENCHMARK_ORG_SIZE_KEYS.enterprise] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 227,
    range_text: '227 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 227,
    max_value: 405,
    range_text: '227 - 405 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 405,
    max_value: 752,
    range_text: '405 - 752 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 752,
    max_value: null,
    range_text: '752 code changes or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 16,
    range_text: '16 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 16,
    max_value: 29,
    range_text: '16 - 29 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 29,
    max_value: 43,
    range_text: '29 - 43 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 43,
    max_value: null,
    range_text: '43 code changes or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 91,
    range_text: '91 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 91,
    max_value: 139,
    range_text: '91 - 139 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 139,
    max_value: 208,
    range_text: '139 - 208 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 208,
    max_value: null,
    range_text: '208 code changes or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 344,
    range_text: '344 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 344,
    max_value: 517,
    range_text: '344 - 517 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 517,
    max_value: 732,
    range_text: '517 - 732 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 732,
    max_value: null,
    range_text: '732 code changes or more'
  }]
}, _metricNames$PR_SIZE[BENCHMARK_ORG_SIZE_KEYS.scale_up] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 205,
    range_text: '205 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 205,
    max_value: 362,
    range_text: '205 - 362 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 362,
    max_value: 708,
    range_text: '362 - 708 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 708,
    max_value: null,
    range_text: '708 code changes or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 16,
    range_text: '16 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 16,
    max_value: 30,
    range_text: '16 - 30 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 30,
    max_value: 43,
    range_text: '30 - 43 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 43,
    max_value: null,
    range_text: '43 code changes or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 89,
    range_text: '89 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 89,
    max_value: 136,
    range_text: '89 - 136 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 136,
    max_value: 197,
    range_text: '136 - 197 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 197,
    max_value: null,
    range_text: '197 code changes or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 329,
    range_text: '329 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 329,
    max_value: 471,
    range_text: '329 - 471 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 471,
    max_value: 694,
    range_text: '471 - 694 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 694,
    max_value: null,
    range_text: '694 code changes or more'
  }]
}, _metricNames$PR_SIZE[BENCHMARK_ORG_SIZE_KEYS.startup] = {
  avg: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 197,
    range_text: '197 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 197,
    max_value: 340,
    range_text: '197 - 340 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 340,
    max_value: 651,
    range_text: '340 - 651 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 651,
    max_value: null,
    range_text: '651 code changes or more'
  }],
  p50: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 20,
    range_text: '20 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 20,
    max_value: 32,
    range_text: '20 - 32 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 32,
    max_value: 48,
    range_text: '32 - 48 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 48,
    max_value: null,
    range_text: '48 code changes or more'
  }],
  p75: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 90,
    range_text: '90 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 90,
    max_value: 143,
    range_text: '90 - 143 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 143,
    max_value: 214,
    range_text: '143 - 214 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 214,
    max_value: null,
    range_text: '214 code changes or more'
  }],
  p90: [{
    title: 'ELITE',
    icon: 'benchmarkElite',
    icon_color: 'malachiteB',
    min_value: null,
    max_value: 316,
    range_text: '316 code changes or less'
  }, {
    title: 'STRONG',
    icon: 'benchmarkStrong',
    icon_color: 'cerulean',
    min_value: 316,
    max_value: 476,
    range_text: '316 - 476 code changes'
  }, {
    title: 'FAIR',
    icon: 'benchmarkFair',
    icon_color: 'neonCarrot',
    min_value: 476,
    max_value: 727,
    range_text: '476 - 727 code changes'
  }, {
    title: 'NEEDS FOCUS',
    icon: 'benchmarkNeedsFocus',
    icon_color: 'radicalRed',
    min_value: 727,
    max_value: null,
    range_text: '727 code changes or more'
  }]
}, _metricNames$PR_SIZE), _ORG_SIZE_METRICS_BEN);
var ORG_SIZE_CYCLE_TIME_METRICS_BENCHMARKS_VALUES = (_ORG_SIZE_CYCLE_TIME_ = {}, _ORG_SIZE_CYCLE_TIME_[metricNames.TIME_TO_PR] = (_metricNames$TIME_TO_4 = {}, _metricNames$TIME_TO_4[BENCHMARK_ORG_SIZE_KEYS.all] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 19 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 35 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 66 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 66 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 4;
    },
    goodCondition: function goodCondition(value) {
      return value < 8;
    },
    fairCondition: function fairCondition(value) {
      return value < 20;
    },
    poorCondition: function poorCondition(value) {
      return value >= 20;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 1 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 5 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 23 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 23 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 26 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 73 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 146 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 146 * 60;
    }
  }
}, _metricNames$TIME_TO_4[BENCHMARK_ORG_SIZE_KEYS.enterprise] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 28 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 53 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 98 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 98 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 4;
    },
    goodCondition: function goodCondition(value) {
      return value < 9;
    },
    fairCondition: function fairCondition(value) {
      return value < 26;
    },
    poorCondition: function poorCondition(value) {
      return value >= 26;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 2 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 10 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 28 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 28 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 48 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 115 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 195 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 195 * 60;
    }
  }
}, _metricNames$TIME_TO_4[BENCHMARK_ORG_SIZE_KEYS.scale_up] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 24 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 44 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 88 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 88 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 4;
    },
    goodCondition: function goodCondition(value) {
      return value < 9;
    },
    fairCondition: function fairCondition(value) {
      return value < 27;
    },
    poorCondition: function poorCondition(value) {
      return value > 27;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 3 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 7 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 28 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 28 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 42 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 94 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 173 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 173 * 60;
    }
  }
}, _metricNames$TIME_TO_4[BENCHMARK_ORG_SIZE_KEYS.startup] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 18 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 33 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 61 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 61 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 4;
    },
    goodCondition: function goodCondition(value) {
      return value < 9;
    },
    fairCondition: function fairCondition(value) {
      return value < 20;
    },
    poorCondition: function poorCondition(value) {
      return value >= 20;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 1 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 5 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 22 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 22 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 26 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 71 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 142 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 142 * 60;
    }
  }
}, _metricNames$TIME_TO_4), _ORG_SIZE_CYCLE_TIME_[metricNames.TIME_TO_REVIEW] = (_metricNames$TIME_TO_5 = {}, _metricNames$TIME_TO_5[BENCHMARK_ORG_SIZE_KEYS.all] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 8 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 15 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 23 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 23 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 12;
    },
    goodCondition: function goodCondition(value) {
      return value < 27;
    },
    fairCondition: function fairCondition(value) {
      return value < 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 60;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 75;
    },
    goodCondition: function goodCondition(value) {
      return value < 6 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 16 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 16 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 16 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 26 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 63 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 63 * 60;
    }
  }
}, _metricNames$TIME_TO_5[BENCHMARK_ORG_SIZE_KEYS.enterprise] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 9 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 15 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 22 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 22 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 11;
    },
    goodCondition: function goodCondition(value) {
      return value < 22;
    },
    fairCondition: function fairCondition(value) {
      return value < 47;
    },
    poorCondition: function poorCondition(value) {
      return value >= 47;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 78;
    },
    goodCondition: function goodCondition(value) {
      return value < 5 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 15 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 15 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 17 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 25 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 57 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 57 * 60;
    }
  }
}, _metricNames$TIME_TO_5[BENCHMARK_ORG_SIZE_KEYS.scale_up] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 9 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 17 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 25 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 25 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 11;
    },
    goodCondition: function goodCondition(value) {
      return value < 31;
    },
    fairCondition: function fairCondition(value) {
      return value < 57;
    },
    poorCondition: function poorCondition(value) {
      return value > 57;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 65;
    },
    goodCondition: function goodCondition(value) {
      return value < 6 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 17 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 17 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 18 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 27 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 66 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 66 * 60;
    }
  }
}, _metricNames$TIME_TO_5[BENCHMARK_ORG_SIZE_KEYS.startup] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 8 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 15 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 23 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 23 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 14;
    },
    goodCondition: function goodCondition(value) {
      return value < 29;
    },
    fairCondition: function fairCondition(value) {
      return value < 66;
    },
    poorCondition: function poorCondition(value) {
      return value >= 66;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 88;
    },
    goodCondition: function goodCondition(value) {
      return value < 6 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 17 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 17 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 17 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 26 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 64 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 64 * 60;
    }
  }
}, _metricNames$TIME_TO_5), _ORG_SIZE_CYCLE_TIME_[metricNames.REVIEW_TIME] = (_metricNames$REVIEW_T2 = {}, _metricNames$REVIEW_T2[BENCHMARK_ORG_SIZE_KEYS.all] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 12 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 22 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 37 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 37 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 20;
    },
    goodCondition: function goodCondition(value) {
      return value < 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 3 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 3 * 60;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 3 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 14 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 24 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 24 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 21 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 51 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 96 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 96 * 60;
    }
  }
}, _metricNames$REVIEW_T2[BENCHMARK_ORG_SIZE_KEYS.enterprise] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 13 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 24 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 36 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 36 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 20;
    },
    goodCondition: function goodCondition(value) {
      return value < 45;
    },
    fairCondition: function fairCondition(value) {
      return value < 2 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 2 * 60;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 3 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 11 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 22 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 22 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 23 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 49 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 94 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 94 * 60;
    }
  }
}, _metricNames$REVIEW_T2[BENCHMARK_ORG_SIZE_KEYS.scale_up] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 14 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 26 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 41 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 41 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 21;
    },
    goodCondition: function goodCondition(value) {
      return value < 57;
    },
    fairCondition: function fairCondition(value) {
      return value < 3 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 3 * 60;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 3 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 18 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 25 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 25 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 24 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 69 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 100 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 100 * 60;
    }
  }
}, _metricNames$REVIEW_T2[BENCHMARK_ORG_SIZE_KEYS.startup] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 12 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 21 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 36 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 36 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 23;
    },
    goodCondition: function goodCondition(value) {
      return value < 54;
    },
    fairCondition: function fairCondition(value) {
      return value < 3 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 3 * 60;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 3 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 14 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 24 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 24 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 22 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 50 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 95 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 95 * 60;
    }
  }
}, _metricNames$REVIEW_T2), _ORG_SIZE_CYCLE_TIME_[metricNames.TIME_TO_PROD] = (_metricNames$TIME_TO_6 = {}, _metricNames$TIME_TO_6[BENCHMARK_ORG_SIZE_KEYS.all] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 21 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 77 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 163 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 163 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 50;
    },
    goodCondition: function goodCondition(value) {
      return value < 23 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 116 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 116 * 60;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 6 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 96 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 248 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 248 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 40 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 198 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 420 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 420 * 60;
    }
  }
}, _metricNames$TIME_TO_6[BENCHMARK_ORG_SIZE_KEYS.enterprise] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 44 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 115 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 193 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 193 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 89;
    },
    goodCondition: function goodCondition(value) {
      return value < 45 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 144 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 144 * 60;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 23 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 166 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 300 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 300 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 103 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 296 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 483 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 483 * 60;
    }
  }
}, _metricNames$TIME_TO_6[BENCHMARK_ORG_SIZE_KEYS.scale_up] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 29 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 88 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 166 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 166 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 86;
    },
    goodCondition: function goodCondition(value) {
      return value < 24 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 120 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value > 120 * 60;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 16 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 104 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 265 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 265 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 67 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 219 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 435 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 435 * 60;
    }
  }
}, _metricNames$TIME_TO_6[BENCHMARK_ORG_SIZE_KEYS.startup] = {
  avg: {
    eliteCondition: function eliteCondition(value) {
      return value < 19 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 76 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 161 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 161 * 60;
    }
  },
  p50: {
    eliteCondition: function eliteCondition(value) {
      return value < 48;
    },
    goodCondition: function goodCondition(value) {
      return value < 23 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 110 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 110 * 60;
    }
  },
  p75: {
    eliteCondition: function eliteCondition(value) {
      return value < 5 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 96 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 245 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 245 * 60;
    }
  },
  p90: {
    eliteCondition: function eliteCondition(value) {
      return value < 31 * 60;
    },
    goodCondition: function goodCondition(value) {
      return value < 197 * 60;
    },
    fairCondition: function fairCondition(value) {
      return value < 410 * 60;
    },
    poorCondition: function poorCondition(value) {
      return value >= 410 * 60;
    }
  }
}, _metricNames$TIME_TO_6), _ORG_SIZE_CYCLE_TIME_);

var METRICS_CALCULATION_STRATEGY_LABEL = {
  p50: 'median',
  p75: '75th percentile',
  avg: 'average',
  p90: '90th percentile'
};

var ARTICLE_IDS = {
  CYCLE_TIME: 'v9pckvmkbj',
  POINT_IN_HISTORY: 'kv6i92sezl',
  CONNECT_JIRA_BOARD: '2mc7kl8sot',
  ONBOARDING_TROUBLESHOOT: 'jnnhljaqyu',
  INITIAL_TEAM: 'i6z0gcvril',
  PULSE_NAMING: '80cg9o0dhu',
  WIP: 'a93cjbshlp',
  DONE_IN_ITERATION: 'fra4z93dex',
  CARRYOVER: 's6avo913wv',
  HIGH_RISK: '7mjk0k1rgm',
  HIGH_REWROK: 'h1kr5vx2fd',
  WORK_BREAKDOWN: 'tpxx3m8cwb',
  THROUGHPUT_METRICS: 'tpmxyz5ei7',
  REVIEW_DEPTH: 'v9s73q7d93',
  MERGED_WITHOUT_REVIEW: 's0jjewxoh9',
  PR_SIZE: 'x1620txj8m',
  BRANCH_STATE: '83dyr15yme',
  PR_STATE: 'oknqh6k7cn',
  CODE_CHANGES_RATE: 'fypuctwrek',
  DEPLOYMENT_FREQ: 'gm1zmtps8p',
  PR_OPEN_RATE: 'l0irnv33z7',
  UPDATED_IN_ITERATION: '3a56ox8pyl',
  MERGED_IN_ITERATION: 'x4448wfnyx',
  LIGHTNING_PR: '69f29yawrr',
  HIGH_INT_PR: 'zzjmzqx1ku',
  LONG_LIVING_PR: 'gvf7nqpyb3',
  REVIEW_REQUEST_HANGING: 'bg6c46ds1y',
  WHO_IS_ACTIVE: '9hdw53zd0n',
  NOTIFICATION_TYPES: '16zfs7qnli',
  CONNECT_PM: 'p0a1a6m12x',
  PM_CFR: 'bqkxf4rjom',
  PM_MTTR: 'y6ul0o0vz0',
  ISSUES_PLANNED: '',
  ISSUES_PLANNED_STORY_POINTS: '',
  PR_MERGED_WITH_BASIC_OR_NO_REVIEW: 'o33iwr05u2',
  HIGH_RISK_WORK: '1rk0nrp4yd',
  HANGING_AND_LONG_REVIEWS: 'oyrgn1orkd',
  LARGE_PULL_REQUESTS: 'drons87w53',
  BRANCH_TIME_TO_APPROVE: 'pxbpvpa4x4',
  BRANCH_TIME_TO_MERGE: 'hm13cv22b6',
  ACTIVE_DAYS: 'hp6tf3wzmt',
  DONE_BRANCHES: 'n8pacj3gpq',
  ACTIVE_BRANCHES: '3oscrws8cy',
  DEV_COACHING: {
    KNOWLEDGE_AREAS: 'ayw67w2r3k',
    TOP_CODE_LANGUAGES: 'a15fbmts83',
    DEVELOPMENT_EXPERIENCE: 'y1fn773xjx',
    WELLNESS_WORKLOAD: 'qs1plysaat',
    DEVELOPER_METRICS: 'm8dzroiuc6'
  },
  CUSTOM_STAGES: 'z4jn2k1mdj',
  PR_MATURITY: '12bihr2x2s'
};

var _metricDisplayValues;
var metricDisplayValues = (_metricDisplayValues = {}, _metricDisplayValues[metricNames.TIME_TO_PR] = {
  displayName: 'Coding time',
  unitType: 'timespan',
  displayLabel: 'Coding time',
  description: 'Time from first commit to pull request creation',
  articleId: ARTICLE_IDS.CYCLE_TIME
}, _metricDisplayValues[metricNames.TIME_TO_REVIEW] = {
  displayName: 'Pickup time',
  displayLabel: 'Pickup time',
  unitType: 'timespan',
  articleId: ARTICLE_IDS.CYCLE_TIME
}, _metricDisplayValues[metricNames.TIME_TO_PROD] = {
  displayName: 'Time to deploy',
  displayLabel: 'Deploy time',
  unitType: 'timespan',
  articleId: ARTICLE_IDS.CYCLE_TIME
}, _metricDisplayValues[metricNames.REVIEW_TIME] = {
  displayName: 'Review time',
  displayLabel: 'Review time',
  unitType: 'timespan',
  articleId: ARTICLE_IDS.CYCLE_TIME
}, _metricDisplayValues[metricNames.ACTIVE_BRANCHES] = {
  displayName: 'Active branches',
  unitType: 'count',
  displayLabel: 'Active branches'
}, _metricDisplayValues[metricNames.DONE_BRANCHES] = {
  displayName: 'Done branches',
  unitType: 'count',
  displayLabel: 'Done branches'
}, _metricDisplayValues[metricNames.CYCLE_TIME] = {
  displayName: 'Cycle time',
  displayLabel: 'Cycle time',
  unitType: 'timespan',
  articleId: ARTICLE_IDS.CYCLE_TIME
}, _metricDisplayValues[metricNames.ACTIVE_DAYS] = {
  displayName: 'Active days',
  unitType: 'count',
  displayLabel: 'Active days'
}, _metricDisplayValues[metricNames.NEW_WORK] = {
  displayName: 'New code',
  unitType: 'percentage',
  displayLabel: 'New code',
  unitDescription: 'New code',
  articleId: ARTICLE_IDS.WORK_BREAKDOWN
}, _metricDisplayValues[metricNames.REWORK] = {
  displayName: 'Rework',
  unitType: 'percentage',
  displayLabel: 'Code changes',
  unitDescription: 'Rework code',
  articleId: ARTICLE_IDS.WORK_BREAKDOWN
}, _metricDisplayValues[metricNames.REFACTOR] = {
  displayName: 'Refactor',
  unitType: 'percentage',
  displayLabel: 'Code changes',
  unitDescription: 'Refactor code',
  articleId: ARTICLE_IDS.WORK_BREAKDOWN
}, _metricDisplayValues[metricNames.COMMIT_CODE_CHANGES] = {
  displayName: 'Code changes',
  unitType: 'count',
  displayLabel: 'Code changes',
  unitDescription: 'Code changes per',
  articleId: ARTICLE_IDS.THROUGHPUT_METRICS
}, _metricDisplayValues[metricNames.COMMIT_COUNT] = {
  displayName: 'Commits',
  unitType: 'count',
  displayLabel: 'commits',
  unitDescription: 'Commits per',
  articleId: ARTICLE_IDS.THROUGHPUT_METRICS
}, _metricDisplayValues[metricNames.REVIEWS] = {
  displayName: 'Reviews',
  unitType: 'count',
  displayLabel: 'Reviews',
  unitDescription: 'Reviews per',
  articleId: ARTICLE_IDS.THROUGHPUT_METRICS
}, _metricDisplayValues[metricNames.REVIEW_DEPTH] = {
  displayName: 'Review Depth',
  unitType: 'nonAvgCount',
  displayLabel: 'Comments per review',
  unitDescription: 'Comments per review',
  articleId: ARTICLE_IDS.REVIEW_DEPTH
}, _metricDisplayValues[metricNames.PR_NEW] = {
  displayName: 'PRs Opened',
  unitType: 'count',
  displayLabel: 'PRs',
  unitDescription: 'PRs per',
  articleId: ARTICLE_IDS.THROUGHPUT_METRICS
}, _metricDisplayValues[metricNames.PR_MERGED] = {
  displayName: 'PRs Merged',
  unitType: 'count',
  displayLabel: 'PRs',
  unitDescription: 'PRs per',
  articleId: ARTICLE_IDS.THROUGHPUT_METRICS
}, _metricDisplayValues[metricNames.PR_MERGED_WITHOUT_REVIEW] = {
  displayName: 'PRs merged without Review',
  unitType: 'count',
  displayLabel: 'PRs',
  unitDescription: 'PRs per',
  articleId: ARTICLE_IDS.MERGED_WITHOUT_REVIEW
}, _metricDisplayValues[metricNames.PR_SIZE] = {
  displayName: 'PR Size',
  unitType: 'nonAvgCount',
  displayLabel: 'Code changes',
  unitDescription: 'Code changes per PR',
  articleId: ARTICLE_IDS.PR_SIZE
}, _metricDisplayValues[metricNames.RELEASES_COUNT] = {
  displayName: 'Deployment Frequency',
  unitType: 'count',
  displayLabel: 'Deployment Frequency',
  unitDescription: 'Releases per',
  articleId: ARTICLE_IDS.THROUGHPUT_METRICS
}, _metricDisplayValues[metricNames.RELEASES_AVG] = {
  displayName: 'Avg releases',
  unitType: 'count',
  displayLabel: 'Avg releases'
}, _metricDisplayValues[metricNames.TOTAL_ACTIVITY] = {
  displayName: 'Total changes',
  unitType: 'count',
  displayLabel: 'Total changes',
  unitDescription: 'Total changes per',
  articleId: ARTICLE_IDS.THROUGHPUT_METRICS
}, _metricDisplayValues[metricNames.PM_MTTR] = {
  displayName: 'MTTR',
  unitType: 'timespan',
  displayLabel: 'MTTR',
  unitDescription: 'Mean time to restore',
  articleId: ARTICLE_IDS.PM_MTTR
}, _metricDisplayValues[metricNames.PM_CFR] = {
  displayName: 'CFR',
  unitType: 'percentage',
  displayLabel: 'CFR',
  unitDescription: 'Avg change failure rate',
  articleId: ARTICLE_IDS.PM_CFR
}, _metricDisplayValues[metricNames.BRANCH_TIME_TO_APPROVE] = {
  displayName: 'Time to approve',
  unitType: 'timespan',
  displayLabel: 'Time to approve',
  articleId: ARTICLE_IDS.BRANCH_TIME_TO_APPROVE
}, _metricDisplayValues[metricNames.BRANCH_TIME_TO_MERGE] = {
  displayName: 'Time to merge',
  unitType: 'timespan',
  displayLabel: 'Time to merge',
  articleId: ARTICLE_IDS.BRANCH_TIME_TO_MERGE
}, _metricDisplayValues[metricNames.PR_MATURITY_RATIO] = {
  displayName: 'PR Maturity',
  unitType: 'percentage',
  displayLabel: 'PR Maturity',
  unitDescription: 'Avg maturity ratio',
  articleId: ARTICLE_IDS.PR_MATURITY
}, _metricDisplayValues);

var INCIDENTS_SUPPORTED_METRICS = [metricNames.PM_MTTR, metricNames.PM_CFR];
var INCIDENTS_STRATEGIES = {
  REPORTED: 'reported',
  FILTERED_ISSUES: 'filtered_issues',
  USE_PARENT: 'use_parent'
};

var MEDIAN_METRICS = [metricNames.CYCLE_TIME, metricNames.TIME_TO_PR, metricNames.TIME_TO_REVIEW, metricNames.REVIEW_TIME, metricNames.TIME_TO_PROD, metricNames.PR_SIZE, metricNames.BRANCH_TIME_TO_APPROVE, metricNames.BRANCH_TIME_TO_MERGE, metricNames.BRANCH_TIME_TO_RELEASE, metricNames.PR_REVIEWER_TIME_TO_APPROVE, metricNames.PR_REVIEWER_TIME_TO_REVIEW, metricNames.SUM_OF_COMPONENTS_CYCLE_TIME];

var rollup;

(function (rollup) {
  rollup["1d"] = "1d";
  rollup["1w"] = "1w";
  rollup["1mo"] = "1mo";
  rollup["custom"] = "custom";
})(rollup || (rollup = {}));

var GROUP_BY_MAP = {
  TEAM: 'team',
  ORGANIZATION: 'organization',
  CONTRIBUTOR: 'contributor',
  CUSTOM_METRIC: 'custom_metric'
};
var aggKeyValues;

(function (aggKeyValues) {
  aggKeyValues["avg"] = "avg";
  aggKeyValues["sum"] = "sum";
  aggKeyValues["p50"] = "p50";
  aggKeyValues["p75"] = "p75";
  aggKeyValues["default"] = "default";
  aggKeyValues["issues"] = "issues";
  aggKeyValues["p90"] = "p90";
})(aggKeyValues || (aggKeyValues = {}));

var GRANULARITY = {
  AUTO: 'auto',
  DAYS: 'day',
  WEEKS: 'week',
  MONTHS: 'month',
  ITERATIONS: 'iteration'
};

var ISSUE_COUNT_CALCULATION_STRATEGY = 'count';
var STORY_POINTS_CALCULATION_STRATEGY = 'story_points';
var ISSUE_COUNT_METRIC_NAME = 'pm.issue.count';
var ISSUE_TRANSITION_METRIC_NAME = 'pm.issue.state_transition';
var PM_CALCULATION_STRATEGY = {
  ISSUE_COUNT: {
    name: 'Count issues',
    value: ISSUE_COUNT_CALCULATION_STRATEGY
  },
  STORY_POINTS: {
    name: 'Story points sum',
    value: STORY_POINTS_CALCULATION_STRATEGY
  }
};
var CUSTOM_PM_METRICS_TYPES = {
  ISSUE_COUNT: {
    name: 'Single State',
    value: ISSUE_COUNT_METRIC_NAME
  },
  ISSUE_TRANSITION: {
    name: 'Transition between 2 states',
    value: ISSUE_TRANSITION_METRIC_NAME
  }
};
var PM_METRICS_ISSUES_STATES = {
  NONE: 'none',
  CREATED: 'created',
  IN_PROGRESS: 'in-progress',
  DONE: 'done'
};
var MTTR_STRATEGY = {
  STATE_TRANSITION: 'state-transition',
  CUSTOM_FIELD_TRANSITION: 'custom-field-transition'
};
var CFR_INCIDENT_STRATEGY = {
  STATE: 'state',
  CUSTOM_FIELD: 'custom-field'
};

var V3_METRICS = /*#__PURE__*/[metricNames.PR_MERGED, metricNames.BRANCH_TIME_TO_MERGE, metricNames.BRANCH_TIME_TO_APPROVE, metricNames.PR_NEW, metricNames.REVIEW_DEPTH, metricNames.REVIEWS, metricNames.PR_MERGED_WITHOUT_REVIEW, metricNames.RELEASES_COUNT, metricNames.COMMIT_CODE_CHANGES, metricNames.COMMIT_COUNT, metricNames.NEW_WORK, metricNames.REWORK, metricNames.REFACTOR, metricNames.ACTIVE_DAYS, metricNames.PM_MTTR, metricNames.PM_CFR, metricNames.DONE_BRANCHES, metricNames.ACTIVE_BRANCHES, metricNames.BRANCH_TIME_TO_RELEASE].concat(MEDIAN_METRICS, /*#__PURE__*/Object.values(GOALS_METRIC_NAMES));
var PM_V3_METRICS = [metricNames.PM_ISSUE_COUNT, metricNames.PM_ISSUE_STATE_TRANSITION, metricNames.PM_ISSUE_STATE_CATEGORY_TRANSITION];

var SettingValues = {
  CFR_CONFIG: 'cfrConfig',
  ACTIVE_BRANCHES_DURATION: 'activeBranchesDuration',
  PM_IMPORT_STRATEGY: 'pmImportStrategy',
  METRICS_CALCULATION_STRATEGY: 'metricsCalculationStrategy',
  ITERATION_STRATEGY: 'iterationStrategy',
  DEFAULT_BOARD: 'defaultBoard',
  PERFORMANCE_ENABLED: 'performanceEnabled',
  MERGED_USERS_ENABLED: 'showMergedUsers',
  NEW_WORK_SMALL_TOP_RANGE: 'newWorkSmallTopRange',
  NEW_WORK_MEDIUM_TOP_RANGE: 'newWorkMediumTopRange',
  CODE_CHANGES_SMALL_TOP_RANGE: 'codeChangesSmallTopRange',
  CODE_CHANGES_MEDIUM_TOP_RANGE: 'codeChangesMediumTopRange',
  HIGH_RISK_THRESHOLDS: 'workAtRiskNotification',
  LONG_LIVING_THRESHOLDS: 'reviewRequestHangingNotification',
  SUPERFICIAL_REVIEW_THRESHOLDS: 'mergedWithBasicReviewNotification',
  MERGED_WITHOUT_REVIEW_THRESHOLDS: 'mergedWithoutReviewNotification',
  WORKING_DAYS: 'workingDays',
  DAILY_TIME: 'dailyTime',
  MTTR_CONFIG: 'mttrConfig',
  PULL_REQUESTS_LARGER_THAN: 'pullRequestsLargerThan',
  PULL_REQUESTS_OPEN_MORE_THAN: 'pullRequestsOpenMoreThan',
  UNLINKED_BRANCHES: 'unlinkedBranches',
  //TEAM_WIP: 'teamWip',
  WORK_AT_RISK_NOTIFICATION: 'workAtRiskNotification',
  MERGED_WITHOUT_REVIEW_NOTIFICATION: 'mergedWithoutReviewNotification',
  MERGED_WITH_BASIC_REVIEW_NOTIFICATION: 'mergedWithBasicReviewNotification',
  REVIEW_REQUEST_HANGING_NOTIFICATION: 'reviewRequestHangingNotification',
  REVIEW_TOO_LONG_NOTIFICATION: 'reviewTooLongNotification',
  DAILY_DIGEST_NOTIFICATION_THRESHOLDS: 'dailyDigestNotificationThresholds',
  HIDE_NON_WORKING_DAYS: 'hideNonWorkingDays',
  RELEASES_STRATEGY: 'releasesStrategy',
  INCIDENTS_STRATEGY: 'incidentsStrategy',
  RA_INPUTS: 'raInputs',
  RESOURCE_ALLOCATION_RECIPIENTS: 'resourceAllocationEmailRecipients',
  CODING_TIME_STRATEGY: 'codingTimeStrategy',
  ISSUE_IN_PROGRESS_TRANSITION_STRATEGY: 'issueInProgressTransitionStrategy',
  INVESTMENT_PROFILE_ITERATIONS: 'investmentProfileIterations',
  GROUP_DASHBOARD_METRICS_WIDGETS: 'groupDashboardMetricsWidgets',
  GROUP_DASHBOARD_METRICS_TABLE_COLS: 'groupDashboardMetricsTableCols',
  INVESTMENT_CARVING: 'investmentCarvingSetting',
  PM_ISSUE_TAGS_FETCH_STRATEGY: 'pmIssueTagsFetchStrategy',
  EXCLUDE_BRANCHES: 'excludeBranches',
  PROJECT_PROGRESSION_INSIGHTS: 'projectProgressionInsightsSetting',
  RESOURCE_ALLOCATION_WIDGETS_CONFIG: 'resourceAllocationWidgetsConfig',
  TEAM_IS_NOTIFICATIONS_ENABLED: 'teamIsNotificationsEnabled',
  STALE_ISSUES_NOTIFICATION_THRESHOLDS: 'staleIssuesNotificationThresholds',
  PULSE_CONFIG: 'pulseConfig',
  FORCE_SYSTEM_UPDATE: 'forceSystemUpdate',
  SCIM_PROVISIONING_SETTINGS: 'scimProvisioningSettings',
  EXCLUDE_BY_TARGET_BRANCHES: 'excludeByTargetBranches',
  RESTORE_BRANCHES_TIME_WINDOW_IN_MONTHS: 'restoreBranchesTimeWindowInMonths',
  BENCHMARK_ORG_SIZE: 'benchmarkOrgSize',
  RELEASE_STAGES: 'releaseStages',
  AI_SERVICES: 'aiServices',
  RELEASE_CYCLE: 'releaseCycle',
  METRICS_SCALE_FACTOR: 'metricsScaleFactor'
};
var DefinitionLevels = {
  ORGANIZATION: 'organization',
  TEAM: 'team',
  REPOSITORY: 'repository'
};
var FEATURE_FLAGS_NAMES = {
  enableGitReOauth: 'enableGitReOauth',
  showNewPMReport: 'showNewPMReports',
  msTeamsEnabled: 'msTeamsEnabled',
  showNewInvestmentProfile: 'newInvestmentProfileView',
  getFFValueFromQS: 'getFFValueFromQS',
  SHOW_SLACK_DIGEST_FF: 'showSlackDigestSetting',
  enableSlackOnboarding: 'enableSlackOnboarding',
  enableSlackOnboardingAsFirstStep: 'enableSlackOnboardingAsFirstStep',
  showMessageCenter: 'showMessageCenter',
  deleteGitIntegration: 'deleteIntegration',
  projectsView: 'projectsView',
  canConfigProjects: 'canConfigProjects',
  showPulseUnmatchedBranches: 'showPulseUnmatchedBranches',
  newActivityPage: 'newActivityPage',
  showNotificationSettings: 'showNotificationSettings',
  azureReposEnabled: 'azureReposEnabled',
  showNewNotificationsSetting: 'showNewNotificationsSetting',
  qualityMetricsFlow: 'qualityMetricsFlow',
  skipProjectsBoardSelection: 'skipProjectsBoardSelection',
  nextGenSummaryEnabled: 'nextGenSummaryEnabled',
  isMetricsMultiTeamsEnabled: 'isMetricsMultiTeamsEnabled',
  showCFRConfiguration: 'showCFRConfiguration',
  showPMMetricsReport: 'showPMMetricsReport',
  apiTokens: 'apiTokens',
  addIntegrationEnabled: 'addIntegrationEnabled',
  pdtForShortcutEnabled: 'pdtForShortcutEnabled',
  upgradeEmptyStateEnabled: 'upgradeEmptyStateEnabled',
  upgradeGoalsEmptyStateEnabled: 'upgradeGoalsEmptyStateEnabled',
  metricsBenchmarks: 'metricsBenchmarks',
  viewerOnly: 'viewerOnly',
  projectsIssuesView: 'projectsIssuesView',
  ssoEnabled: 'ssoEnabled',
  forceSSOLogin: 'forceSSOLogin',
  newMttrCfrFilters: 'newMttrCfrFilters',
  projectsIterationsConfigEnabled: 'projectsIterationsConfigEnabled',
  hidePersonalInformationEnabled: 'hidePersonalInformationEnabled',
  servicesTabEnabled: 'servicesTabEnabled',
  metricsFilterByServiceEnabled: 'metricsFilterByServiceEnabled',
  showTeamsDashboard: 'showTeamsDashboard',
  showMetricsV3: 'showMetricsV3',
  ignorePmMetaDataEnabled: 'ignorePmMetaDataEnabled',
  teamPMConfigurationEnabled: 'teamPMConfigurationEnabled',
  bitbucketServerFetchLargeRepos: 'bitbucketServerFetchLargeRepos',
  bitbucketFetchLargeRepos: 'bitbucketFetchLargeRepos',
  gitlabFetchLargeRepos: 'gitlabFetchLargeRepos',
  githubFetchLargeRepos: 'githubFetchLargeRepos',
  githubFetchAllRepoTypes: 'githubFetchAllRepoTypes',
  contributorsAndTeamsSettingsEnabled: 'contributorsAndTeamsSettingsEnabled',
  settingsIntegrationsV2Enabled: 'settingsIntegrationsV2Enabled',
  favoriteProjectsEnabled: 'favoriteProjectsEnabled',
  workerbInlinePrApproveEnabled: 'workerb-actions-inline-pr-approve',
  isLinearbOnly: 'isLinearbOnly',
  assigneeNameEnable: 'assigneeNameEnable',
  showGoalsWidgets: 'showGoalsWidgets',
  isCustomPmMetricsEnabled: 'isCustomPmMetricsEnabled',
  projectSettingsFixVersionEnabled: 'projectSettingsFixVersionEnabled',
  analyzeJiraSubTasks: 'analyzeJiraSubTasks',
  newPdtConfigurationEnabled: 'newPdtConfigurationEnabled',
  nextGenProjectViewEnabled: 'nextGenProjectViewEnabled',
  enablePRCheckNotifications: 'enablePRCheckNotifications',
  workerBActionsEnabled: 'workerBActionsEnabled',
  workerbShareUnassignedPR: 'workerbShareUnassignedPR',
  slackCommandsEnabled: 'slackCommandsEnabled',
  showEstimatedReviewTime: 'showEstimatedReviewTime',
  workerbActionsInlinePrApprove: 'workerb-actions-inline-pr-approve',
  hidePersonalInformationDashboardEnabled: 'hidePersonalInformationDashboardEnabled',
  azureFetchLargeRepos: 'azureFetchLargeRepos',
  pmReportTimeDistributionWithToDoEnabled: 'pmReportTimeDistributionWithToDoEnabled',
  workerbMsteamsUnassignedPr: 'workerbMsteamsUnassignedPr',
  pdtDateRangePickerEnable: 'pdtDateRangePickerEnable',
  excludeBranchFromCycleTime: 'excludeBranchFromCycleTime',
  isActivityReleasesEnabled: 'isActivityReleasesEnabled',
  isIncidentsStrategyEnabled: 'isIncidentsStrategyEnabled',
  hidePulseEnabled: 'hidePulseEnabled',
  hideNonWorkingDayEnabled: 'hideNonWorkingDayEnabled',
  workerbInlineApproveMSTeams: 'workerbInlineApproveMSTeams',
  isAzurePmToolEnabled: 'isAzurePmToolEnabled',
  pdtContextForKanbanEnabled: 'pdtContextForKanbanEnabled',
  isRaInputSettingEnabled: 'isRaInputSettingEnabled',
  branchTimeToMergeAndTimeToApproveEnabled: 'branchTimeToMergeAndTimeToApproveEnabled',
  isPulseCtaEnabled: 'isPulseCtaEnabled',
  isResourceAllocationEmailEnabled: 'isResourceAllocationEmailEnabled',
  showEmailPreferencesSettings: 'showEmailPreferencesSettings',
  showTeamsOfTeams: 'showTeamsOfTeams',
  showTeamOfTeamsDashboard: 'showTeamOfTeamsDashboard',
  workerBMentionsEnabled: 'workerBMentionsEnabled',
  showGitlabGitstreamIntegration: 'showGitlabGitstreamIntegration',
  groupDashboardMetricsCustomizeEnabled: 'groupDashboardMetricsCustomizeEnabled',
  workerBMentionsMsteamsEnabled: 'workerBMentionsMsteamsEnabled',
  customPmMetricsLeadTimeEnabled: 'customPmMetricsLeadTimeEnabled',
  showPRLabelsFilter: 'showPRLabelsFilter',
  showIncidentsSettingsTab: 'showIncidentsSettingsTab',
  rollUpCfrMttrChildrenEnabled: 'rollUpCfrMttrChildrenEnabled',
  rollupForOrgLevelEnable: 'rollupForOrgLevelEnable',
  getPmEntitiesFromPgEnabled: 'getPmEntitiesFromPgEnabled',
  saveJiraIssuesCurrentStateOnlyEnabled: 'saveJiraIssuesCurrentStateOnlyEnabled',
  getProjectConfigFromPGEnabled: 'getProjectConfigFromPGEnabled',
  isPeriodPickerEnabled: 'isPeriodPickerEnabled',
  isAzureBoardsTeamSettingsEnabled: 'isAzureBoardsTeamSettingsEnabled',
  isCustomStagesDeployFrequencyMetricsEnabled: 'isCustomStagesDeployFrequencyMetricsEnabled',
  enableRepositoryLevelMetrics: 'enableRepositoryLevelMetrics',
  isFilterMenusV2Enabled: 'isFilterMenusV2Enabled',
  prOpenedMetricDependOnPrOpenEventEnabled: 'prOpenedMetricDependOnPrOpenEventEnabled',
  doraMetricsEnabled: 'doraMetricsEnabled',
  isPmOnPremConfigurationEnabledUI: 'isPmOnPremConfigurationEnabledUI',
  isPMEntitiesEnabledUI: 'isPMEntitiesEnabledUI',
  enableAllContributorsTeamMode: 'enableAllContributorsTeamMode',
  freePlusEnabled: 'freePlusEnabled',
  isMTTRDurationEnabled: 'isMTTRDurationEnabled',
  includeOutOfIterationIssuesInPMMetrics: 'includeOutOfIterationIssuesInPMMetrics',
  newTeamDashboardEnabled: 'newTeamDashboardEnabled',
  isRBACEnabled: 'isRBACEnabled',
  isReauthV2Enabled: 'isReauthV2Enabled',
  isGeneralSettingMFAEnabled: 'isGeneralSettingMFAEnabled',
  showOnboardingV2: 'showOnboardingV2',
  showDoraDashboardV2: 'showDoraDashboardV2',
  enableMsTeamsV2: 'enableMsTeamsV2',
  teamsSettingsNewUIEnabled: 'teamsSettingsNewUIEnabled',
  showGitProviderConnectV2: 'showGitProviderConnectV2',
  cftMttrMultiStrategiesEnabled: 'cftMttrMultiStrategiesEnabled',
  isMetricsTopBarFiltersAligned: 'isMetricsTopBarFiltersAligned',
  isAllTeamsEnabled: 'isAllTeamsEnabled',
  showDoraDashboard: 'showDoraDashboard',
  enableTeamSelection: 'enableTeamSelection',
  limitTimeRange: 'limitTimeRange',
  shouldReturnAllContributorsTeam: 'shouldReturnAllContributorsTeam',
  shouldReturnOnlyAllContributorsTeam: 'shouldReturnOnlyAllContributorsTeam',
  showTeamGoals: 'showTeamGoals',
  showBookADemoCta: 'showBookADemoCta',
  hideFreeDoraProcessingBarStates: 'hideFreeDoraProcessingBarStates',
  isPmIssueTagsFetchStrategyEnabled: 'isPmIssueTagsFetchStrategyEnabled',
  customPmMetricsForAzureBoardsEnabled: 'customPmMetricsForAzureBoardsEnabled',
  isCycleTimeInspectionEnabled: 'isCycleTimeInspectionEnabled',
  showMetricsInspectionForCustomStages: 'showMetricsInspectionForCustomStages',
  hideFreeDoraSettings: 'hideFreeDoraSettings',
  automationsViewEnabled: 'automationsViewEnabled',
  automationsMarketplaceViewEnable: 'automationsMarketplaceViewEnable',
  isNewSidebarBarEnabled: 'isNewSidebarBarEnabled',
  cycletimeMetricsPerDistinctBranchCalculationEnabled: 'cycletimeMetricsPerDistinctBranchCalculationEnabled',
  githubAutoRepoDiscoveryEnabled: 'githubAutoRepoDiscoveryEnabled',
  gitlabAutoRepoDiscoveryEnabled: 'gitlabAutoRepoDiscoveryEnabled',
  azureDevopsAutoRepoDiscoveryEnabled: 'azureDevopsAutoRepoDiscoveryEnabled',
  bitbucketAutoRepoDiscoveryEnabled: 'bitbucketAutoRepoDiscoveryEnabled',
  isProjectProgressionV2Enabled: 'isProjectProgressionV2Enabled',
  cfrMttrUseParentEnabled: 'cfrMttrUseParentEnabled',
  showChurnMetricsWidgets: 'showChurnMetricsWidgets',
  reportedMetricsEnabled: 'reportedMetricsEnabled',
  investmentCarvingIssuesDisplayEnabled: 'investmentCarvingIssuesDisplayEnabled',
  investmentCarvingFiltersEnabled: 'investmentCarvingFiltersEnabled',
  isDevCoachingEnabled: 'isDevCoachingEnabled',
  newTeamDashboardPastIterationEnabled: 'newTeamDashboardPastIterationEnabled',
  showPMReports: 'showPMReports',
  doneBranchesFromCommitEventEnabled: 'doneBranchesFromCommitEventEnabled',
  isPreventTooLongIterationsEnabled: 'isPreventTooLongIterationsEnabled',
  workerbDailyDigestEnabled: 'workerbDailyDigestEnabled',
  prReviewPerPrMergedReviewDepthEnabled: 'prReviewPerPrMergedReviewDepthEnabled',
  isExportAuditLogsEnabled: 'isExportAuditLogsEnabled',
  isTokenTypeSelectionEnabled_github: 'isTokenTypeSelectionEnabled_github',
  filterPullRequestsByReviewerTeamEnabled: 'filterPullRequestsByReviewerTeamEnabled',
  p90AggregationEnabled: 'p90AggregationEnabled',
  hideIncidentsSettingPerTeamEnabled: 'hideIncidentsSettingPerTeamEnabled',
  newGroupDashboardTableEnabled: 'newGroupDashboardTableEnabled',
  gitstreamGithubServerIntegrationEnabled: 'gitstreamGithubServerIntegrationEnabled',
  isSaveFiltersEnabled: 'isSaveFiltersEnabled',
  isScimEnabled: 'isScimEnabled',
  fetchIssueUsingNormalizedAttributes: 'fetchIssueUsingNormalizedAttributes',
  fetchBranchesActivityFiltersCountEnabled: 'fetchBranchesActivityFiltersCountEnabled',
  customStagesForTeamsEnabled: 'customStagesForTeamsEnabled',
  automationInspectionEnabled: 'automationInspectionEnabled',
  isSharedDemoEnvironment: 'isSharedDemoEnvironment',
  isDataMaskingEnabled: 'isDataMaskingEnabled',
  addLabelAutomationDrillDownEnabled: 'addLabelAutomationDrillDownEnabled',
  isMergeContributorDisabled: 'isMergeContributorDisabled',
  userProfileWizardEnabled: 'userProfileWizardEnabled',
  pitFilterForBranchesEnabled: 'pitFilterForBranchesEnabled',
  resolveTeamsToContributorIdsEnabled: 'resolveTeamsToContributorIdsEnabled',
  cycleTimeForDoneBranchesEnabled: 'cycleTimeForDoneBranchesEnabled',
  isProjectProgressionTreeHierarchyEnabled: 'isProjectProgressionTreeHierarchyEnabled',
  isSearchReleasesV2Enabled: 'isSearchReleasesV2Enabled',
  showGitstreamGitlabServerIntegration: 'showGitstreamGitlabServerIntegration',
  isResourceAllocationTreeHierarchyEnabled: 'isResourceAllocationTreeHierarchyEnabled',
  showGitstreamBitbucketIntegration: 'showGitstreamBitbucketIntegration',
  isInvestmentCarvingTreeHierarchyEnabled: 'isInvestmentCarvingTreeHierarchyEnabled',
  excludeBranchAffectAllMetricsEnabled: 'excludeBranchAffectAllMetricsEnabled',
  isPdtTreeHierarchyEnabled: 'isPdtTreeHierarchyEnabled',
  isIterationSummaryEnabled: 'isIterationSummaryEnabled',
  deployFrequencyServiceFiltersBasedOnReleaseServicesEnabled: 'deployFrequencyServiceFiltersBasedOnReleaseServicesEnabled',
  newDevCoachingFeatureEnabled: 'newDevCoachingFeatureEnabled',
  isVisionInsightsEnabled: 'isVisionInsightsEnabled',
  isVisionInsightsEnabledForTeam: 'isVisionInsightsEnabledForTeam',
  isTreeHierarchyFiltersEnabled: 'isTreeHierarchyFiltersEnabled',
  isDevCoachingMergeContributorsSuggestionEnabled: 'isDevCoachingMergeContributorsSuggestionEnabled',
  isTeamGitSettingEnabled: 'isTeamGitSettingEnabled',
  isCommitCountBasedOnCommitIdEnabled: 'isCommitCountBasedOnCommitIdEnabled',
  isStarterKitGenaiEnabled: 'isStarterKitGenaiEnabled',
  isProductivityGainEnabled: 'isProductivityGainEnabled',
  searchPullRequestsV2EnabledFF: 'searchPullRequestsV2EnabledFF',
  isGitSyncedTeamsPaginated: 'isGitSyncedTeamsPaginated',
  enableParallelMetricsQueryExecution: 'enableParallelMetricsQueryExecution',
  isPulseKanbanAccumulatedDoneDisabled: 'isPulseKanbanAccumulatedDoneDisabled',
  isInsightsTeamSettingsEnabled: 'isInsightsTeamSettingsEnabled',
  isVisionNotificationsEnabledForTeam: 'isVisionNotificationsEnabledForTeam',
  isAzureBoardsPdtEnabled: 'isAzureBoardsPdtEnabled',
  isAzureBoardsPulseEnabled: 'isAzureBoardsPulseEnabled',
  unifiedUserEnabled: 'unifiedUserEnabled',
  newUserManagementEnabled: 'newUserManagementEnabled',
  prMetricsPerBranchContributorsEnabled: 'prMetricsPerBranchContributorsEnabled',
  isTeamSpaceEnabled: 'isTeamSpaceEnabled',
  balanceAndWellnessDashboardEnabled: 'balanceAndWellnessDashboardEnabled',
  disableProfileEmailValidation: 'disableProfileEmailValidation',
  aiServicesSettingsVisible: 'aiServicesSettingsVisible',
  deployFrequencyPerBranchReleaseEventEnabled: 'deployFrequencyPerBranchReleaseEventEnabled',
  showExpediaMigrationStaleMode: 'showExpediaMigrationStaleMode',
  isLinearBTeamProjectFiltersEnabled: 'isLinearBTeamProjectFiltersEnabled',
  branchMetricsPerPrIssuerEnabled: 'branchMetricsPerPrIssuerEnabled',
  isSurveysEnabled: 'isSurveysEnabled',
  codingDaysMetricEnabled: 'codingDaysMetricEnabled',
  isJiraOAuth2Enabled: 'isJiraOAuth2Enabled'
};
var MEDIAN_VALUES = {
  p50: 'p50',
  p75: 'p75',
  p90: 'p90'
};

var _AVAILABLE_METRICS_WI;
var WIDGET_NAMES = {
  MERGED_LARGE_PRS_VS_MERGED_PRS: 'MERGED_LARGE_PRS_VS_MERGED_PRS',
  MERGED_LONG_LIVING_PRS_VS_MERGED_PRS: 'MERGED_LONG_LIVING_PRS_VS_MERGED_PRS',
  MERGED_UNLINKED_PRS_VS_MERGED_PRS: 'MERGED_UNLINKED_PRS_VS_MERGED_PRS',
  MERGED_REVIEW_REQUEST_HANGING_VS_MERGED_PRS: 'MERGED_REVIEW_REQUEST_HANGING_VS_MERGED_PRS',
  MERGED_WITHOUT_REVIEW_VS_MERGED_PRS: 'MERGED_WITHOUT_REVIEW_VS_MERGED_PRS',
  MERGED_WORK_AT_RISK_PRS_VS_MERGED_PRS: 'MERGED_WORK_AT_RISK_PRS_VS_MERGED_PRS',
  MERGED_WITH_BASIC_REVIEW_PRS_VS_MERGED_PRS: 'MERGED_WITH_BASIC_REVIEW_PRS_VS_MERGED_PRS',
  MERGED_LONG_REVIEW_PRS_VS_MERGED_PRS: 'MERGED_LONG_REVIEW_PRS_VS_MERGED_PRS'
};
var COMMIT_CODE_CHANGES_WIDGET = {
  id: 12,
  name: 'Code changes',
  description: 'Lines of code changed',
  category: 'Throughput',
  unitType: 'count',
  displayLabel: 'Changes',
  unitDescription: 'Code changes per',
  articleId: ARTICLE_IDS.THROUGHPUT_METRICS,
  metrics: [{
    name: metricNames.COMMIT_CODE_CHANGES
  }]
};
var RELEASES_COUNT_WIDGET = {
  id: 17,
  name: 'Releases',
  description: 'Number of releases (based on release detection strategy)',
  category: 'Throughput',
  unitType: 'count',
  unitDescription: 'Releases per',
  displayLabel: 'Releases',
  metrics: [{
    name: metricNames.RELEASES_COUNT
  }]
};
var AVAILABLE_METRICS_WIDGETS_MAP = (_AVAILABLE_METRICS_WI = {}, _AVAILABLE_METRICS_WI[metricNames.CYCLE_TIME] = {
  id: 1,
  name: 'Cycle Time',
  description: 'Time from first commit to release',
  category: 'Delivery',
  unitType: 'timespan',
  articleId: ARTICLE_IDS.CYCLE_TIME,
  metrics: [{
    name: metricNames.CYCLE_TIME
  }],
  avgOnlyWhenDataAvailable: true
}, _AVAILABLE_METRICS_WI[metricNames.TIME_TO_PR] = {
  id: 2,
  name: 'Coding Time',
  description: 'Time from first commit to pull request creation',
  category: 'Delivery',
  displayName: 'Coding time',
  unitType: 'timespan',
  articleId: ARTICLE_IDS.CYCLE_TIME,
  metrics: [{
    name: metricNames.TIME_TO_PR
  }],
  avgOnlyWhenDataAvailable: true
}, _AVAILABLE_METRICS_WI[metricNames.TIME_TO_REVIEW] = {
  id: 3,
  name: 'Pickup Time',
  description: 'Time from pull request creation to review',
  category: 'Delivery',
  unitType: 'timespan',
  articleId: ARTICLE_IDS.CYCLE_TIME,
  metrics: [{
    name: metricNames.TIME_TO_REVIEW
  }],
  avgOnlyWhenDataAvailable: true
}, _AVAILABLE_METRICS_WI[metricNames.REVIEW_TIME] = {
  id: 4,
  name: 'Review Time',
  description: 'Time from review beginning to pull request merged',
  category: 'Delivery',
  unitType: 'timespan',
  articleId: ARTICLE_IDS.CYCLE_TIME,
  metrics: [{
    name: metricNames.REVIEW_TIME
  }],
  avgOnlyWhenDataAvailable: true
}, _AVAILABLE_METRICS_WI[metricNames.TIME_TO_PROD] = {
  id: 5,
  name: 'Deploy Time',
  description: 'Time from pull request merge to release',
  category: 'Delivery',
  unitType: 'timespan',
  articleId: ARTICLE_IDS.CYCLE_TIME,
  metrics: [{
    name: metricNames.TIME_TO_PROD
  }],
  avgOnlyWhenDataAvailable: true
}, _AVAILABLE_METRICS_WI[metricNames.PR_SIZE] = {
  id: 6,
  name: 'PR Size',
  description: 'Size of pull request (total lines of code changed)',
  category: 'Quality',
  unitType: 'nonAvgCount',
  displayLabel: 'Code changes',
  unitDescription: 'Code changes per PR',
  articleId: ARTICLE_IDS.PR_SIZE,
  metrics: [{
    name: metricNames.PR_SIZE,
    avgBy: metricNames.PR_MERGED
  }]
}, _AVAILABLE_METRICS_WI[metricNames.REVIEW_DEPTH] = {
  id: 7,
  name: 'Review Depth',
  description: 'Avg. number of comments per review',
  category: 'Quality',
  unitType: 'nonAvgCount',
  displayLabel: 'Comments per review',
  unitDescription: 'Comments per review',
  articleId: ARTICLE_IDS.REVIEW_DEPTH,
  metrics: [{
    name: metricNames.REVIEW_DEPTH
  }],
  avgOnlyWhenDataAvailable: true
}, _AVAILABLE_METRICS_WI[metricNames.NEW_WORK] = {
  id: 8,
  name: 'New code',
  description: 'Ratio of new code',
  category: 'Quality',
  unitType: 'percentage',
  displayLabel: 'Of code changes',
  unitDescription: 'New code',
  articleId: ARTICLE_IDS.WORK_BREAKDOWN,
  metrics: [{
    name: metricNames.NEW_WORK,
    percentOff: COMMIT_CODE_CHANGES_WIDGET
  }]
}, _AVAILABLE_METRICS_WI[metricNames.REFACTOR] = {
  id: 9,
  name: 'Refactor',
  description: 'Ratio of legacy code changed (more than 21 days)',
  category: 'Quality',
  unitType: 'percentage',
  displayLabel: 'Of code changes',
  unitDescription: 'Refactor code',
  articleId: ARTICLE_IDS.WORK_BREAKDOWN,
  metrics: [{
    name: metricNames.REFACTOR,
    percentOff: COMMIT_CODE_CHANGES_WIDGET
  }]
}, _AVAILABLE_METRICS_WI[metricNames.REWORK] = {
  id: 10,
  name: 'Rework',
  description: 'Ratio of novice code changed (less than 21 days)',
  category: 'Quality',
  displayLabel: 'Of code changes',
  unitType: 'percentage',
  articleId: ARTICLE_IDS.WORK_BREAKDOWN,
  metrics: [{
    name: metricNames.REWORK,
    percentOff: COMMIT_CODE_CHANGES_WIDGET
  }]
}, _AVAILABLE_METRICS_WI[metricNames.PR_MERGED_WITHOUT_REVIEW] = {
  id: 11,
  name: 'PRs merged w/o review',
  description: 'Number of pull requests merged without any review',
  category: 'Quality',
  unitType: 'count',
  displayLabel: 'PRs',
  unitDescription: 'PRs per',
  articleId: ARTICLE_IDS.MERGED_WITHOUT_REVIEW,
  metrics: [{
    name: metricNames.PR_MERGED_WITHOUT_REVIEW
  }]
}, _AVAILABLE_METRICS_WI[metricNames.COMMIT_CODE_CHANGES] = COMMIT_CODE_CHANGES_WIDGET, _AVAILABLE_METRICS_WI[metricNames.COMMIT_COUNT] = {
  id: 13,
  name: 'Commits',
  description: 'Number of commits',
  category: 'Throughput',
  unitType: 'count',
  unitDescription: 'Commits per',
  displayLabel: 'Commits',
  articleId: ARTICLE_IDS.THROUGHPUT_METRICS,
  metrics: [{
    name: metricNames.COMMIT_COUNT
  }]
}, _AVAILABLE_METRICS_WI[metricNames.PR_NEW] = {
  id: 14,
  name: 'PRs opened',
  description: 'Number of pull requests opened',
  category: 'Throughput',
  unitType: 'count',
  displayLabel: 'PRs',
  unitDescription: 'PRs per',
  articleId: ARTICLE_IDS.THROUGHPUT_METRICS,
  metrics: [{
    name: metricNames.PR_NEW
  }]
}, _AVAILABLE_METRICS_WI[metricNames.PR_MERGED] = {
  id: 15,
  name: 'Merge Frequency',
  description: 'Number of pull requests merged',
  category: 'Throughput',
  unitType: 'count',
  displayLabel: 'PRs',
  unitDescription: 'PRs per',
  articleId: ARTICLE_IDS.THROUGHPUT_METRICS,
  metrics: [{
    name: metricNames.PR_MERGED
  }]
}, _AVAILABLE_METRICS_WI[metricNames.REVIEWS] = {
  id: 16,
  name: 'Reviews',
  description: 'Number of pull requests reviews',
  category: 'Throughput',
  unitType: 'count',
  unitDescription: 'Reviews per',
  displayLabel: 'Reviews',
  articleId: ARTICLE_IDS.THROUGHPUT_METRICS,
  metrics: [{
    name: metricNames.REVIEWS
  }]
}, _AVAILABLE_METRICS_WI[metricNames.RELEASES_COUNT] = {
  id: 18,
  name: 'Deploy frequency',
  description: 'Avg. of releases per day',
  category: 'Throughput',
  unitType: 'count',
  unitDescription: 'per',
  displayLabel: 'Deployments',
  articleId: ARTICLE_IDS.DEPLOYMENT_FREQ,
  metrics: [{
    name: metricNames.RELEASES_COUNT
  }]
}, _AVAILABLE_METRICS_WI[metricNames.ACTIVE_DAYS] = {
  id: 19,
  name: 'Active days',
  description: 'Number of days with Git activity (commits, PRs, Reviews etc.)',
  category: 'Balance',
  unitType: 'count',
  unitDescription: 'per',
  displayLabel: 'Active days',
  articleId: ARTICLE_IDS.ACTIVE_DAYS,
  metrics: [{
    name: metricNames.ACTIVE_DAYS
  }]
}, _AVAILABLE_METRICS_WI[metricNames.DONE_BRANCHES] = {
  id: 20,
  name: 'Done Branches',
  description: 'Number of branches moved to state merged or released',
  category: 'Throughput',
  unitType: 'count',
  unitDescription: 'per',
  displayLabel: 'Branches done',
  articleId: ARTICLE_IDS.DONE_BRANCHES,
  metrics: [{
    name: metricNames.DONE_BRANCHES
  }]
}, _AVAILABLE_METRICS_WI[metricNames.ACTIVE_BRANCHES] = {
  id: 21,
  name: 'Active Branches',
  description: 'Number of branches in active state',
  category: 'Balance',
  unitType: 'count',
  unitDescription: 'per',
  displayLabel: 'Active branches',
  articleId: ARTICLE_IDS.ACTIVE_BRANCHES,
  metrics: [{
    name: metricNames.ACTIVE_BRANCHES
  }]
}, _AVAILABLE_METRICS_WI[metricNames.PM_MTTR] = {
  id: 23,
  name: 'MTTR',
  description: 'Mean time to restore',
  unitDescription: 'Mean time to restore',
  category: 'Project Management',
  unitType: 'timespan',
  isPMMetric: true,
  goToSettingsType: 'MTTR',
  filtersOfSettingDefinition: 'mttrConfig',
  metrics: [{
    name: metricNames.PM_MTTR
  }],
  articleId: ARTICLE_IDS.PM_MTTR
}, _AVAILABLE_METRICS_WI[WIDGET_NAMES.MERGED_LARGE_PRS_VS_MERGED_PRS] = {
  id: 27,
  type: 'stacked',
  name: 'PR Size',
  description: 'Large pull requests (total lines of code changed)',
  category: 'Team Goals',
  unitType: 'percentageWholeNumber',
  unitDescription: 'Met goal',
  agg_func: 'count',
  featureFlagName: FEATURE_FLAGS_NAMES.showGoalsWidgets,
  goToSettingsType: 'teamGoals',
  metrics: [{
    name: metricNames.MERGED_LARGE_PRS,
    isInfluxBasedMetric: true
  }, {
    name: metricNames.PR_MERGED,
    isInfluxBasedMetric: true
  }],
  articleId: ARTICLE_IDS.LARGE_PULL_REQUESTS
}, _AVAILABLE_METRICS_WI[WIDGET_NAMES.MERGED_LONG_LIVING_PRS_VS_MERGED_PRS] = {
  id: 28,
  type: 'stacked',
  name: 'PR Lifecycle',
  description: 'Long living pull requests',
  category: 'Team Goals',
  unitType: 'percentageWholeNumber',
  unitDescription: 'Met goal',
  agg_func: 'count',
  featureFlagName: FEATURE_FLAGS_NAMES.showGoalsWidgets,
  goToSettingsType: 'teamGoals',
  metrics: [{
    name: metricNames.MERGED_LONG_LIVING_PRS,
    isInfluxBasedMetric: true
  }, {
    name: metricNames.PR_MERGED,
    isInfluxBasedMetric: true
  }],
  articleId: ARTICLE_IDS.HANGING_AND_LONG_REVIEWS
}, _AVAILABLE_METRICS_WI[WIDGET_NAMES.MERGED_REVIEW_REQUEST_HANGING_VS_MERGED_PRS] = {
  id: 30,
  type: 'stacked',
  name: 'PR Pickup Time',
  description: '',
  category: 'Team Goals',
  unitType: 'percentageWholeNumber',
  unitDescription: 'Met goal',
  agg_func: 'count',
  featureFlagName: FEATURE_FLAGS_NAMES.showGoalsWidgets,
  goToSettingsType: 'teamGoals',
  metrics: [{
    name: metricNames.MERGED_REVIEW_REQUEST_HANGING,
    isInfluxBasedMetric: true
  }, {
    name: metricNames.PR_MERGED,
    isInfluxBasedMetric: true
  }],
  articleId: ARTICLE_IDS.HANGING_AND_LONG_REVIEWS
}, _AVAILABLE_METRICS_WI[WIDGET_NAMES.MERGED_WITHOUT_REVIEW_VS_MERGED_PRS] = {
  id: 31,
  type: 'stacked',
  name: 'PR Merged without Review',
  description: '',
  category: 'Team Goals',
  unitType: 'percentageWholeNumber',
  unitDescription: 'Met goal',
  agg_func: 'count',
  featureFlagName: FEATURE_FLAGS_NAMES.showGoalsWidgets,
  goToSettingsType: 'teamGoals',
  metrics: [{
    name: metricNames.MERGED_WITHOUT_REVIEW,
    isInfluxBasedMetric: true
  }, {
    name: metricNames.PR_MERGED,
    isInfluxBasedMetric: true
  }],
  articleId: ARTICLE_IDS.PR_MERGED_WITH_BASIC_OR_NO_REVIEW
}, _AVAILABLE_METRICS_WI[WIDGET_NAMES.MERGED_WORK_AT_RISK_PRS_VS_MERGED_PRS] = {
  id: 32,
  type: 'stacked',
  name: 'High Risk Work',
  description: '',
  category: 'Team Goals',
  unitType: 'percentageWholeNumber',
  unitDescription: 'Met goal',
  agg_func: 'count',
  featureFlagName: FEATURE_FLAGS_NAMES.showGoalsWidgets,
  goToSettingsType: 'teamGoals',
  metrics: [{
    name: metricNames.MERGED_WORK_AT_RISK_PRS,
    isInfluxBasedMetric: true
  }, {
    name: metricNames.PR_MERGED,
    isInfluxBasedMetric: true
  }],
  articleId: ARTICLE_IDS.HIGH_RISK_WORK
}, _AVAILABLE_METRICS_WI[WIDGET_NAMES.MERGED_WITH_BASIC_REVIEW_PRS_VS_MERGED_PRS] = {
  id: 33,
  type: 'stacked',
  name: 'PR Merged with Basic Review',
  description: '',
  category: 'Team Goals',
  unitType: 'percentageWholeNumber',
  unitDescription: 'Met goal',
  agg_func: 'count',
  featureFlagName: FEATURE_FLAGS_NAMES.showGoalsWidgets,
  goToSettingsType: 'teamGoals',
  metrics: [{
    name: metricNames.MERGED_WITH_BASIC_REVIEW_PRS,
    isInfluxBasedMetric: true
  }, {
    name: metricNames.PR_MERGED,
    isInfluxBasedMetric: true
  }],
  articleId: ARTICLE_IDS.PR_MERGED_WITH_BASIC_OR_NO_REVIEW
}, _AVAILABLE_METRICS_WI[WIDGET_NAMES.MERGED_LONG_REVIEW_PRS_VS_MERGED_PRS] = {
  id: 34,
  type: 'stacked',
  name: 'PR Review Time',
  description: '',
  category: 'Team Goals',
  unitType: 'percentageWholeNumber',
  unitDescription: 'Met goal',
  agg_func: 'count',
  featureFlagName: FEATURE_FLAGS_NAMES.showGoalsWidgets,
  goToSettingsType: 'teamGoals',
  metrics: [{
    name: metricNames.MERGED_LONG_REVIEW_PRS,
    isInfluxBasedMetric: true
  }, {
    name: metricNames.PR_MERGED,
    isInfluxBasedMetric: true
  }],
  articleId: ARTICLE_IDS.HANGING_AND_LONG_REVIEWS
}, _AVAILABLE_METRICS_WI[metricNames.PM_CFR] = {
  id: 35,
  name: 'CFR',
  description: 'Change failure rate',
  unitDescription: 'Avg change failure rate',
  category: 'Project Management',
  unitType: 'percentage',
  articleId: ARTICLE_IDS.PM_CFR,
  goToSettingsType: 'CFR',
  filtersOfSettingDefinition: 'cfrConfig',
  featureFlagName: FEATURE_FLAGS_NAMES.showCFRConfiguration,
  metrics: [{
    name: metricNames.PM_CFR,
    percentOff: RELEASES_COUNT_WIDGET
  }],
  avgOnlyWhenDataAvailable: false,
  overridePercentName: true
}, _AVAILABLE_METRICS_WI[metricNames.PR_MATURITY_RATIO] = {
  id: 36,
  name: 'PR Maturity',
  description: 'PR Maturity Ratio',
  unitDescription: 'Avg maturity ratio',
  category: 'Quality',
  unitType: 'percentage',
  metrics: [{
    name: metricNames.PR_MATURITY_RATIO
  }],
  avgOnlyWhenDataAvailable: true,
  articleId: ARTICLE_IDS.PR_MATURITY
}, _AVAILABLE_METRICS_WI[metricNames.BUGS_IN_PROGRESS] = {
  id: 37,
  name: 'Bugs in progress',
  description: 'Count all bugs that are in progress',
  type: 'bar',
  metrics: [{
    name: 'pm.issue.count'
  }],
  filters: {
    issue_types: [{
      name: 'Bug',
      id: 'bug'
    }],
    issue_states: [{
      name: 'In Progress',
      category: 'in-progress'
    }]
  },
  agg_func: 'count',
  unitType: 'count',
  category: 'Custom PM Metrics',
  internal_type: CUSTOM_DASHBOARD_INTERNAL_TYPES.CUSTOM_PM_METRICS,
  featureFlagName: FEATURE_FLAGS_NAMES.isCustomPmMetricsEnabled
}, _AVAILABLE_METRICS_WI[metricNames.BUGS_COMPLETED] = {
  id: 38,
  name: 'Completed Bugs',
  description: 'Count all bugs that are done',
  type: 'bar',
  metrics: [{
    name: 'pm.issue.count'
  }],
  filters: {
    issue_types: [{
      name: 'Bug',
      id: 'bug'
    }],
    issue_states: [{
      name: 'Done',
      category: 'done'
    }]
  },
  agg_func: 'count',
  unitType: 'count',
  category: 'Custom PM Metrics',
  internal_type: CUSTOM_DASHBOARD_INTERNAL_TYPES.CUSTOM_PM_METRICS,
  featureFlagName: FEATURE_FLAGS_NAMES.isCustomPmMetricsEnabled
}, _AVAILABLE_METRICS_WI[metricNames.STORIES_COMPLETED] = {
  id: 39,
  name: 'Completed Stories',
  description: 'All stories that are done',
  type: 'bar',
  metrics: [{
    name: 'pm.issue.count'
  }],
  filters: {
    issue_types: [{
      name: 'Story',
      id: 'story'
    }],
    issue_states: [{
      name: 'Done',
      category: 'done'
    }]
  },
  agg_func: 'count',
  unitType: 'count',
  category: 'Custom PM Metrics',
  internal_type: CUSTOM_DASHBOARD_INTERNAL_TYPES.CUSTOM_PM_METRICS,
  featureFlagName: FEATURE_FLAGS_NAMES.isCustomPmMetricsEnabled
}, _AVAILABLE_METRICS_WI[metricNames.PM_CUSTOM] = {
  id: 40,
  name: 'Custom',
  description: 'Customize your own parameters',
  type: 'bar',
  metrics: [{
    name: 'pm.issue.count'
  }],
  filters: {},
  agg_func: 'count',
  is_custom: true,
  unitType: 'count',
  category: 'Custom PM Metrics',
  internal_type: CUSTOM_DASHBOARD_INTERNAL_TYPES.CUSTOM_PM_METRICS,
  featureFlagName: FEATURE_FLAGS_NAMES.isCustomPmMetricsEnabled
}, _AVAILABLE_METRICS_WI[metricNames.BRANCH_TIME_TO_APPROVE] = {
  id: 41,
  name: 'Time to approve',
  description: 'Time from review beginning to pull request final approval',
  category: 'Delivery',
  unitType: 'timespan',
  metrics: [{
    name: metricNames.BRANCH_TIME_TO_APPROVE
  }],
  articleId: ARTICLE_IDS.BRANCH_TIME_TO_APPROVE
}, _AVAILABLE_METRICS_WI[metricNames.BRANCH_TIME_TO_MERGE] = {
  id: 42,
  name: 'Time to merge',
  description: 'Time from pull request final approval to pull request merged',
  category: 'Delivery',
  unitType: 'timespan',
  metrics: [{
    name: metricNames.BRANCH_TIME_TO_MERGE
  }],
  articleId: ARTICLE_IDS.BRANCH_TIME_TO_MERGE
}, _AVAILABLE_METRICS_WI[metricNames.CODE_CHURN_REFACTOR] = {
  id: 43,
  name: 'Code churn refactor',
  description: 'Code churn refactor',
  unitDescription: 'Sum of code churn refactor',
  category: 'Quality',
  unitType: 'count',
  featureFlagName: FEATURE_FLAGS_NAMES.showChurnMetricsWidgets,
  metrics: [{
    name: metricNames.CODE_CHURN_REFACTOR
  }]
}, _AVAILABLE_METRICS_WI[metricNames.CODE_CHURN_REWORK] = {
  id: 44,
  name: 'Code churn rework',
  description: 'Code churn rework',
  unitDescription: 'Sum of code churn rework',
  category: 'Quality',
  unitType: 'count',
  featureFlagName: FEATURE_FLAGS_NAMES.showChurnMetricsWidgets,
  metrics: [{
    name: metricNames.CODE_CHURN_REWORK
  }]
}, _AVAILABLE_METRICS_WI[metricNames.REPORTED_CUSTOM] = {
  id: 45,
  name: 'Custom Reported Metric',
  description: 'Customize metrics reported over API',
  type: 'bar',
  metrics: [{
    name: metricNames.REPORTED_CUSTOM
  }],
  agg_func: 'count',
  is_custom: true,
  unitType: 'count',
  category: 'Reported Metrics',
  internal_type: CUSTOM_DASHBOARD_INTERNAL_TYPES.REPORTED_METRICS,
  featureFlagName: FEATURE_FLAGS_NAMES.reportedMetricsEnabled
}, _AVAILABLE_METRICS_WI[metricNames.PR_REVIEWED] = {
  id: 46,
  name: 'PRs reviewed',
  description: 'Number of pull requests with review',
  category: 'Throughput',
  unitType: 'count',
  displayLabel: 'PRs',
  unitDescription: 'PRs per',
  articleId: ARTICLE_IDS.THROUGHPUT_METRICS,
  metrics: [{
    name: metricNames.PR_REVIEWED
  }]
}, _AVAILABLE_METRICS_WI[metricNames.SUM_OF_COMPONENTS_CYCLE_TIME] = {
  id: 47,
  name: 'Sum of Cycle Time components',
  description: 'Time from first commit to release',
  category: 'Delivery',
  unitType: 'timespan',
  articleId: ARTICLE_IDS.CYCLE_TIME,
  featureFlagName: FEATURE_FLAGS_NAMES.cycleTimeForDoneBranchesEnabled,
  metrics: [{
    name: metricNames.SUM_OF_COMPONENTS_CYCLE_TIME
  }],
  avgOnlyWhenDataAvailable: true
}, _AVAILABLE_METRICS_WI[metricNames.CONTRIBUTOR_CODING_DAYS] = {
  id: 48,
  name: 'Coding Days',
  description: 'Number of days on which at least one commit was made',
  category: 'Throughput',
  unitType: 'count',
  unitDescription: 'per',
  displayLabel: 'Coding days',
  featureFlagName: FEATURE_FLAGS_NAMES.codingDaysMetricEnabled,
  metrics: [{
    name: metricNames.CONTRIBUTOR_CODING_DAYS
  }]
}, _AVAILABLE_METRICS_WI);
var METRICS_WITH_INSPECTION_SUPPORTED = [// metricNames.CYCLE_TIME,
metricNames.TIME_TO_PR, metricNames.TIME_TO_REVIEW, metricNames.REVIEW_TIME, metricNames.TIME_TO_PROD, metricNames.PR_MERGED, metricNames.PR_MERGED_WITHOUT_REVIEW, metricNames.PR_NEW, metricNames.PR_SIZE, metricNames.REVIEW_DEPTH];

var METRICS_LIST = [{
  name: 'Cycle Time',
  description: 'Time from first commit to release'
}, {
  name: 'Coding Time',
  description: 'Time from first commit to pull request creation'
}, {
  name: 'Pickup Time',
  description: 'Time from pull request creation to review'
}, {
  name: 'Review Time',
  description: 'Time from review begining to pull request merged'
}, {
  name: 'Deploy Time',
  description: 'Time from pull request merge to release'
}, {
  name: 'PR Size',
  description: 'Size of pull request (total lines of code changed)'
}, {
  name: 'Review Depth',
  description: 'Avg. number of comments per review'
}, {
  name: 'New code',
  description: 'Ratio of new code'
}, {
  name: 'Refactor',
  description: 'Ratio of legacy code changed (more than 21 days)'
}, {
  name: 'Rework',
  description: 'Ratio of novice code changed (less than 21 days)'
}, {
  name: 'PRs merged w/o review',
  description: 'Numbre of pull requests merged without any review'
}, {
  name: 'Code changes',
  description: 'Lines of code changed'
}, {
  name: 'Commits',
  description: 'Number of commits'
}, {
  name: 'PRs opened',
  description: 'Number of pull requests opened'
}, {
  name: 'PRs merged',
  description: 'Number of pull requests merged'
}, {
  name: 'Reviews',
  description: 'Number of pull requests reviews'
}, {
  name: 'Releases',
  description: 'Number of releases (based on release detection strategy)'
}, {
  name: 'Deploy frequency',
  description: 'Avg. of releases per day'
}, {
  name: 'Active days',
  description: 'Number of days with Git activity (commits, PRs, Reviews etc.)'
}, {
  name: 'Active Branches',
  description: 'Number of branches in active state'
}, {
  name: 'Done Branches',
  description: 'Number of branches moved to state merged or releaaed '
}, {
  name: 'Caarryover',
  description: 'Number of branches that were active in the last day of the iteration '
}];
var TIME_TO_CUSTOM_STAGES_REGEX = /^(?!.+deploy_frequency$)branch.stage.*/;
var CUSTOM_STAGES_DEPLOY_FREQUENCY_REGEX = /^branch.stage.*.*deploy_frequency$/;
var BRANCH_STATS_REGEX_FIELDS = [TIME_TO_CUSTOM_STAGES_REGEX, CUSTOM_STAGES_DEPLOY_FREQUENCY_REGEX];

var PERMISSION_SCOPE_TYPE = {
  TEAM: 'team',
  ALL_TEAMS: 'all_teams'
};
var PERMISSION_SCOPE_ALL_TEAMS_ID = -1;
var RBAC_ALL_TEAMS_SCOPE = [{
  scope_id: PERMISSION_SCOPE_ALL_TEAMS_ID,
  scope_type: PERMISSION_SCOPE_TYPE.ALL_TEAMS
}];
/**
 * @description Permissions for protected domain contains area + action
 * For example:
 *    dev-coaching edit
 *    dev-coaching-developer-metrics view
 */

var PERMISSION_ACTION = {
  VIEW: 'view',
  EDIT: 'edit'
};
var PERMISSION_DOMAIN = {
  DEV_COACHING: 'dev-coaching'
};

var PROJECT_STATUS = {
  EDITED: 'EDITED',
  DELETED: 'DELETED',
  NEW: 'NEW',
  STEADY: 'STEADY'
};

var PUSHER_DEFAULT_CHANNEL_PREFIX = 'private-linearb-';
var PUSHER_EVENTS = {
  ADD_REPOSITORIES: 'add_repositories'
}; // Generates name for private channels

var generatePusherPrivateChannelName = function generatePusherPrivateChannelName(organizationId) {
  return "" + PUSHER_DEFAULT_CHANNEL_PREFIX + organizationId;
};

/**
 * Resource allocation project related enum with options values for public.epic_status table values for status column.
 * This status is an internal thing, that has no real relation to the jira issues with type `epic`. Users are allowed to
 * choose this status for epics in the resource allocation page in the aggregated table widget.
 * @note: Old enum that will be deprecated soon, so please don't use it anymore. Use resourceAllocationIssueStatusEnum
 * instead.
 * @enum {string}
 * */
var resourceAllocationEpicStatusEnum;

(function (resourceAllocationEpicStatusEnum) {
  resourceAllocationEpicStatusEnum["ON_TRACK"] = "on_track";
  resourceAllocationEpicStatusEnum["IDLE"] = "idle";
  resourceAllocationEpicStatusEnum["AT_RISK"] = "at_risk";
  resourceAllocationEpicStatusEnum["COMPLETE"] = "complete";
})(resourceAllocationEpicStatusEnum || (resourceAllocationEpicStatusEnum = {}));
/**
 * Resource allocation project related enum with options values for public.issue_status table values for status column.
 * This status is an internal thing, that has no real relation to the jira issues. Users are allowed to choose this
 * status for epics, initiatives (others in the future) in the resource allocation page in the aggregated table widget.
 * @enum {string}
 * */


var resourceAllocationIssueStatusEnum;

(function (resourceAllocationIssueStatusEnum) {
  resourceAllocationIssueStatusEnum["ON_TRACK"] = "on_track";
  resourceAllocationIssueStatusEnum["IDLE"] = "idle";
  resourceAllocationIssueStatusEnum["AT_RISK"] = "at_risk";
  resourceAllocationIssueStatusEnum["COMPLETE"] = "complete";
})(resourceAllocationIssueStatusEnum || (resourceAllocationIssueStatusEnum = {}));
/**
 * Resource allocation project related enum with aggregation types options values. We are doing aggregation and group
 * data by epics, issues, projects and initiatives. Epic is basically the issue with type `epic`, but we treat it as a
 * separate type.
 * @enum {string}
 */


var resourceAllocationTypesEnum;

(function (resourceAllocationTypesEnum) {
  resourceAllocationTypesEnum["PROJECT"] = "project";
  resourceAllocationTypesEnum["ISSUE_TYPE"] = "issue_type";
  resourceAllocationTypesEnum["CUSTOM_FIELD"] = "custom_field";
  resourceAllocationTypesEnum["LABEL"] = "label";
  resourceAllocationTypesEnum["EPIC"] = "epic";
  resourceAllocationTypesEnum["INITIATIVE"] = "initiative";
  resourceAllocationTypesEnum["FEATURE"] = "feature";
  resourceAllocationTypesEnum["DYNAMIC_ISSUE_TYPE"] = "dynamic_issue_type";
})(resourceAllocationTypesEnum || (resourceAllocationTypesEnum = {}));
/** Resource allocation project related enum with sorting options values.
 * @enum {string}
 */


var sortingOrderEnum;

(function (sortingOrderEnum) {
  sortingOrderEnum["DESC"] = "desc";
  sortingOrderEnum["ASC"] = "asc";
})(sortingOrderEnum || (sortingOrderEnum = {}));
/**
 * Resource allocation project related enum with aggregation periods options values.
 * @enum {string}
 */


var resourceAllocationAggregationRangesEnum;

(function (resourceAllocationAggregationRangesEnum) {
  resourceAllocationAggregationRangesEnum["MONTH"] = "month";
  resourceAllocationAggregationRangesEnum["WEEK"] = "week";
})(resourceAllocationAggregationRangesEnum || (resourceAllocationAggregationRangesEnum = {}));

var CURRENCIES = {
  USD: {
    symbol: '$',
    name: 'US Dollar',
    key: 'USD'
  },
  EUR: {
    symbol: '€',
    name: 'Euro',
    key: 'EUR'
  },
  GBP: {
    symbol: '£',
    name: 'Pound',
    key: 'GBP'
  },
  AUD: {
    symbol: '$',
    name: 'Australian Dollar',
    key: 'AUD'
  },
  CAD: {
    symbol: '$',
    name: 'Canadian Dollar',
    key: 'CAD'
  },
  BRL: {
    symbol: 'R$',
    name: 'Brazilian Real',
    key: 'BRL'
  },
  PEN: {
    symbol: 'S/',
    name: 'Peruvian Sol',
    key: 'PEN'
  },
  COP: {
    symbol: '$',
    name: 'Colombian Peso',
    key: 'COP'
  },
  MXN: {
    symbol: '$',
    name: 'Mexican Peso',
    key: 'MXN'
  }
};

var _SENSOR_PROVIDER_DETA;

var SENSOR_TYPES;

(function (SENSOR_TYPES) {
  SENSOR_TYPES[SENSOR_TYPES["GIT"] = 1] = "GIT";
  SENSOR_TYPES[SENSOR_TYPES["PM"] = 2] = "PM";
  SENSOR_TYPES[SENSOR_TYPES["HR"] = 3] = "HR";
  SENSOR_TYPES[SENSOR_TYPES["COLLABORATION"] = 4] = "COLLABORATION";
  SENSOR_TYPES[SENSOR_TYPES["CI_CD"] = 5] = "CI_CD";
  SENSOR_TYPES[SENSOR_TYPES["SSO"] = 6] = "SSO";
})(SENSOR_TYPES || (SENSOR_TYPES = {}));

var SENSOR_NAMES = {
  CLUBHOUSE: 'clubhouse',
  AZURE_DEVOPS: 'azure_devops',
  GITLAB: 'gitlab',
  GITHUB: 'github',
  JIRA: 'JIRA',
  SLACK: 'slack',
  BITBUCKET_SERVER: 'bitbucket_server',
  BITBUCKET: 'bitbucket',
  MS_TEAMS: 'azure_ad_oauth2',
  SAML_SSO: 'saml',
  AZURE_BOARDS: 'azure_boards'
};
var SENSOR_STATES = {
  'insufficient-permission': 'insufficient-permission',
  'cleanup-requested': 'cleanup-requested',
  'cleanup-in-progress': 'cleanup-in-progress',
  'cleanup-failed': 'cleanup-failed',
  deleted: 'deleted',
  failing: 'failing',
  inactive: 'inactive',
  inProgress: 'in-progress',
  ok: 'ok'
};
var SENSORS_MAP;

(function (SENSORS_MAP) {
  SENSORS_MAP[SENSORS_MAP["GITLAB"] = 2] = "GITLAB";
  SENSORS_MAP[SENSORS_MAP["GITHUB"] = 3] = "GITHUB";
  SENSORS_MAP[SENSORS_MAP["JIRA"] = 4] = "JIRA";
  SENSORS_MAP[SENSORS_MAP["BITBUCKET"] = 1] = "BITBUCKET";
  SENSORS_MAP[SENSORS_MAP["SLACK"] = 5] = "SLACK";
  SENSORS_MAP[SENSORS_MAP["BITBUCKET_SERVER"] = 6] = "BITBUCKET_SERVER";
  SENSORS_MAP[SENSORS_MAP["CLUBHOUSE"] = 7] = "CLUBHOUSE";
  SENSORS_MAP[SENSORS_MAP["MSTEAMS"] = 8] = "MSTEAMS";
  SENSORS_MAP[SENSORS_MAP["AZURE_BOARDS"] = 11] = "AZURE_BOARDS";
})(SENSORS_MAP || (SENSORS_MAP = {}));

var SENSOR_PROVIDER_DETAILS = (_SENSOR_PROVIDER_DETA = {}, _SENSOR_PROVIDER_DETA[SENSORS_MAP.BITBUCKET] = {
  name: 'Bitbucket',
  sensorId: 1,
  prTypeName: 'pull requests',
  imageUrl: 'https://linearb-website-assets-prod-01.s3.us-east-2.amazonaws.com/assets/v2/linearb-bot-connect-bitbucket.png'
}, _SENSOR_PROVIDER_DETA[SENSORS_MAP.GITLAB] = {
  name: 'GitLab',
  sensorId: 2,
  prTypeName: 'merge requests',
  imageUrl: 'https://linearb-website-assets-prod-01.s3.us-east-2.amazonaws.com/assets/v2/linearb-bot-connect-gitlab.png'
}, _SENSOR_PROVIDER_DETA[SENSORS_MAP.GITHUB] = {
  name: 'GitHub',
  sensorId: 3,
  prTypeName: 'pull requests',
  imageUrl: 'https://linearb-website-assets-prod-01.s3.us-east-2.amazonaws.com/assets/v2/linearb-bot-welcome.png'
}, _SENSOR_PROVIDER_DETA);
var GITHUB_TOKEN_TYPES = {
  CLASSIC: 'classic',
  FINE_GRAINED: 'fine_grained'
};

var _TEAM_NAMES, _TEAM_INITIALS;

var TEAM_TYPE_MAP;

(function (TEAM_TYPE_MAP) {
  TEAM_TYPE_MAP["GROUP"] = "group";
  TEAM_TYPE_MAP["STANDARD"] = "standard";
  TEAM_TYPE_MAP["SYNCED"] = "synced";
  TEAM_TYPE_MAP["ALL_CONTRIBUTORS"] = "all_contributors";
  TEAM_TYPE_MAP["ALL_TEAMS"] = "all_teams";
})(TEAM_TYPE_MAP || (TEAM_TYPE_MAP = {}));

var TEAM_NAME_TYPES = {
  ALL_CONTRIBUTORS: 'ALL_CONTRIBUTORS',
  MY_TEAM: 'MY_TEAM',
  ALL_TEAMS: 'ALL_TEAMS'
};
var TEAM_NAMES = (_TEAM_NAMES = {}, _TEAM_NAMES[TEAM_NAME_TYPES.ALL_CONTRIBUTORS] = 'All Contributors', _TEAM_NAMES[TEAM_NAME_TYPES.MY_TEAM] = 'My Team', _TEAM_NAMES[TEAM_NAME_TYPES.ALL_TEAMS] = 'All Teams', _TEAM_NAMES);
var TEAM_INITIALS = (_TEAM_INITIALS = {}, _TEAM_INITIALS[TEAM_NAME_TYPES.ALL_CONTRIBUTORS] = 'ACT', _TEAM_INITIALS[TEAM_NAME_TYPES.MY_TEAM] = 'MT', _TEAM_INITIALS[TEAM_NAME_TYPES.ALL_TEAMS] = 'ALL', _TEAM_INITIALS);

/**
 * Types of date ranges aggregation. We receive before and after and split whole period on ranges by weeks and months.
 * @enum {string}
 * */
var AggregationRangesEnum;

(function (AggregationRangesEnum) {
  AggregationRangesEnum["MONTHLY"] = "month";
  AggregationRangesEnum["WEEKLY"] = "week";
})(AggregationRangesEnum || (AggregationRangesEnum = {}));
/** Ordering directions.
 * @enum {string}
 */


var OrderOptionsEnum;

(function (OrderOptionsEnum) {
  OrderOptionsEnum["DESC"] = "desc";
  OrderOptionsEnum["ASC"] = "asc";
})(OrderOptionsEnum || (OrderOptionsEnum = {}));

/**
 * Types of project progression related linearb status categories. Here we have an additional accumulated_done category
 * for over time chart.
 * @enum {string}
 */
var ProjectProgressionLinearBStatusCategoriesEnum;

(function (ProjectProgressionLinearBStatusCategoriesEnum) {
  ProjectProgressionLinearBStatusCategoriesEnum["CREATED"] = "created";
  ProjectProgressionLinearBStatusCategoriesEnum["IN_PROGRESS"] = "in-progress";
  ProjectProgressionLinearBStatusCategoriesEnum["DONE"] = "done";
  ProjectProgressionLinearBStatusCategoriesEnum["ACCUMULATED_DONE"] = "accumulated_done";
})(ProjectProgressionLinearBStatusCategoriesEnum || (ProjectProgressionLinearBStatusCategoriesEnum = {}));
/**
 * Types of aggregation for over time chart.
 * @enum {string}
 * */


var ProjectProgressionOverTimeChartTypeEnum;

(function (ProjectProgressionOverTimeChartTypeEnum) {
  ProjectProgressionOverTimeChartTypeEnum["ISSUES"] = "issues";
  ProjectProgressionOverTimeChartTypeEnum["STORY_POINTS"] = "story_points";
})(ProjectProgressionOverTimeChartTypeEnum || (ProjectProgressionOverTimeChartTypeEnum = {}));
/**
 * Types of aggregation for aggregated table.
 * @enum {string}
 * */


var ProjectProgressionAggregatedTableTypeEnum;

(function (ProjectProgressionAggregatedTableTypeEnum) {
  ProjectProgressionAggregatedTableTypeEnum["ISSUES"] = "issues";
  ProjectProgressionAggregatedTableTypeEnum["EPICS"] = "epics";
  ProjectProgressionAggregatedTableTypeEnum["INITIATIVES"] = "initiatives";
  ProjectProgressionAggregatedTableTypeEnum["FEATURES"] = "features";
  ProjectProgressionAggregatedTableTypeEnum["DYNAMIC_ISSUE_TYPE"] = "dynamic_issue_type";
})(ProjectProgressionAggregatedTableTypeEnum || (ProjectProgressionAggregatedTableTypeEnum = {}));

/**
 * REPOS_AUTO_DISCOVERY_STATE_TYPE
 */
var REPOS_AUTO_DISCOVERY_STATE_TYPE = {
  ACTIVE: 'active',
  IN_ACTIVE: 'inactive',
  FAILING: 'failing'
};
/**
 * REPOS_AUTO_DISCOVERY_VISIBILITY_TYPE
 */

var REPOS_AUTO_DISCOVERY_VISIBILITY_TYPE = {
  PUBLIC: 'public',
  PRIVATE: 'private',
  INTERNAL: 'internal'
};

/**
 * REPOS_COLLECTOR_FILTER_MODE
 */
var REPOS_COLLECTOR_FILTER_MODE = {
  SELECT_ALL: 'select_all',
  SPECIFIC: 'specific',
  REPOS_AUTO_DISCOVERY: 'repos_auto_discovery'
};

var marketPlaceAutomations = [{
  always: false,
  automation_in_cm: 'approve_tests',
  category: ['efficiency', 'testing'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/approve_tests.cm',
  config: '* The PR only contains changes to tests\n\nAutomation Actions:\n\n* Add a tests-only label\n* Approve the PR\n* Post a comment that explains why the PR was approved.\n',
  config_actions: ['Add a tests-only label', 'Approve the PR', 'Post a comment that explains why the PR was approved'],
  config_conditions: ['The PR only contains changes to tests'],
  config_intro: 'Label and approve PRs that only include tests, and post an explanation comment.',
  date: '2023-05-02T16:30:21-04:00',
  description: 'Automatically approve changes that only contain updates to tests.',
  file: 'docs/automations/approve-tests/README.md',
  image: 'https://docs.gitstream.cm/automations/approve-tests/approve_tests.png',
  id: 'approve-test-changes',
  link: 'https://docs.gitstream.cm/automations/approve-tests',
  logo: null,
  name: 'Approve test changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_ui',
  category: ['quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/assign_reviewers_by_directory.cm',
  config: '* The PR contains changes to JavaScript files inside the `src/ui` directory.\n\nAutomation Actions:\n\n* Add a user named `my-teamate` and a team named `my-organization/ui-team` as reviewers. These should be customized to match your organization.\n* Post a comment explaining why these reviewers were assigned.\n',
  config_actions: ['Add a user named `my-teamate` and a team named `my-organization/ui-team` as reviewers. These should be customized to match your organization', 'Post a comment explaining why these reviewers were assigned'],
  config_conditions: ['The PR contains changes to JavaScript files inside the `src/ui` directory'],
  config_intro: 'Automatically assign code reviewers based on directory structure. Optionally, you can substitue `require-reviewers` for `add-reviewers` to make review from the specified teams and individuals mandatory.',
  date: '2023-04-27T11:20:16-04:00',
  description: 'Automatically assign reviewers based on a watch list of files and directories.',
  file: 'docs/automations/assign-reviewers-by-directory/README.md',
  image: 'https://docs.gitstream.cm/automations/assign-reviewers-by-directory/assign_reviewers_by_directory.png',
  id: 'assign-reviewers-by-directory',
  link: 'https://docs.gitstream.cm/automations/assign-reviewers-by-directory',
  logo: null,
  name: 'Assign Reviewers by Directory',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_deleted_files',
  category: ['quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/label_deleted_files.cm',
  config: '* The PR deletes one or more files.\n\nAutomation Actions:\n\n* Apply a `deleted-files` label to the PR.\n',
  config_actions: ['Apply a `deleted-files` label to the PR'],
  config_conditions: ['The PR deletes one or more files'],
  config_intro: 'Label PRs that delete files.',
  date: '2023-05-02T16:30:21-04:00',
  description: 'Label PRs that delete files.',
  file: 'docs/automations/label-deleted-files/README.md',
  image: 'https://docs.gitstream.cm/automations/label-deleted-files/label_deleted_files.png',
  id: 'label-deleted-files',
  link: 'https://docs.gitstream.cm/automations/label-deleted-files',
  logo: 'https://docs.gitstream.cm/automations/label-deleted-files/Label-deleted-file.svg',
  name: 'Label Deleted Files',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'approve_team_by_directory',
  category: ['efficiency'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/approve_team_by_directory.cm',
  config: '* All changed files are inside the `docs` directory\n* The PR author is on the `tech-writers` team.\n\nAutomation Actions:\n\n* Approve the PR\n* Post a comment that explains the approval.\n',
  config_actions: ['Approve the PR', 'Post a comment that explains the approval'],
  config_conditions: ['All changed files are inside the `docs` directory', 'The PR author is on the `tech-writers` team'],
  config_intro: 'Automatically approve low-risk PRs from trusted teams.',
  date: '2023-05-02T16:30:21-04:00',
  description: 'Automatically approve PRs from trusted teams.',
  file: 'docs/automations/approve-team-by-directory/README.md',
  image: 'https://docs.gitstream.cm/automations/approve-team-by-directory/approve_team_by_directory.png',
  id: 'approve-trusted-team',
  link: 'https://docs.gitstream.cm/automations/approve-team-by-directory',
  logo: null,
  name: 'Approve Trusted Team',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'close_wrong_team_by_directory',
  category: ['quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/close_wrong_team_by_directory.cm',
  config: '* The PR changes one or more files inside `/src/views`. Customize this value for your project.\n* The PR author is not a member of the `ui` team. Customize this value for your organization.\n\nAutomation Actions:\n\n* Close the PR.\n* Post a comment that explains why the PR was closed.\n',
  config_actions: ['Close the PR', 'Post a comment that explains why the PR was closed'],
  config_conditions: ['The PR changes one or more files inside `/src/views`. Customize this value for your project', 'The PR author is not a member of the `ui` team. Customize this value for your organization'],
  config_intro: 'Close PRs to a specified directory if the PR author is not on an approved team.',
  date: '2023-05-02T08:28:13-04:00',
  description: 'Automatically close PRs to protected portions of your code.',
  file: 'docs/automations/close-wrong-team-by-directory/README.md',
  image: 'https://docs.gitstream.cm/automations/close-wrong-team-by-directory/close_wrong_team_by_directory.png',
  id: 'close-wrong-team-by-directory',
  link: 'https://docs.gitstream.cm/automations/close-wrong-team-by-directory',
  logo: null,
  name: 'Close Wrong Team by Directory',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'welcome_newcomer',
  category: ['review'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/welcome_newcomer.cm',
  config: '* The PR author made their first contribution to the repo during the current day.\n\nAutomation Actions:\n\n* Add the `my-organization/mentors` team to review the PR. Customize this to match your organization.\n* Apply a `new-contributor` label to the PR.\n* Post a comment explaining the next steps. Customize this to match your project.\n',
  config_actions: ['Add the `my-organization/mentors` team to review the PR. Customize this to match your organization', 'Apply a `new-contributor` label to the PR', 'Post a comment explaining the next steps. Customize this to match your project'],
  config_conditions: ['The PR author made their first contribution to the repo during the current day'],
  config_intro: "Post a welcome message when someone makes their first PR to a repo, and provide context to help them know what's next.",
  date: '2023-05-02T16:30:21-04:00',
  description: 'Automatically post messages to first time PR contributors to help them get started.',
  file: 'docs/automations/welcome-newcomer/README.md',
  image: 'https://docs.gitstream.cm/automations/welcome-newcomer/welcome_newcomer.png',
  id: 'welcome-newcomer',
  link: 'https://docs.gitstream.cm/automations/welcome-newcomer',
  logo: 'https://docs.gitstream.cm/automations/welcome-newcomer/welcome_newcomer.svg',
  name: 'Welcome Newcomer',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'additional_review_for_large_pr',
  category: ['efficiency'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/additional_review_for_large_pr.cm',
  config: '* There are 10 or more changed files\n* The estimated time to review is 30 minutes or more.\n* One or more of the changed files is inside the `src` directory.\n\nAutomation Actions:\n\n* Require a minumim of 2 reviews.\n* Post a comment that explains this is considered a large change that requires 2 reviews.\n',
  config_actions: ['Require a minumim of 2 reviews', 'Post a comment that explains this is considered a large change that requires 2 reviews'],
  config_conditions: ['There are 10 or more changed files', 'The estimated time to review is 30 minutes or more', 'One or more of the changed files is inside the `src` directory'],
  config_intro: 'Require 2 reviewers for PRs that have more than 10 changed files in the src directory and the estimated time to review is 30 or more minutes.',
  date: '2023-04-27T15:22:16-04:00',
  description: 'Require extra code reviews for large PRs.',
  file: 'docs/automations/additional-review-for-large-pr/README.md',
  image: 'https://docs.gitstream.cm/automations/additional-review-for-large-pr/additional_review_for_large_pr.png',
  id: 'additional-review-for-large-prs',
  link: 'https://docs.gitstream.cm/automations/additional-review-for-large-pr',
  logo: 'https://docs.gitstream.cm/automations/additional-review-for-large-pr/Additional-review-for-large-PR.svg',
  name: 'Additional Review for Large PRs',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'explain_code_experts',
  category: ['quality', 'review', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/explain_code_experts.cm',
  config: "* The PR has the 'suggest-reviewer' label.\n\nExplicit Triggers:\n* When a PR is created (`pr_created`)\n* When a PR becomes ready for review (`pr_ready_for_review`)\n* When a new commit is pushed to the PR (`commit`)\n\nAutomation Actions:\n\n* Post a comment that identifies the people with the highest level of code expertise.\n",
  config_actions: ['Post a comment that identifies the people with the highest level of code expertise'],
  config_conditions: ["The PR has the 'suggest-reviewer' label", 'Explicit Triggers:', '', 'When a PR is created (`pr_created`)', 'When a PR becomes ready for review (`pr_ready_for_review`)', 'When a new commit is pushed to the PR (`commit`)'],
  config_intro: 'Post a comment that uses git blame and history to list the most relevant experts for all PRs. The comment will automatically update as additional commits are added to the PR.',
  date: '2023-07-06T13:55:36-04:00',
  description: 'Automatically summarize the people with the highest code expertise for PRs.',
  file: 'docs/automations/standard/explain-code-experts/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/explain-code-experts/explain-code-experts.png',
  id: 'explain-code-experts',
  link: 'https://docs.gitstream.cm/automations/standard/explain-code-experts',
  logo: 'https://docs.gitstream.cm/automations/standard/explain-code-experts/explain-code-experts.svg',
  name: 'Explain Code Experts',
  quickstart: true,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'enforce_branch_name',
  category: ['review', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/branch-management/enforce_branch_name.cm',
  config: '* The incoming branch name is missing a required prefix `feature` `fix` or `stable`\n* The invoming branch name fails to match a specified regex pattern. In this case `abc-` followed by a number.\n* The incoming branch name is not listed in an `ignoreList` custom expression.\n\n* Post a comment explaining the branch name requirements.\n* Apply a red label: `❗ Incorrect Branch Name`\n* Close the PR.\n',
  config_actions: ['Post a comment explaining the branch name requirements', 'Apply a red label: `❗ Incorrect Branch Name`', 'Close the PR'],
  config_conditions: ['The incoming branch name is missing a required prefix `feature` `fix` or `stable`', 'The invoming branch name fails to match a specified regex pattern. In this case `abc-` followed by a number', 'The incoming branch name is not listed in an `ignoreList` custom expression'],
  config_intro: 'Automatically enforce prefixes or keywords in PR branch names.',
  date: '2023-08-22T12:37:02-04:00',
  description: 'Automatically enforce prefixes or keywords in PR branch names.',
  file: 'docs/automations/standard/branch-management/enforce-branch-name/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/branch-management/enforce-branch-name/enforce-branch-name.png',
  id: 'enforce-branch-naming-conventions',
  link: 'https://docs.gitstream.cm/automations/standard/branch-management/enforce-branch-name',
  logo: null,
  name: 'Enforce Branch Naming Conventions',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_changelog',
  category: ['review'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/review_changelog.cm',
  config: '* The branch name contains the phrase `feature`\n* The PR lacks changes to the docs/changelog.md file\n\nAutomation Actions:\n\n* Apply a yellow label that says `⚠️ Missing Changelog`\n* Request changes and post a comment explaining why.\n',
  config_actions: ['Apply a yellow label that says `⚠️ Missing Changelog`', 'Request changes and post a comment explaining why'],
  config_conditions: ['The branch name contains the phrase `feature`', 'The PR lacks changes to the docs/changelog.md file'],
  config_intro: "Request changes if a PR that meets specified criteria lacks an update to the project's changelog.",
  date: '2023-07-06T16:12:59-04:00',
  description: 'Ensure PRS to specific branches include changelog updates.',
  file: 'docs/automations/standard/review-changelog/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/review-changelog/review-changelog.png',
  id: 'enforce-changelog-updates',
  link: 'https://docs.gitstream.cm/automations/standard/review-changelog',
  logo: null,
  name: 'Enforce Changelog Updates',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'notify_watcher',
  category: ['review', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/review-assignment/notify_watcher.cm',
  config: '* The PR modifies any files listed under the `watchers` custom expression.\n\n* Post a comment that notifies the responsible team or individual of the changes.\n',
  config_actions: ['Post a comment that notifies the responsible team or individual of the changes'],
  config_conditions: ['The PR modifies any files listed under the `watchers` custom expression'],
  config_intro: 'Automatically notify code reviewers based on a resource watchlist.',
  date: '2023-09-01T15:32:17-04:00',
  description: 'Automatically notify code reviewers based on a resource watchlist.',
  file: 'docs/automations/standard/review-assignment/notify-watcher/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/review-assignment/notify-watcher/notify-watcher.png',
  id: 'notify-watchlist',
  link: 'https://docs.gitstream.cm/automations/standard/review-assignment/notify-watcher',
  logo: null,
  name: 'Notify Watchlist',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'share_knowledge',
  category: ['review'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/review-assignment/share_knowledge.cm',
  config: '* A `Share Knowledge` label has been applied to the PR\n\n* Choose a previous contributor between specified expertise thresholds and assign them as a reviewer.\n* Post a comment explaining why this action was taken.\n',
  config_actions: ['Choose a previous contributor between specified expertise thresholds and assign them as a reviewer', 'Post a comment explaining why this action was taken'],
  config_conditions: ['A `Share Knowledge` label has been applied to the PR'],
  config_intro: 'Require the reviewer as a previous contributor with code expertise between set thresholds when PR contains `Share Knowledge` label.',
  date: '2023-07-11T10:35:44+05:30',
  description: 'Automatically distribute PR reviews to increase code expertise.',
  file: 'docs/automations/standard/review-assignment/share-knowledge/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/review-assignment/share-knowledge/share-knowledge.png',
  id: 'knowledge-share',
  link: 'https://docs.gitstream.cm/automations/standard/review-assignment/share-knowledge',
  logo: null,
  name: 'Knowledge Share',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_target_branch',
  category: ['review'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/review-assignment/review_target_branch.cm',
  config: '* The target or source branch name contains a specified prefix.\n\n* Implement custom review policies for the branch.\n',
  config_actions: ['Implement custom review policies for the branch'],
  config_conditions: ['The target or source branch name contains a specified prefix'],
  config_intro: 'Automatically route and manage PRs based on the target or destination branch.',
  date: '2023-09-01T15:32:17-04:00',
  description: 'Automatically route and manage PRs based on the target or destination branch.',
  file: 'docs/automations/standard/review-assignment/review-branch/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/review-assignment/review-branch/review-branch.png',
  id: 'branch-based-review-policies-by-target-branch',
  link: 'https://docs.gitstream.cm/automations/standard/review-assignment/review-branch',
  logo: null,
  name: 'Branch-Based Review Policies - By Target Branch',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_source_branch',
  category: ['review'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/review-assignment/review_source_branch.cm',
  config: null,
  config_actions: ['Implement custom review policies for the branch'],
  config_conditions: ['The target or source branch name contains a specified prefix'],
  config_intro: 'Automatically route and manage PRs based on the target or destination branch.',
  date: '2023-09-01T15:32:17-04:00',
  description: 'Automatically route and manage PRs based on the target or destination branch.',
  file: 'docs/automations/standard/review-assignment/review-branch/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/review-assignment/review-branch/review-branch.png',
  id: 'branch-based-review-policies-by-source-branch',
  link: 'https://docs.gitstream.cm/automations/standard/review-assignment/review-branch',
  logo: null,
  name: 'Branch-Based Review Policies - By Source Branch',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_sensitive_files',
  category: ['review', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/review-assignment/review_sensitive_files.cm',
  config: '* Any files match the files or directories listed in the `sensitive_files` custom expression. Customize this list for your project.\n\nAutomation Actions:\n\n* Assign `my-organization/security` to review the PR. Customize this value to match your organization.\n* Require 2 approvals.\n* Post a comment that explains the automation.\n',
  config_actions: ['Assign `my-organization/security` to review the PR. Customize this value to match your organization', 'Require 2 approvals', 'Post a comment that explains the automation'],
  config_conditions: ['Any files match the files or directories listed in the `sensitive_files` custom expression. Customize this list for your project'],
  config_intro: 'Compare the changed files to a pre-defined list of files and directories in. If any files match, require a review from the team `my-organization/security` .',
  date: '2023-05-01T15:57:18-04:00',
  description: 'Automatically assign reviewers for PRs that contain changes to high-risk code.',
  file: 'docs/automations/standard/review-assignment/review-sensitive-files/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/review-assignment/review-sensitive-files/review_sensitive_files.png',
  id: 'review-sensitive-files',
  link: 'https://docs.gitstream.cm/automations/standard/review-assignment/review-sensitive-files',
  logo: null,
  name: 'Review Sensitive Files',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'assign_code_experts',
  category: ['review', 'efficiency', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/review-assignment/assign_code_experts.cm',
  config: '* The PR has a suggest-reviewers label attached to it.\n\nAutomation Actions:\n\n* Use `codeExperts` to assign recommended reviewers.\n* Use `explainCodeExperts` to post a comment that lists the top code experts for the PR.\n',
  config_actions: ['Use `codeExperts` to assign recommended reviewers', 'Use `explainCodeExperts` to post a comment that lists the top code experts for the PR'],
  config_conditions: ['The PR has a suggest-reviewers label attached to it'],
  config_intro: 'When someone applies a `suggest-reviewers` label to a PR, use codeExperts to assign recommended reviewers and post a comment with the `explainCodeExperts` automation action.',
  date: '2023-04-27T14:51:21-04:00',
  description: 'Automatically assign PR reviewers based on code expertise.',
  file: 'docs/automations/standard/review-assignment/assign-code-experts/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/review-assignment/assign-code-experts/assign_code_experts.png',
  id: 'assign-code-experts',
  link: 'https://docs.gitstream.cm/automations/standard/review-assignment/assign-code-experts',
  logo: 'https://docs.gitstream.cm/automations/standard/review-assignment/assign-code-experts/assign-code-experts.svg',
  name: 'Assign Code Experts',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_team',
  category: ['review'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/review-assignment/review_team.cm',
  config: '* The PR author is a member of one of the teams specified in the `teams` custom expression.\n\n* Assign that team to review the PR.\n',
  config_actions: ['Assign that team to review the PR'],
  config_conditions: ['The PR author is a member of one of the teams specified in the `teams` custom expression'],
  config_intro: "Automatically assign the PR author's team to review PRs.",
  date: '2023-09-01T15:32:17-04:00',
  description: 'Automatically assign teams to review PRs.',
  file: 'docs/automations/standard/review-assignment/review-team/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/review-assignment/review-team/review-team.png',
  id: 'automatic-team-review-assignment',
  link: 'https://docs.gitstream.cm/automations/standard/review-assignment/review-team',
  logo: null,
  name: 'Automatic Team Review Assignment',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'summarize_language_changes',
  category: ['review'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/summarize_language_changes.cm',
  config: '* A PR is created.\n\nAutomation Actions:\n\n* Post a comment containing a table that shows the percent of total changes for each programming language present in the PR.\n',
  config_actions: ['Post a comment containing a table that shows the percent of total changes for each programming language present in the PR'],
  config_conditions: ['A PR is created'],
  config_intro: 'Post a comment that summarizes which programming languages are contained in PRs.',
  date: '2023-12-07T15:34:21+02:00',
  description: 'Automatically post a comment that summarizes which programming languages are contained in PRs.',
  file: 'docs/automations/standard/summarize-language-changes/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/summarize-language-changes/summarize-language-changes.png',
  id: 'summarize-language-changes',
  link: 'https://docs.gitstream.cm/automations/standard/summarize-language-changes',
  logo: null,
  name: 'Summarize Language Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'flag_merged_no_review',
  category: [],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/flag_merged_no_review.cm',
  config: '* A PR is merged without at least one review.\n* Send a Slack notification to alert your team.\n* Apply a red `DCF5-merged-without-review` label.\n* Post a comment explaining SOC II requirements.\n',
  config_actions: ['', 'Send a Slack notification to alert your team', 'Apply a red `DCF5-merged-without-review` label', 'Post a comment explaining SOC II requirements'],
  config_conditions: ['', 'A PR is merged without at least one review', ''],
  config_intro: 'Automatically send notifications to your team when code is merged without review.',
  date: '2023-12-01T12:25:15+02:00',
  description: 'Automatically send notifications to your team when code is merged without review.',
  file: 'docs/automations/standard/flag-merged-no-review/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/flag-merged-no-review/slack-message.png',
  id: 'flag-code-that-s-merged-without-review',
  link: 'https://docs.gitstream.cm/automations/standard/flag-merged-no-review',
  logo: null,
  name: "Flag Code That's Merged Without Review",
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'enforce_pr_title',
  category: ['quality', 'review'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/enforce_pr_title.cm',
  config: '* The PR fails to follow a predefined semantic release format:\n\nAutomation Actions:\n\n* Request changes and post a comment explaining why.\n',
  config_actions: ['Request changes and post a comment explaining why'],
  config_conditions: ['The PR fails to follow a predefined semantic release format:'],
  config_intro: 'Automatically enforce PR naming conventions; this example expects the format: `<type>(<scope>): <short summary>` ',
  date: '2023-08-22T12:37:02-04:00',
  description: 'Automatically enforce PR naming conventions across your GitHub organization.',
  file: 'docs/automations/standard/enforce-pr-title/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/enforce-pr-title/enforce-pr-title.png',
  id: 'enforce-pr-semantic-titles',
  link: 'https://docs.gitstream.cm/automations/standard/enforce-pr-title',
  logo: null,
  name: 'Enforce PR Semantic Titles',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_todo_comments',
  category: ['review', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/review-todo-comments/review_todo_comments.cm',
  config: '* The PR contains a TODO statement\n\n* Request changes and post a comment explaining why.\n',
  config_actions: ['Request changes and post a comment explaining why'],
  config_conditions: ['The PR contains a TODO statement'],
  config_intro: 'Request changes for a PR that contains a TODO statement.',
  date: '2023-11-10T09:55:03+02:00',
  description: 'Automatically request changes for a PR that contains a TODO statement.',
  file: 'docs/automations/standard/review-todo-comments/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/review-todo-comments/review-todo-comments.png',
  id: 'review-todo-comments',
  link: 'https://docs.gitstream.cm/automations/standard/review-todo-comments',
  logo: null,
  name: 'Review TODO Comments',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_unresolved_threads',
  category: ['security'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/label-management/label_unresolved_threads.cm',
  config: '* The PR has one or more unresolved code review comments.\n\nAutomation Actions:\n\n* Apply a label that indicates how many unresolved comments the PR has.\n',
  config_actions: ['Apply a label that indicates how many unresolved comments the PR has'],
  config_conditions: ['The PR has one or more unresolved code review comments'],
  config_intro: 'Automatically label PRs when there are unresolved code review comments.',
  date: '2023-07-31T14:18:09+03:00',
  description: 'Automatically label PRs when there are unresolved code review comments.',
  file: 'docs/automations/standard/label-management/label-unresolved-threads/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/label-management/label-unresolved-threads/label-unresolved-threads.png',
  id: 'label-unresolved-review-threads',
  link: 'https://docs.gitstream.cm/automations/standard/label-management/label-unresolved-threads',
  logo: 'https://docs.gitstream.cm/automations/standard/label-management/label-unresolved-threads/Label-unresolved-thread.svg',
  name: 'Label Unresolved Review Threads',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'suggest_labels',
  category: ['review'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/label-management/suggest_labels.cm',
  config: '* A PR is created or updated that has no labels.\n\nAutomation Actions:\n\n* Post a comment that suggest labels the author can apply to the PR.\n',
  config_actions: ['Post a comment that suggest labels the author can apply to the PR'],
  config_conditions: ['A PR is created or updated that has no labels'],
  config_intro: 'Automatically suggest labels to apply to new PRs.',
  date: '2023-07-31T14:18:09+03:00',
  description: 'Automatically suggest labels to apply to new PRs.',
  file: 'docs/automations/standard/label-management/suggest-labels/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/label-management/suggest-labels/suggest-labels.png',
  id: 'pr-label-guidance',
  link: 'https://docs.gitstream.cm/automations/standard/label-management/suggest-labels',
  logo: null,
  name: 'PR Label Guidance',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_pr',
  category: ['review'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/label-management/label_prs_by_language.cm',
  config: '* A PR is created or updated.\n\n* Label the PR for each programming language that is included.\n',
  config_actions: ['Label the PR for each programming language that is included'],
  config_conditions: ['A PR is created or updated'],
  config_intro: 'Automatically detect which programming languages are contained in PRs and automatically label the PRs appropriately.',
  date: '2023-12-07T15:34:21+02:00',
  description: 'Automatically detect which programming languages are contained in PRs and automatically label the PRs appropriately.',
  file: 'docs/automations/standard/label-management/label-prs-by-language/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/label-management/label-prs-by-language/label-prs-by-language.png',
  id: 'label-prs-by-language',
  link: 'https://docs.gitstream.cm/automations/standard/label-management/label-prs-by-language',
  logo: null,
  name: 'Label PRs by Language',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_resource',
  category: ['review', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/label-management/label_modified_resources.cm',
  config: '* A PR is created or updated.\n\n* Apply labels based on the branch name or modified resources.\n',
  config_actions: ['Apply labels based on the branch name or modified resources'],
  config_conditions: ['A PR is created or updated'],
  config_intro: 'Automatically label PRs to indicate what resources are being changed.',
  date: '2023-08-16T16:08:32-04:00',
  description: 'Automatically label PRs to indicate what resources are being changed.',
  file: 'docs/automations/standard/label-management/label-modified-resources/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/label-management/label-modified-resources/label-modified-resources.png',
  id: 'label-modified-resources',
  link: 'https://docs.gitstream.cm/automations/standard/label-management/label-modified-resources',
  logo: null,
  name: 'Label Modified Resources',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_resource_percent',
  category: ['review'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/label-management/label_resources_percent.cm',
  config: '* A PR modifies resources listed in one or more specified locations.\n\nAutomation Actions:\n\n* Apply labels that indicate what percentage of new code lines modify the specified resources.\n',
  config_actions: ['Apply labels that indicate what percentage of new code lines modify the specified resources'],
  config_conditions: ['A PR modifies resources listed in one or more specified locations'],
  config_intro: 'Apply a label to all PRs that indicates what percentage of new lines of code modify one or more specified resources.',
  date: '2023-08-22T12:37:02-04:00',
  description: 'Automatically label PRs based on changes to code resources.',
  file: 'docs/automations/standard/label-management/label-resources-percent/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/label-management/label-resources-percent/label-resources-percent.png',
  id: 'label-changed-resources-by-percent',
  link: 'https://docs.gitstream.cm/automations/standard/label-management/label-resources-percent',
  logo: null,
  name: 'Label Changed Resources By Percent',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'enforce_required_labels',
  category: ['review', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/label-management/enforce_required_labels.cm',
  config: '* The PR lacks one or more labels from a list of required labels.\n\nAutomation Actions:\n\n* Apply a `Missing Required Labels` label.\n* Post a comment explaining why the label was applied and which labels are required.\n',
  config_actions: ['Apply a `Missing Required Labels` label', 'Post a comment explaining why the label was applied and which labels are required'],
  config_conditions: ['The PR lacks one or more labels from a list of required labels'],
  config_intro: 'Automatically enforce the use of required PR labels.',
  date: '2023-08-16T16:08:32-04:00',
  description: 'Automatically enforce the use of required PR labels.',
  file: 'docs/automations/standard/label-management/enforce-labels/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/label-management/enforce-labels/enforce-labels.png',
  id: 'enforce-required-labels',
  link: 'https://docs.gitstream.cm/automations/standard/label-management/enforce-labels',
  logo: null,
  name: 'Enforce Required Labels',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_approvals',
  category: ['review'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/label-management/label_approvals.cm',
  config: '* A PR is created or updated.\n\nAutomation Actions:\n\n* Apply or update a label that indicates how many merge approvals have been granted.\n',
  config_actions: ['Apply or update a label that indicates how many merge approvals have been granted'],
  config_conditions: ['A PR is created or updated'],
  config_intro: 'Automatically label PRs with the number of completed reviews that approve the PR.',
  date: '2023-07-31T14:18:09+03:00',
  description: 'Automatically label PRs with the number of completed reviews that approve the PR.',
  file: 'docs/automations/standard/label-management/label-approvals/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/label-management/label-approvals/label-approvals.png',
  id: 'label-the-number-of-approvals',
  link: 'https://docs.gitstream.cm/automations/standard/label-management/label-approvals',
  logo: null,
  name: 'Label the Number of Approvals',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'enforce_copyright_header',
  category: ['review', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/enforce_copyright_header.cm',
  config: '* The PR creates a new file inside the /src directory that lacks a specified copyright header at the top of the file.\n\n* Request changes and post a comment that explains the copyright header requirement.\n',
  config_actions: ['Request changes and post a comment that explains the copyright header requirement'],
  config_conditions: ['The PR creates a new file inside the /src directory that lacks a specified copyright header at the top of the file'],
  config_intro: 'Automatically require copyright headers for all new source code files.',
  date: '2023-08-22T12:37:02-04:00',
  description: 'Automatically require copyright headers for all new source code files.',
  file: 'docs/automations/standard/enforce-copyright-header/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/enforce-copyright-header/enforce-copyright-header.png',
  id: 'enforce-copyright-headers',
  link: 'https://docs.gitstream.cm/automations/standard/enforce-copyright-header',
  logo: null,
  name: 'Enforce Copyright Headers',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'comment_issue_tracker',
  category: ['quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/standard/link_issue_tracker.cm',
  config: '* The PR contains a reference to project tracking tickets in the title or branch name.\n\n* Post a comment that provides a link to the associated project tracking resource.\n',
  config_actions: ['Post a comment that provides a link to the associated project tracking resource'],
  config_conditions: ['The PR contains a reference to project tracking tickets in the title or branch name'],
  config_intro: 'Post a PR comment that links the associated resource in your issue tracker, such as Jira, Azure Boards, Shortcut, Asana, and more.',
  date: '2023-09-04T22:22:55+05:30',
  description: 'Automatically post PR comments that link to the associated project tracking resource.',
  file: 'docs/automations/standard/link-issue-tracker/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/link-issue-tracker/link-issue-tracker.png',
  id: 'automatic-project-tracker-links',
  link: 'https://docs.gitstream.cm/automations/standard/link-issue-tracker',
  logo: null,
  name: 'Automatic Project Tracker Links',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'estimated_time_to_review',
  category: ['efficiency', 'review'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/provide_estimated_time_to_review.cm',
  config: '* Any new PR or change to an existing PR.\n\nAutomation Actions:\n\n* Apply a color coded label that provides an estimated number of minutes someone will need to review the PR.\n',
  config_actions: ['Apply a color coded label that provides an estimated number of minutes someone will need to review the PR'],
  config_conditions: ['Any new PR or change to an existing PR'],
  config_intro: 'Label all PRs with an estimated number of minutes it would take someone to review. gitStream will automatically update this label whenever a PR changes.',
  date: '2023-04-27T15:05:03-04:00',
  description: 'Automatically label PRs with an estimated time to review.',
  file: 'docs/automations/provide-estimated-time-to-review/README.md',
  image: 'https://docs.gitstream.cm/automations/provide-estimated-time-to-review/provide_estimated_time_to_review.png',
  id: 'provide-estimated-time-to-review',
  link: 'https://docs.gitstream.cm/automations/provide-estimated-time-to-review',
  logo: 'https://docs.gitstream.cm/automations/provide-estimated-time-to-review/estimated_time_to_review.svg',
  name: 'Provide Estimated Time to Review',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'approve_python_log_output',
  category: ['python', 'efficiency'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/approve_python_log_output.cm',
  config: '* All files must end in .py\n* The changes only affect lines of code that invoke a `logger` object. This should be customized to your environment.\n\n* Apply a `log-output-only` label\n* Approve the PR\n* Post a comment explaining that the change only affects logging output.\n',
  config_actions: ['Apply a `log-output-only` label', 'Approve the PR', 'Post a comment explaining that the change only affects logging output'],
  config_conditions: ['All files must end in .py', 'The changes only affect lines of code that invoke a `logger` object. This should be customized to your environment'],
  config_intro: 'Approve changes to Python files that only affect lines of code that invoke a specified logging object.',
  date: '2023-04-27T11:07:58-04:00',
  description: 'Automatically approve PRs that only affect Python log output.',
  file: 'docs/automations/languages/python/approve-python-log-output/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/approve-log-output.png',
  id: 'approve-python-log-output-changes',
  link: 'https://docs.gitstream.cm/automations/languages/python/approve-python-log-output',
  logo: 'https://docs.gitstream.cm/automations/languages/python/approve-python-log-output/approve-formatting-changes-PY.svg',
  name: 'Approve Python Log Output Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_python_test_name',
  category: ['python', 'testing', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/languages/python/review_python_test_name.cm',
  config: '* The PR creates one or more new Python test files\n* The Python test fails to match the required naming convention.\n\n* Request changes and post a comment that explains the Python test name requirements.\n',
  config_actions: ['Request changes and post a comment that explains the Python test name requirements'],
  config_conditions: ['The PR creates one or more new Python test files', 'The Python test fails to match the required naming convention'],
  config_intro: 'Automatically request changes for Python test files that fail to match the required naming convention.',
  date: '2023-11-02T23:20:57+02:00',
  description: 'Automatically request changes for Python test files that fail to match the required naming convention.',
  file: 'docs/automations/languages/python/review-python-test-name/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/python/review-python-test-name/review-python-test-name.png',
  id: 'review-python-test-name',
  link: 'https://docs.gitstream.cm/automations/languages/python/review-python-test-name',
  logo: 'https://docs.gitstream.cm/automations/languages/python/review-python-test-name/approve-formatting-changes-PY.svg',
  name: 'Review Python Test Name',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'approve_python_formatting',
  category: ['python', 'efficiency'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/approve_python_formatting_change.cm',
  config: '* All of the files end in `.py`.\n* All changes are non-functional\n\nAutomation Actions:\n\n* Approve the PR\n* Apply a `code-formatting` label.\n* Post a comment that explains the automation.\n',
  config_actions: ['Approve the PR', 'Apply a `code-formatting` label', 'Post a comment that explains the automation'],
  config_conditions: ['All of the files end in `.py`', 'All changes are non-functional'],
  config_intro: 'Approve PRs that only contain formatting changes to Python files.',
  date: '2023-05-11T11:20:26-04:00',
  description: 'Automatically approve PRs that only contain Python formatting changes.',
  file: 'docs/automations/languages/python/approve-python-formatting-change/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/python/approve-python-formatting-change/approve_python_formatting_change.png',
  id: 'approve-python-formatting-changes',
  link: 'https://docs.gitstream.cm/automations/languages/python/approve-python-formatting-change',
  logo: 'https://docs.gitstream.cm/automations/languages/python/approve-python-formatting-change/approve-formatting-changes-PY.svg',
  name: 'Approve Python Formatting Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_missing_python_tests',
  category: ['python', 'testing', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/languages/python/review_missing_python_tests.cm',
  config: '* The PR creates one or more new Python files\n* The PR lacks new test files that match the name of the Python files\n\n* Apply a red missing-tests label\n* Request changes and post a comment listing the files that need tests.\n',
  config_actions: ['Apply a red missing-tests label', 'Request changes and post a comment listing the files that need tests'],
  config_conditions: ['The PR creates one or more new Python files', 'The PR lacks new test files that match the name of the Python files'],
  config_intro: 'Automatically request changes for Python PRs that lack test files.',
  date: '2023-11-02T23:20:57+02:00',
  description: 'Automatically request changes for Python PRs that lack test files.',
  file: 'docs/automations/languages/python/review-missing-python-tests/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/python/review-missing-python-tests/review-missing-python-tests.png',
  id: 'review-missing-python-tests',
  link: 'https://docs.gitstream.cm/automations/languages/python/review-missing-python-tests',
  logo: 'https://docs.gitstream.cm/automations/languages/python/review-missing-python-tests/approve-formatting-changes-PY.svg',
  name: 'Review Missing Python Tests',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'approve_golang_log_output',
  category: ['go', 'logging', 'efficiency'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/languages/golang/approve_golang_log_output.cm',
  config: '* All files end in `.go`\n* The changes only affect lines of code that invoke the `log` object.\n\n* Apply a `log-output-only` label\n* Approve the PR\n* Post a comment explaining that the change only affects logging output.\n',
  config_actions: ['Apply a `log-output-only` label', 'Approve the PR', 'Post a comment explaining that the change only affects logging output'],
  config_conditions: ['All files end in `.go`', 'The changes only affect lines of code that invoke the `log` object'],
  config_intro: 'Approve changes to Golang files that only affect lines of code that invoke the logger object.',
  date: '2023-10-11T09:01:02+02:00',
  description: 'Automatically approve PRs that only change Golang log output.',
  file: 'docs/automations/languages/golang/approve-golang-log-output/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/approve-log-output.png',
  id: 'approve-golang-log-output-changes',
  link: 'https://docs.gitstream.cm/automations/languages/golang/approve-golang-log-output',
  logo: 'https://docs.gitstream.cm/automations/languages/golang/approve-golang-log-output/approve-formatting-changes-go.svg',
  name: 'Approve Golang Log Output Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_missing_golang_tests',
  category: ['go', 'quality', 'testing'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/languages/golang/review_missing_golang_tests.cm',
  config: '* The PR creates one or more new Golang files\n* The PR lacks new test files that match the name of the Golang files\n\n* The PR lacks new test files that match the name of the Golang files\n*  Apply a red missing-tests label\n',
  config_actions: ['The PR lacks new test files that match the name of the Golang files', 'Apply a red missing-tests label'],
  config_conditions: ['The PR creates one or more new Golang files', 'The PR lacks new test files that match the name of the Golang files'],
  config_intro: 'Automatically request changes for Golang PRs that are missing tests.',
  date: '2023-11-02T23:20:57+02:00',
  description: 'Automatically request changes for Golang PRs that are missing tests.',
  file: 'docs/automations/languages/golang/review-missing-golang-tests/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/golang/review-missing-golang-tests/review-missing-golang-tests.png',
  id: 'review-missing-golang-tests',
  link: 'https://docs.gitstream.cm/automations/languages/golang/review-missing-golang-tests',
  logo: 'https://docs.gitstream.cm/automations/languages/golang/review-missing-golang-tests/approve-formatting-changes-go.svg',
  name: 'Review Missing Golang Tests',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'approve_rust_log_output',
  category: ['rust', 'logging', 'efficiency'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/languages/rust/approve_rust_log_output.cm',
  config: '* All files end in `.rs`\n* The changes only affect lines of code that invoke `print`, `println` or `dbg` macros or use the `log` crate macros.\n\n* Apply a `log-output-only` label\n* Approve the PR\n* Post a comment explaining that the change only affects logging output.\n',
  config_actions: ['Apply a `log-output-only` label', 'Approve the PR', 'Post a comment explaining that the change only affects logging output'],
  config_conditions: ['All files end in `.rs`', 'The changes only affect lines of code that invoke `print`, `println` or `dbg` macros or use the `log` crate macros'],
  config_intro: 'Approve changes to Rust files that only affect lines of code that invoke the logging marcos.',
  date: '2023-10-17T09:05:25+03:00',
  description: 'Automatically approve PRs that only change Rust log output.',
  file: 'docs/automations/languages/rust/approve-rust-log-output/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/approve-log-output.png',
  id: 'approve-rust-log-output-changes',
  link: 'https://docs.gitstream.cm/automations/languages/rust/approve-rust-log-output',
  logo: 'https://docs.gitstream.cm/automations/languages/rust/approve-rust-log-output/approve-formatting-changes-rs.svg',
  name: 'Approve Rust Log Output Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_java_test_name',
  category: ['java', 'testing', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/languages/java/review_java_test_name.cm',
  config: '* The PR creates one or more new Java test files\n* The Java test fails to match the required naming convention.\n\n* Request changes and post a comment that explains the Java test name requirements.\n',
  config_actions: ['Request changes and post a comment that explains the Java test name requirements'],
  config_conditions: ['The PR creates one or more new Java test files', 'The Java test fails to match the required naming convention'],
  config_intro: 'Automatically request changes for Java test files that fail to match the required naming convention.',
  date: '2023-11-02T23:20:57+02:00',
  description: 'Automatically request changes for Java test files that fail to match the required naming convention.',
  file: 'docs/automations/languages/java/review-java-test-name/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/java/review-java-test-name/review-java-test-name.png',
  id: 'review-java-test-name',
  link: 'https://docs.gitstream.cm/automations/languages/java/review-java-test-name',
  logo: 'https://docs.gitstream.cm/automations/languages/java/review-java-test-name/approve-formatting-changes-JAV.svg',
  name: 'Review Java Test Name',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_missing_java_tests',
  category: ['java', 'testing', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/languages/java/review_missing_java_tests.cm',
  config: '* The PR creates one or more new Java files\n* The PR lacks new test files that match the name of the Java files\n\n* Apply a red missing-tests label\n* Request changes and post a comment listing the files that need tests.\n',
  config_actions: ['Apply a red missing-tests label', 'Request changes and post a comment listing the files that need tests'],
  config_conditions: ['The PR creates one or more new Java files', 'The PR lacks new test files that match the name of the Java files'],
  config_intro: 'Automatically request changes for Java PRs that lack test files.',
  date: '2023-11-02T23:20:57+02:00',
  description: 'Automatically request changes for Java PRs that lack test files.',
  file: 'docs/automations/languages/java/review-missing-java-tests/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/java/review-missing-java-tests/review-missing-java-tests.png',
  id: 'review-missing-java-tests',
  link: 'https://docs.gitstream.cm/automations/languages/java/review-missing-java-tests',
  logo: 'https://docs.gitstream.cm/automations/languages/java/review-missing-java-tests/approve-formatting-changes-JAV.svg',
  name: 'Review Missing Java Tests',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'approve_java_log_output',
  category: ['java', 'logging', 'efficiency'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/languages/java/approve_java_log_output.cm',
  config: '* All files end in .java\n* The changes only affect lines of code that invoke logger object.\n\n* Apply a `log-output-only` label\n* Approve the PR\n* Post a comment explaining that the change only affects logging output.\n',
  config_actions: ['Apply a `log-output-only` label', 'Approve the PR', 'Post a comment explaining that the change only affects logging output'],
  config_conditions: ['All files end in .java', 'The changes only affect lines of code that invoke logger object'],
  config_intro: 'Approve changes to Java files that only affect lines of code that invoke the logger object.',
  date: '2023-10-11T09:01:02+02:00',
  description: 'Automatically approve PRs that only change Java log output.',
  file: 'docs/automations/languages/java/approve-java-log-output/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/approve-log-output.png',
  id: 'approve-java-log-output-changes',
  link: 'https://docs.gitstream.cm/automations/languages/java/approve-java-log-output',
  logo: 'https://docs.gitstream.cm/automations/languages/java/approve-java-log-output/approve-formatting-changes-JAV.svg',
  name: 'Approve Java Log Output Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_css_important',
  category: ['quality', 'html', 'css', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/languages/css/review_css_important.cm',
  config: '* The PR contains changes to CSS files.\n* The changes include `!important`\n\nAutomation Actions:\n\n* Apply an orange label that says `⚠️ Includes !important tag`\n* Request changes an post a comment asking the PR author to remove the important tage.\n',
  config_actions: ['Apply an orange label that says `⚠️ Includes !important tag`', 'Request changes an post a comment asking the PR author to remove the important tage'],
  config_conditions: ['The PR contains changes to CSS files', 'The changes include `!important`'],
  config_intro: 'Flag the use of `!important` in CSS files and automatically request changes.',
  date: '2023-06-20T12:29:09-04:00',
  description: 'Automatically request changes when PRs that include !important tags.',
  file: 'docs/automations/languages/html/review-css-important/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/html/review-css-important/review-css-important.png',
  id: 'flag-css-important-tags',
  link: 'https://docs.gitstream.cm/automations/languages/html/review-css-important',
  logo: 'https://docs.gitstream.cm/automations/languages/html/review-css-important/approve-formatting-changes-HTML.svg',
  name: 'Flag CSS Important Tags',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'flag_missing_html_tags',
  category: ['quality', 'html', 'css', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/languages/html/flag_missing_html_tags.cm',
  config: '* The PR contains only new HTML files\n* One or more files are missing a canonical tag\n* One or more files are missing a robots meta tag\n\n* Apply a `⚠️ Missing Required Tag` label.\n* Post a comment asking the user to add required tags.\n',
  config_actions: ['Apply a `⚠️ Missing Required Tag` label', 'Post a comment asking the user to add required tags'],
  config_conditions: ['The PR contains only new HTML files', 'One or more files are missing a canonical tag', 'One or more files are missing a robots meta tag'],
  config_intro: 'Request changes for HTML files that lack the canonical and robots tag.',
  date: '2023-11-10T09:26:43+02:00',
  description: 'Automatically request changes for HTML files that lack the canonical and robots tag.',
  file: 'docs/automations/languages/html/flag-missing-html-tags/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/html/flag-missing-html-tags/flag-missing-html-tags.png',
  id: 'flag-missing-html-tags',
  link: 'https://docs.gitstream.cm/automations/languages/html/flag-missing-html-tags',
  logo: 'https://docs.gitstream.cm/automations/languages/html/flag-missing-html-tags/approve-formatting-changes-HTML.svg',
  name: 'Flag Missing HTML Tags',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'enforce_html_title_length',
  category: ['quality', 'html', 'css'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/languages/html/enforce_html_title_length.cm',
  config: '* The PR adds a `<title>` tag that is less than 30 or greater than 90 characters.\n\n* Request changes and post a comment asking the author to modify the title.\n',
  config_actions: ['Request changes and post a comment asking the author to modify the title'],
  config_conditions: ['The PR adds a `<title>` tag that is less than 30 or greater than 90 characters'],
  config_intro: "Automatically request changes for `<title>` tags that don't comply with best practices.",
  date: '2023-11-10T09:26:43+02:00',
  description: "Automatically request changes for `<title>` tags that don't comply with best practices.",
  file: 'docs/automations/languages/html/enforce-html-title-length/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/html/enforce-html-title-length/enforce-html-title-length.png',
  id: 'enforce-html-title-length-requirements',
  link: 'https://docs.gitstream.cm/automations/languages/html/enforce-html-title-length',
  logo: 'https://docs.gitstream.cm/automations/languages/html/enforce-html-title-length/approve-formatting-changes-HTML.svg',
  name: 'Enforce HTML Title Length Requirements',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'flag_duplicate_h1',
  category: ['quality', 'html', 'css', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/languages/html/flag_duplicate_h1.cm',
  config: '* The PR contains more than one H1 heading in an HTML file.\n\n* Post a comment requesting the author to reduce H1 headings to one per file.\n',
  config_actions: ['Post a comment requesting the author to reduce H1 headings to one per file'],
  config_conditions: ['The PR contains more than one H1 heading in an HTML file'],
  config_intro: 'Automatically request changes when PRs contain HTML files that have more than one H1 heading.',
  date: '2023-11-10T09:26:43+02:00',
  description: 'Automatically request changes when PRs contain HTML files that have more than one H1 heading.',
  file: 'docs/automations/languages/html/flag-duplicate-h1/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/html/flag-duplicate-h1/flag-duplicate-h1.png',
  id: 'flag-duplicate-h1',
  link: 'https://docs.gitstream.cm/automations/languages/html/flag-duplicate-h1',
  logo: 'https://docs.gitstream.cm/automations/languages/html/flag-duplicate-h1/approve-formatting-changes-HTML.svg',
  name: 'Flag Duplicate H1',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'enforce_image_alt',
  category: ['quality', 'html', 'css'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/languages/html/enforce_image_alt.cm',
  config: '* The PR adds an image tag to an HTML file.\n* The PR is missing alt attributes for one or more images.\n\n* Add a `⚠️ Missing alt label` label\n* Request changes and post a comment asking the author to add alt attributes to images.\n',
  config_actions: ['Add a `⚠️ Missing alt label` label', 'Request changes and post a comment asking the author to add alt attributes to images'],
  config_conditions: ['The PR adds an image tag to an HTML file', 'The PR is missing alt attributes for one or more images'],
  config_intro: 'Automatically request changes for PRs HTML files that are missing image alt attributes.',
  date: '2023-11-10T09:26:43+02:00',
  description: 'Automatically request changes for PRs that are missing image alt attributes.',
  file: 'docs/automations/languages/html/enforce-image-alt/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/html/enforce-image-alt/enforce-image-alt.png',
  id: 'enforce-image-alt-attributes',
  link: 'https://docs.gitstream.cm/automations/languages/html/enforce-image-alt',
  logo: 'https://docs.gitstream.cm/automations/languages/html/enforce-image-alt/approve-formatting-changes-HTML.svg',
  name: 'Enforce Image Alt Attributes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_javascript_test_name',
  category: ['javascript'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/languages/javascript/review_javascript_test_name.cm',
  config: '* The PR creates one or more new JavaScript test files\n* The JavaScript test fails to match the required naming convention.\n\n* Request changes and post a comment that explains the JavaScript test name requirements.\n',
  config_actions: ['Request changes and post a comment that explains the JavaScript test name requirements'],
  config_conditions: ['The PR creates one or more new JavaScript test files', 'The JavaScript test fails to match the required naming convention'],
  config_intro: 'Automatically request changes for JavaScript test files that fail to match the required naming convention.',
  date: '2023-11-02T23:20:57+02:00',
  description: 'Automatically request changes for JavaScript test files that fail to match the required naming convention.',
  file: 'docs/automations/languages/javascript/review-javascript-test-name/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/javascript/review-javascript-test-name/review-javascript-test-name.png',
  id: 'review-javascript-test-name',
  link: 'https://docs.gitstream.cm/automations/languages/javascript/review-javascript-test-name',
  logo: 'https://docs.gitstream.cm/automations/languages/javascript/review-javascript-test-name/approve-formatting-changes-JS.svg',
  name: 'Review JavaScript Test Name',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_missing_javascript_tests',
  category: ['javascript'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/languages/javascript/review_missing_javascript_tests.cm',
  config: '* The PR creates one or more new JavaScript files\n* The PR lacks new test files that match the name of the JavaScript files\n\n* Apply a red `missing-tests` label\n* Request changes and post a comment listing the files that need tests.\n',
  config_actions: ['Apply a red `missing-tests` label', 'Request changes and post a comment listing the files that need tests'],
  config_conditions: ['The PR creates one or more new JavaScript files', 'The PR lacks new test files that match the name of the JavaScript files'],
  config_intro: 'Request changes for JavaScript PRs that lack test files.',
  date: '2023-11-02T23:20:57+02:00',
  description: 'Automatically request changes for JavaScript PRs that lack test files.',
  file: 'docs/automations/languages/javascript/review-missing-javascript-tests/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/javascript/review-missing-javascript-tests/review-missing-javascript-tests.png',
  id: 'review-missing-javascript-tests',
  link: 'https://docs.gitstream.cm/automations/languages/javascript/review-missing-javascript-tests',
  logo: 'https://docs.gitstream.cm/automations/languages/javascript/review-missing-javascript-tests/approve-formatting-changes-JS.svg',
  name: 'Review Missing JavaScript Tests',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'approve_javascript_formatting',
  category: ['javascript', 'efficiency'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/approve_javascript_formatting_change.cm',
  config: '* All of the files end in `.js` or `.ts`\n* All changes are non-functional\n\nAutomation Actions:\n\n* Approve the PR\n* Apply a `code-formatting` label.\n* Post a comment that explains the automation.\n',
  config_actions: ['Approve the PR', 'Apply a `code-formatting` label', 'Post a comment that explains the automation'],
  config_conditions: ['All of the files end in `.js` or `.ts`', 'All changes are non-functional'],
  config_intro: 'Approve PRs that only contain formatting changes to JavaScript or TypeScript files.',
  date: '2023-05-02T16:30:21-04:00',
  description: 'Automatically approve PRs that only change JavaScript formatting.',
  file: 'docs/automations/languages/javascript/approve-javascript-formatting-change/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/javascript/approve-javascript-formatting-change/approve-javascript-formatting-change.png',
  id: 'approve-javascript-formatting-changes',
  link: 'https://docs.gitstream.cm/automations/languages/javascript/approve-javascript-formatting-change',
  logo: 'https://docs.gitstream.cm/automations/languages/javascript/approve-javascript-formatting-change/approve-formatting-changes-JS.svg',
  name: 'Approve JavaScript Formatting Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'approve_javascript_log_output',
  category: ['javascript', 'efficiency'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/approve_javascript_log_output.cm',
  config: '* All files must end in .js or .ts\n* The changes only affect lines of code that invoke console.log()\n\n* Applies a `log-output-only` label\n* Approves the PR\n* Posts a comment explaining that the change only affects logging output.\n',
  config_actions: ['Applies a `log-output-only` label', 'Approves the PR', 'Posts a comment explaining that the change only affects logging output'],
  config_conditions: ['All files must end in .js or .ts', 'The changes only affect lines of code that invoke console.log()'],
  config_intro: 'Approve changes to JavaScript files that only affect lines of code that invoke the console.log() method.',
  date: '2022-12-18T21:26:31+02:00',
  description: 'Automatically approve PRs that only change JavaScript log output.',
  file: 'docs/automations/languages/javascript/approve-javascript-log-output/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/approve-log-output.png',
  id: 'approve-javascript-log-output-changes',
  link: 'https://docs.gitstream.cm/automations/languages/javascript/approve-javascript-log-output',
  logo: 'https://docs.gitstream.cm/automations/languages/javascript/approve-javascript-log-output/approve-formatting-changes-JS.svg',
  name: 'Approve JavaScript Log Output Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_ruby_test_name',
  category: ['ruby', 'testing', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/languages/ruby/review_ruby_test_name.cm',
  config: '* The PR creates one or more new Ruby test files\n* The Ruby test fails to match the required naming convention.\n\n* Request changes and post a comment that explains the Ruby test name requirements.\n',
  config_actions: ['Request changes and post a comment that explains the Ruby test name requirements'],
  config_conditions: ['The PR creates one or more new Ruby test files', 'The Ruby test fails to match the required naming convention'],
  config_intro: 'Automatically request changes for Ruby test files that fail to match the required naming convention.',
  date: '2023-11-02T23:20:57+02:00',
  description: 'Automatically request changes for Ruby test files that fail to match the required naming convention.',
  file: 'docs/automations/languages/ruby/review-ruby-test-name/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/ruby/review-ruby-test-name/review-ruby-test-name.png',
  id: 'review-ruby-test-name',
  link: 'https://docs.gitstream.cm/automations/languages/ruby/review-ruby-test-name',
  logo: 'https://docs.gitstream.cm/automations/languages/ruby/review-ruby-test-name/approve-formatting-changes-RB.svg',
  name: 'Review Ruby Test Name',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_missing_ruby_tests',
  category: ['ruby', 'testing', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/languages/ruby/review_missing_ruby_tests.cm',
  config: '* The PR creates one or more new Ruby files\n* The PR lacks new test files that match the name of the Ruby files\n\n* Apply a red missing-tests label\n* Request changes and post a comment listing the files that need tests.\n',
  config_actions: ['Apply a red missing-tests label', 'Request changes and post a comment listing the files that need tests'],
  config_conditions: ['The PR creates one or more new Ruby files', 'The PR lacks new test files that match the name of the Ruby files'],
  config_intro: 'Automatically request changes for Ruby PRs that lack test files.',
  date: '2023-11-02T23:20:57+02:00',
  description: 'Automatically request changes for Ruby PRs that lack test files.',
  file: 'docs/automations/languages/ruby/review-missing-ruby-tests/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/ruby/review-missing-ruby-tests/review-missing-ruby-tests.png',
  id: 'review-missing-ruby-tests',
  link: 'https://docs.gitstream.cm/automations/languages/ruby/review-missing-ruby-tests',
  logo: 'https://docs.gitstream.cm/automations/languages/ruby/review-missing-ruby-tests/approve-formatting-changes-RB.svg',
  name: 'Review Missing Ruby Tests',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'approve_ruby_log_output',
  category: ['ruby', 'logging', 'efficiency'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/languages/ruby/approve_ruby_log_output.cm',
  config: '* All files end in .rb\n* The changes only affect lines of code that invoke logger object.\n\n* Apply a `log-output-only` label\n* Approve the PR\n* Post a comment explaining that the change only affects logging output.\n',
  config_actions: ['Apply a `log-output-only` label', 'Approve the PR', 'Post a comment explaining that the change only affects logging output'],
  config_conditions: ['All files end in .rb', 'The changes only affect lines of code that invoke logger object'],
  config_intro: 'Approve changes to Ruby files that only affect lines of code that invoke the logger object.',
  date: '2023-10-11T09:01:02+02:00',
  description: 'Automatically approve PRs that only change Ruby log output.',
  file: 'docs/automations/languages/ruby/approve-ruby-log-output/README.md',
  image: 'https://docs.gitstream.cm/automations/languages/approve-log-output.png',
  id: 'approve-ruby-log-output-changes',
  link: 'https://docs.gitstream.cm/automations/languages/ruby/approve-ruby-log-output',
  logo: 'https://docs.gitstream.cm/automations/languages/ruby/approve-ruby-log-output/approve-formatting-changes-RB.svg',
  name: 'Approve Ruby Log Output Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'catch_missing_lambda_info',
  category: ['quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/change_missing_lambda_field.cm',
  config: '* The PR contains an update to a Lambda function.\n* The affected files are missing a description field.\n\nAutomation Actions:\n\n* Add a `lambda-missing-field` label to the PR.\n* Request changes and post a comment that explains why.\n',
  config_actions: ['Add a `lambda-missing-field` label to the PR', 'Request changes and post a comment that explains why'],
  config_conditions: ['The PR contains an update to a Lambda function', 'The affected files are missing a description field'],
  config_intro: 'If a PR creates a new Lambda function, but lacks a description field, gitStream will request changes and post a comment that explains why.',
  date: '2023-05-01T16:54:38-04:00',
  description: 'Detect missing Lambda fields that are required in all PRs.',
  file: 'docs/automations/change-missing-lambda-field/README.md',
  image: 'https://docs.gitstream.cm/automations/change-missing-lambda-field/change_missing_lambda_field.png',
  id: 'change-missing-lambda-field',
  link: 'https://docs.gitstream.cm/automations/change-missing-lambda-field',
  logo: null,
  name: 'Change Missing Lambda Field',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_terraform_module_name',
  category: ['quality', 'terraform'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/terraform/review_terraform_module_name.cm',
  config: '* The PR creates a new Terraform module.\n* The module name lacks a required name prefix, or one or more keywords.\n\n* Request review changes on the PR with a comment explaining the structure of module name.\n',
  config_actions: ['Request review changes on the PR with a comment explaining the structure of module name'],
  config_conditions: ['The PR creates a new Terraform module', 'The module name lacks a required name prefix, or one or more keywords'],
  config_intro: 'Request changes if a PR creates a new Terraform module that is missing a required prefix or keyword in the name.',
  date: '2023-08-08T00:08:19+05:30',
  description: 'Enforce naming conventions in Terraform module changes',
  file: 'docs/automations/integrations/terraform/review-terraform-module-name/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/terraform/review-terraform-module-name/review-terraform-module-name.png',
  id: 'review-terraform-module-name',
  link: 'https://docs.gitstream.cm/automations/integrations/terraform/review-terraform-module-name',
  logo: 'https://docs.gitstream.cm/automations/integrations/terraform/review-terraform-module-name/review-terraform.svg',
  name: 'Review Terraform Module Name',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_terraform',
  category: ['quality', 'terraform'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/terraform/review_terraform.cm',
  config: '* The PR contains changes to one or more Terraform configuration files.\n\n* Require a review from the org/infrastructure team.\n',
  config_actions: ['Require a review from the org/infrastructure team'],
  config_conditions: ['The PR contains changes to one or more Terraform configuration files'],
  config_intro: 'Automatically assign `org/infrastructure` team for reviewing changes when PR contains Terraform file changes.',
  date: '2023-07-22T13:33:08+05:30',
  description: 'Require specific reviewers for Terraform module changes',
  file: 'docs/automations/integrations/terraform/review-terraform/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/terraform/review-terraform/review-terraform.png',
  id: 'automatically-assign-infrastructure-team-for-terraform-changes',
  link: 'https://docs.gitstream.cm/automations/integrations/terraform/review-terraform',
  logo: 'https://docs.gitstream.cm/automations/integrations/terraform/review-terraform/review-terraform.svg',
  name: 'Automatically assign infrastructure team for Terraform changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_new_terraform_module',
  category: ['quality', 'terraform'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/terraform/review_new_module.cm',
  config: '* The PR creates a new Terraform module\n* A new sub-directory is created inside the `/modules` directory.\n* The PR lacks one or more required components from the list in the terraform custom expression.\n\n* Request changes and post a comment explaining the missing parts of the module.\n* Apply Label : `⚠️ Missing Terraform Components`\n',
  config_actions: ['Request changes and post a comment explaining the missing parts of the module', 'Apply Label : `⚠️ Missing Terraform Components`'],
  config_conditions: ['The PR creates a new Terraform module', 'A new sub-directory is created inside the `/modules` directory', 'The PR lacks one or more required components from the list in the terraform custom expression'],
  config_intro: 'Request changes if a PR that creates a new Terraform module which do not conform to the required directory structure.',
  date: '2023-07-29T15:06:36+05:30',
  description: 'Enforce directory structure conventions for new Terraform module',
  file: 'docs/automations/integrations/terraform/review-new-module/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/terraform/review-new-module/review-new-module.png',
  id: 'review-terraform-module-directory',
  link: 'https://docs.gitstream.cm/automations/integrations/terraform/review-new-module',
  logo: 'https://docs.gitstream.cm/automations/integrations/terraform/review-new-module/review-terraform.svg',
  name: 'Review Terraform Module Directory',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_terraform_source_version',
  category: ['quality', 'terraform'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/terraform/review_terraform_source_version.cm',
  config: '* The PR contains a Terraform source declaration via URL that lacks a version reference.\n* The source is not included in a whitelist custom expression that defines one or more whitelisted source locations.\n\n* Request review changes on the PR with a comment explaining version number requirement.\n',
  config_actions: ['Request review changes on the PR with a comment explaining version number requirement'],
  config_conditions: ['The PR contains a Terraform source declaration via URL that lacks a version reference', 'The source is not included in a whitelist custom expression that defines one or more whitelisted source locations'],
  config_intro: 'Ensure that all Terraform modules imported via a source URL specify a version.',
  date: '2023-08-08T00:08:19+05:30',
  description: 'Enforce Terraform modules use version when importing via URL source',
  file: 'docs/automations/integrations/terraform/review-terraform-source-version/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/terraform/review-terraform-source-version/review-terraform-source-version.png',
  id: 'review-terraform-module-imports',
  link: 'https://docs.gitstream.cm/automations/integrations/terraform/review-terraform-source-version',
  logo: 'https://docs.gitstream.cm/automations/integrations/terraform/review-terraform-source-version/review-terraform.svg',
  name: 'Review Terraform Module Imports',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_claude_code_pr',
  category: ['quality', 'genai', 'claude_code', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/claude_code/label_claude_code_by_prompt.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: 'Automatically apply labels to PRs that are assisted by Claude Code. You can apply labels based on a known list of Claude Code users, PR tags, or by prompting the PR author to indicate if they used Claude Code.',
  date: '2025-05-08T12:42:02-07:00',
  description: 'Automatically apply labels to PRs that are assisted by Claude Code',
  file: 'docs/automations/integrations/claude-code/flag-claude-code-pr/README.md',
  image: null,
  id: 'label-claude-code-prs-label-by-prompt',
  link: 'https://docs.gitstream.cm/automations/integrations/claude-code/flag-claude-code-pr',
  logo: null,
  name: 'Label Claude Code PRs - Label by Prompt',
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_claude_code_contributors',
  category: ['quality', 'genai', 'claude_code', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/claude_code/label_claude_code_by_contributors.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: 'Automatically apply labels to PRs that are assisted by Claude Code. You can apply labels based on a known list of Claude Code users, PR tags, or by prompting the PR author to indicate if they used Claude Code.',
  date: '2025-05-08T12:42:02-07:00',
  description: 'Automatically apply labels to PRs that are assisted by Claude Code',
  file: 'docs/automations/integrations/claude-code/flag-claude-code-pr/README.md',
  image: null,
  id: 'label-claude-code-prs-label-by-known-users',
  link: 'https://docs.gitstream.cm/automations/integrations/claude-code/flag-claude-code-pr',
  logo: null,
  name: 'Label Claude Code PRs - Label by Known Users',
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_claude_code',
  category: ['quality', 'genai', 'claude_code', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/claude_code/label_claude_code_by_tag.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: 'Automatically apply labels to PRs that are assisted by Claude Code. You can apply labels based on a known list of Claude Code users, PR tags, or by prompting the PR author to indicate if they used Claude Code.',
  date: '2025-05-08T12:42:02-07:00',
  description: 'Automatically apply labels to PRs that are assisted by Claude Code',
  file: 'docs/automations/integrations/claude-code/flag-claude-code-pr/README.md',
  image: null,
  id: 'label-claude-code-prs-label-by-tag',
  link: 'https://docs.gitstream.cm/automations/integrations/claude-code/flag-claude-code-pr',
  logo: null,
  name: 'Label Claude Code PRs - Label by Tag',
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'link_shortcut',
  category: ['quality', 'shortcut', 'project'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/shortcut/link_shortcut.cm',
  config: '* The PR contains a reference to an Shortcut card in the title or branch name.\n\nAutomation Actions:\n\n* Post a comment that provides a link to the associated Shortcut Task.\n',
  config_actions: ['Post a comment that provides a link to the associated Shortcut Task'],
  config_conditions: ['The PR contains a reference to an Shortcut card in the title or branch name'],
  config_intro: 'Provide automatic links to Shortcut tasks that are associated with PRs.',
  date: '2023-09-06T14:26:58-04:00',
  description: 'Provide automatic links to Shortcut tasks that are associated with PRs.',
  file: 'docs/automations/integrations/shortcut/link-shortcut/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/link-issue-tracker/link-issue-tracker.png',
  id: 'automatically-link-prs-to-related-shortcut-tasks',
  link: 'https://docs.gitstream.cm/automations/integrations/shortcut/link-shortcut',
  logo: 'https://docs.gitstream.cm/automations/integrations/shortcut/link-shortcut/link-shortcut.svg',
  name: 'Automatically Link PRs to Related Shortcut Tasks',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_missing_shortcut',
  category: ['quality', 'shortcut', 'project'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/shortcut/label_missing_shortcut.cm',
  config: '* The PR is missing one of the following:\n* An Shortcut ticket reference in the PR title.\n* A link to an Shortcut resource in the PR description.\n\n* Apply a red `⚠️ Missing Shortcut Link` label\n* Post a comment that asks the author to add an Shortcut reference to the PR.\n',
  config_actions: ['Apply a red `⚠️ Missing Shortcut Link` label', 'Post a comment that asks the author to add an Shortcut reference to the PR'],
  config_conditions: ['The PR is missing one of the following:', 'An Shortcut ticket reference in the PR title', 'A link to an Shortcut resource in the PR description'],
  config_intro: 'Automatically label PRs that are missing references to Shortcut resources.',
  date: '2023-09-01T12:49:00-04:00',
  description: 'Automatically label PRs that are missing references to Shortcut resources.',
  file: 'docs/automations/integrations/shortcut/label-missing-shortcut/README.md',
  image: 'https://docs.gitstream.cm/automations/label-missing-project-tracker/label-missing-project-tracker.png',
  id: 'label-missing-shortcut',
  link: 'https://docs.gitstream.cm/automations/integrations/shortcut/label-missing-shortcut',
  logo: 'https://docs.gitstream.cm/automations/integrations/shortcut/label-missing-shortcut/link-shortcut.svg',
  name: 'Label Missing Shortcut',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_ai_tools_by_checkbox',
  category: ['quality', 'genai', 'ai', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/ai-assistance/track_ai_models.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: 'Automatically apply labels to PRs based on whether they were assisted by AI tools. Developers can indicate the specific AI tools or models used, or pre-add an AI-related label to skip the prompt.',
  date: '2025-04-08T12:00:24+03:00',
  description: 'Automatically apply labels to PRs based on AI assistance.',
  file: 'docs/automations/integrations/ai-assistance/flag-ai-pr/README.md',
  image: null,
  id: 'label-ai-assisted-prs-ask-developers-about-ai-assistance',
  link: 'https://docs.gitstream.cm/automations/integrations/ai-assistance/flag-ai-pr',
  logo: null,
  name: 'Label AI-Assisted PRs - Ask Developers About AI Assistance',
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_ai_tools_by_checkbox',
  category: ['quality', 'genai', 'ai', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/ai-assistance/track_ai_models.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: 'Automatically apply labels to PRs based on whether they were assisted by AI tools. Developers can indicate the specific AI tools or models used, or pre-add an AI-related label to skip the prompt.',
  date: '2025-04-08T12:00:24+03:00',
  description: 'Automatically apply labels to PRs based on AI assistance.',
  file: 'docs/automations/integrations/ai-assistance/flag-ai-pr/README.md',
  image: null,
  id: 'label-ai-assisted-prs-skip-the-survey-for-known-users',
  link: 'https://docs.gitstream.cm/automations/integrations/ai-assistance/flag-ai-pr',
  logo: null,
  name: 'Label AI-Assisted PRs - Skip the survey for known users',
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_amazon_q_pr',
  category: ['quality', 'genai', 'amazon_q', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/amazon_q/label_amazon_q_by_prompt.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: 'Automatically apply labels to PRs that are assisted by Amazon Q. You can apply labels based on a known list of Amazon Q users, PR tags, or by prompting the PR author to indicate if they used Amazon Q.',
  date: '2025-05-08T15:09:21-07:00',
  description: 'Automatically apply labels to PRs that are assisted by Amazon Q',
  file: 'docs/automations/integrations/amazon-q/flag-amazon-q-pr/README.md',
  image: null,
  id: 'label-amazon-q-prs-label-by-prompt',
  link: 'https://docs.gitstream.cm/automations/integrations/amazon-q/flag-amazon-q-pr',
  logo: null,
  name: 'Label Amazon Q PRs - Label by Prompt',
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_amazon_q_contributors',
  category: ['quality', 'genai', 'amazon_q', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/amazon_q/label_amazon_q_by_contributors.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: 'Automatically apply labels to PRs that are assisted by Amazon Q. You can apply labels based on a known list of Amazon Q users, PR tags, or by prompting the PR author to indicate if they used Amazon Q.',
  date: '2025-05-08T15:09:21-07:00',
  description: 'Automatically apply labels to PRs that are assisted by Amazon Q',
  file: 'docs/automations/integrations/amazon-q/flag-amazon-q-pr/README.md',
  image: null,
  id: 'label-amazon-q-prs-label-by-known-users',
  link: 'https://docs.gitstream.cm/automations/integrations/amazon-q/flag-amazon-q-pr',
  logo: null,
  name: 'Label Amazon Q PRs - Label by Known Users',
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_amazon_q',
  category: ['quality', 'genai', 'amazon_q', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/amazon_q/label_amazon_q_by_tag.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: 'Automatically apply labels to PRs that are assisted by Amazon Q. You can apply labels based on a known list of Amazon Q users, PR tags, or by prompting the PR author to indicate if they used Amazon Q.',
  date: '2025-05-08T15:09:21-07:00',
  description: 'Automatically apply labels to PRs that are assisted by Amazon Q',
  file: 'docs/automations/integrations/amazon-q/flag-amazon-q-pr/README.md',
  image: null,
  id: 'label-amazon-q-prs-label-by-tag',
  link: 'https://docs.gitstream.cm/automations/integrations/amazon-q/flag-amazon-q-pr',
  logo: null,
  name: 'Label Amazon Q PRs - Label by Tag',
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_copilot_pr',
  category: ['quality', 'genai', 'copilot', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/copilot/label_copilot_by_prompt.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: 'Automatically apply labels to PRs that are assisted by GitHub Copilot. You can apply labels based on a known list of Copilot users, PR tags, or by prompting the PR author to indicate if they used Copilot.',
  date: '2023-12-14T15:11:42-05:00',
  description: 'Automatically apply labels to PRs that are assisted by GitHub Copilot',
  file: 'docs/automations/integrations/copilot/flag-copilot-pr/README.md',
  image: null,
  id: 'label-github-copilot-prs-label-by-prompt',
  link: 'https://docs.gitstream.cm/automations/integrations/copilot/flag-copilot-pr',
  logo: 'https://docs.gitstream.cm/automations/integrations/copilot/flag-copilot-pr/flag-copilot-pr.svg',
  name: 'Label GitHub Copilot PRs - Label by Prompt',
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_copilot_by_contributors',
  category: ['quality', 'genai', 'copilot', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/copilot/label_copilot_by_contributors.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: 'Automatically apply labels to PRs that are assisted by GitHub Copilot. You can apply labels based on a known list of Copilot users, PR tags, or by prompting the PR author to indicate if they used Copilot.',
  date: '2023-12-14T15:11:42-05:00',
  description: 'Automatically apply labels to PRs that are assisted by GitHub Copilot',
  file: 'docs/automations/integrations/copilot/flag-copilot-pr/README.md',
  image: null,
  id: 'label-github-copilot-prs-label-by-known-users',
  link: 'https://docs.gitstream.cm/automations/integrations/copilot/flag-copilot-pr',
  logo: 'https://docs.gitstream.cm/automations/integrations/copilot/flag-copilot-pr/flag-copilot-pr.svg',
  name: 'Label GitHub Copilot PRs - Label by Known Users',
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_copilot',
  category: ['quality', 'genai', 'copilot', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/copilot/label_copilot_by_tag.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: 'Automatically apply labels to PRs that are assisted by GitHub Copilot. You can apply labels based on a known list of Copilot users, PR tags, or by prompting the PR author to indicate if they used Copilot.',
  date: '2023-12-14T15:11:42-05:00',
  description: 'Automatically apply labels to PRs that are assisted by GitHub Copilot',
  file: 'docs/automations/integrations/copilot/flag-copilot-pr/README.md',
  image: null,
  id: 'label-github-copilot-prs-label-by-tag',
  link: 'https://docs.gitstream.cm/automations/integrations/copilot/flag-copilot-pr',
  logo: 'https://docs.gitstream.cm/automations/integrations/copilot/flag-copilot-pr/flag-copilot-pr.svg',
  name: 'Label GitHub Copilot PRs - Label by Tag',
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_copilot_pr',
  category: ['quality', 'genai', 'copilot', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/copilot/label_copilot_by_comment.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: 'Automatically apply labels to PRs that are assisted by GitHub Copilot. You can apply labels based on a known list of Copilot users, PR tags, or by prompting the PR author to indicate if they used Copilot.',
  date: '2023-12-14T15:11:42-05:00',
  description: 'Automatically apply labels to PRs that are assisted by GitHub Copilot',
  file: 'docs/automations/integrations/copilot/flag-copilot-pr/README.md',
  image: null,
  id: 'label-github-copilot-prs-label-by-copilot-code-comment',
  link: 'https://docs.gitstream.cm/automations/integrations/copilot/flag-copilot-pr',
  logo: 'https://docs.gitstream.cm/automations/integrations/copilot/flag-copilot-pr/flag-copilot-pr.svg',
  name: 'Label GitHub Copilot PRs - Label by Copilot code comment',
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_cursor_pr',
  category: ['quality', 'genai', 'cursor', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/cursor/label_cursor_by_prompt.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: "Automatically apply labels to Pull Requests that are assisted by Cursor AI. This automation helps track the impact and usage of Cursor's AI capabilities across your development workflow.",
  date: '2025-04-17T13:28:48-07:00',
  description: 'Automatically apply labels to PRs that are assisted by Cursor',
  file: 'docs/automations/integrations/cursor/flag-cursor-pr/README.md',
  image: null,
  id: 'label-cursor-prs-label-by-prompt',
  link: 'https://docs.gitstream.cm/automations/integrations/cursor/flag-cursor-pr',
  logo: null,
  name: 'Label Cursor PRs - Label by Prompt',
  quickstart: true,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_cursor_contributors',
  category: ['quality', 'genai', 'cursor', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/cursor/label_cursor_by_contributors.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: "Automatically apply labels to Pull Requests that are assisted by Cursor AI. This automation helps track the impact and usage of Cursor's AI capabilities across your development workflow.",
  date: '2025-04-17T13:28:48-07:00',
  description: 'Automatically apply labels to PRs that are assisted by Cursor',
  file: 'docs/automations/integrations/cursor/flag-cursor-pr/README.md',
  image: null,
  id: 'label-cursor-prs-label-by-known-users',
  link: 'https://docs.gitstream.cm/automations/integrations/cursor/flag-cursor-pr',
  logo: null,
  name: 'Label Cursor PRs - Label by Known Users',
  quickstart: true,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_cursor',
  category: ['quality', 'genai', 'cursor', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/cursor/label_cursor_by_tag.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: "Automatically apply labels to Pull Requests that are assisted by Cursor AI. This automation helps track the impact and usage of Cursor's AI capabilities across your development workflow.",
  date: '2025-04-17T13:28:48-07:00',
  description: 'Automatically apply labels to PRs that are assisted by Cursor',
  file: 'docs/automations/integrations/cursor/flag-cursor-pr/README.md',
  image: null,
  id: 'label-cursor-prs-label-by-tag',
  link: 'https://docs.gitstream.cm/automations/integrations/cursor/flag-cursor-pr',
  logo: null,
  name: 'Label Cursor PRs - Label by Tag',
  quickstart: true,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_ff_flagr',
  category: ['quality', 'feature-flag', 'flagr'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/flagr/label-ff-flagr/label_ff_flagr.cm',
  config: '* The PR adds one or more feature flag keys.\n\n* Label the PR for each feature flag key introduced in the PR.\n',
  config_actions: ['Label the PR for each feature flag key introduced in the PR'],
  config_conditions: ['The PR adds one or more feature flag keys'],
  config_intro: 'Automatically label code that contians specified feature flags.',
  date: '2024-01-11T16:27:55+02:00',
  description: 'Automatically label code that contians specified feature flags.',
  file: 'docs/automations/integrations/flagr/label-ff-flagr/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/flagr/label-ff-flagr/label-ff-flagr.png',
  id: 'label-prs-based-on-flagr-feature-flags',
  link: 'https://docs.gitstream.cm/automations/integrations/flagr/label-ff-flagr',
  logo: null,
  name: 'Label PRs Based on Flagr Feature Flags',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'zapier_export_pr_description_title_url',
  category: ['project', 'zapier'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/zapier/zapier_export_pr_description_title_url.cm',
  config: '* A PR is created.\n\n* gitStream sends a webhook to Zapier that contains the PR title, description, and URL.\n',
  config_actions: ['gitStream sends a webhook to Zapier that contains the PR title, description, and URL'],
  config_conditions: ['A PR is created'],
  config_intro: 'Export new PR titles, description, and URL to Zapier.',
  date: '2024-01-22T16:50:18-05:00',
  description: 'Automatically export new PR titles, description, and url to Zapier.',
  file: 'docs/automations/integrations/zapier/zapier-export-pr-description-title-url/README.md',
  image: null,
  id: 'create-project-management-tasks-via-zapier',
  link: 'https://docs.gitstream.cm/automations/integrations/zapier/zapier-export-pr-description-title-url',
  logo: 'https://docs.gitstream.cm/automations/integrations/zapier/zapier-export-pr-description-title-url/zapier-export-pr-number.svg',
  name: 'Create Project Management Tasks Via Zapier',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'zapier_export_pr_number_title_url',
  category: ['project', 'zapier'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/zapier/zapier_export_pr_number_title_url.cm',
  config: '* A PR is created.\n\n* gitStream sends the PR number, title, and URL to Zapier via webhook.\n',
  config_actions: ['gitStream sends the PR number, title, and URL to Zapier via webhook'],
  config_conditions: ['A PR is created'],
  config_intro: 'Export new PR titles, numbers, and URLs to Zapier.',
  date: '2024-01-22T16:50:18-05:00',
  description: 'Automatically export data from your git repo to Zapier.',
  file: 'docs/automations/integrations/zapier/zapier-export-pr-number-title-url/README.md',
  image: null,
  id: 'export-pr-number-title-and-url-to-zapier',
  link: 'https://docs.gitstream.cm/automations/integrations/zapier/zapier-export-pr-number-title-url',
  logo: 'https://docs.gitstream.cm/automations/integrations/zapier/zapier-export-pr-number-title-url/zapier-export-pr-number.svg',
  name: 'Export PR Number, Title, and URL to Zapier',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'zapier_export_pr_reviewers',
  category: ['zapier'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/zapier/zapier_export_pr_reviewers.cm',
  config: '* A PR is created or updated.\n\n* gitStream sends the list of reviewers to Zapier via webooks.\n',
  config_actions: ['gitStream sends the list of reviewers to Zapier via webooks'],
  config_conditions: ['A PR is created or updated'],
  config_intro: 'Automatically update Zapier with a list of PR reviewers.',
  date: '2024-01-22T16:50:18-05:00',
  description: 'Automatically export data from your git repo to Zapier.',
  file: 'docs/automations/integrations/zapier/zapier-export-pr-reviewers/README.md',
  image: null,
  id: 'auto-schedule-sync-meetings-via-zapier',
  link: 'https://docs.gitstream.cm/automations/integrations/zapier/zapier-export-pr-reviewers',
  logo: 'https://docs.gitstream.cm/automations/integrations/zapier/zapier-export-pr-reviewers/zapier-export-pr-number.svg',
  name: 'Auto-Schedule Sync Meetings via Zapier',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'zapier_export_pr_number',
  category: ['project', 'zapier'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/zapier/zapier_export_pr_number.cm',
  config: '* A PR is created.\n\n* gitStream sends a webhook to Zapier that contains the PR number\n',
  config_actions: ['gitStream sends a webhook to Zapier that contains the PR number'],
  config_conditions: ['A PR is created'],
  config_intro: 'This is an example of how to send data from gitStream to Zapier.',
  date: '2024-01-22T16:50:18-05:00',
  description: 'Automatically export data from your git repo to Zapier.',
  file: 'docs/automations/integrations/zapier/zapier-export-pr-number/README.md',
  image: null,
  id: 'export-pr-data-to-zapier',
  link: 'https://docs.gitstream.cm/automations/integrations/zapier/zapier-export-pr-number',
  logo: 'https://docs.gitstream.cm/automations/integrations/zapier/zapier-export-pr-number/zapier-export-pr-number.svg',
  name: 'Export PR Data to Zapier',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_godoc',
  category: ['docs', 'go'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/godoc/review_godoc.cm',
  config: '* The PR only contains changes to Godoc content.\n\n* Assign the org/tech-writers team for optional review.\n* Apply a green `📓 Godoc Only` label\n* Approve the PR\n',
  config_actions: ['Assign the org/tech-writers team for optional review', 'Apply a green `📓 Godoc Only` label', 'Approve the PR'],
  config_conditions: ['The PR only contains changes to Godoc content'],
  config_intro: 'Approve PRs that only contain changes to Godoc and assign optional reviewers.',
  date: '2023-09-14T15:53:22+02:00',
  description: 'Automatically approve PRs for Godoc changes.',
  file: 'docs/automations/integrations/godoc/review-godoc/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/godoc/review-godoc/review-godoc.png',
  id: 'review-godoc-changes',
  link: 'https://docs.gitstream.cm/automations/integrations/godoc/review-godoc',
  logo: 'https://docs.gitstream.cm/automations/integrations/godoc/review-godoc/review-godoc.svg',
  name: 'Review Godoc Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_godoc_large',
  category: ['docs', 'go'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/godoc/review_godoc_large.cm',
  config: '* The PR changes more than 100 lines of Golang code.\n\nAutomation Actions:\n\n* Post a comment asking the author to review all relevant Godoc to identify necessary updates.\n* Require a review from the `ORG/tech-writers` team.\n* Apply a yellow `⚠️ Missing Godoc` Label\n',
  config_actions: ['Post a comment asking the author to review all relevant Godoc to identify necessary updates', 'Require a review from the `ORG/tech-writers` team', 'Apply a yellow `⚠️ Missing Godoc` Label'],
  config_conditions: ['The PR changes more than 100 lines of Golang code'],
  config_intro: 'Require more extensive reviews for large Golang changes that lack Godoc updates.',
  date: '2023-09-15T10:49:46+02:00',
  description: 'Automatically flag large PRs that may require Godoc updates.',
  file: 'docs/automations/integrations/godoc/review-godoc-large/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/godoc/review-godoc-large/review-godoc-large.png',
  id: 'review-godoc-for-large-changes',
  link: 'https://docs.gitstream.cm/automations/integrations/godoc/review-godoc-large',
  logo: 'https://docs.gitstream.cm/automations/integrations/godoc/review-godoc-large/review-godoc.svg',
  name: 'Review Godoc for Large Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_godoc_new_class',
  category: ['docs', 'go'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/godoc/review_godoc_new_class.cm',
  config: '* The PR creates a new Golang class.\n* The PR lacks Godoc content.\n\n* Request changes and post a comment explaining that Godoc is required\n* Apply a yellow `⚠️ Missing Godoc` label.\n',
  config_actions: ['Request changes and post a comment explaining that Godoc is required', 'Apply a yellow `⚠️ Missing Godoc` label'],
  config_conditions: ['The PR creates a new Golang class', 'The PR lacks Godoc content'],
  config_intro: 'Require Godoc for all new Golang classes.',
  date: '2023-09-14T15:53:22+02:00',
  description: 'Enforce Godoc requirements for PRS that include new Golang classes.',
  file: 'docs/automations/integrations/godoc/review-godoc-new-class/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/godoc/review-godoc-new-class/review-godoc-new-class.png',
  id: 'require-godoc-for-new-golang-classes',
  link: 'https://docs.gitstream.cm/automations/integrations/godoc/review-godoc-new-class',
  logo: 'https://docs.gitstream.cm/automations/integrations/godoc/review-godoc-new-class/review-godoc.svg',
  name: 'Require Godoc for New Golang Classes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_ff_launchdarkly',
  category: ['featureflag', 'launchdarkly'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/launch-darkly/label-ff-launch-darkly/label_ff_launch_darkly.cm',
  config: '* The PR adds one or more feature flag keys.\n\n* Label the PR for each feature flag key introduced in the PR.\n',
  config_actions: ['Label the PR for each feature flag key introduced in the PR'],
  config_conditions: ['The PR adds one or more feature flag keys'],
  config_intro: 'Automatically label code that contians specified feature flags.',
  date: '2024-01-11T16:27:55+02:00',
  description: 'Automatically label code that contians specified feature flags.',
  file: 'docs/automations/integrations/launch-darkly/label-ff-launch-darkly/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/launch-darkly/label-ff-launch-darkly/label-ff-launch-darkly.png',
  id: 'label-prs-based-on-launchdarkly-feature-flags',
  link: 'https://docs.gitstream.cm/automations/integrations/launch-darkly/label-ff-launch-darkly',
  logo: 'https://docs.gitstream.cm/automations/integrations/launch-darkly/label-ff-launch-darkly/label-ff-launch-darkly.svg',
  name: 'Label PRs Based on LaunchDarkly Feature Flags',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_ff_flagsmith',
  category: ['quality', 'feature-flag', 'flagsmith'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/flagsmith/label-ff-flagsmith/label_ff_flagsmith.cm',
  config: '* The PR adds one or more feature flag keys.\n\n* Label the PR for each feature flag key introduced in the PR.\n',
  config_actions: ['Label the PR for each feature flag key introduced in the PR'],
  config_conditions: ['The PR adds one or more feature flag keys'],
  config_intro: 'Automatically label code that contians specified feature flags.',
  date: '2024-01-11T16:27:55+02:00',
  description: 'Automatically label code that contians specified feature flags.',
  file: 'docs/automations/integrations/flagsmith/label-ff-flagsmith/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/flagsmith/label-ff-flagsmith/label-ff-flagsmith.png',
  id: 'label-prs-based-on-flagsmith-feature-flags',
  link: 'https://docs.gitstream.cm/automations/integrations/flagsmith/label-ff-flagsmith',
  logo: null,
  name: 'Label PRs Based on Flagsmith Feature Flags',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'ask_ai_review',
  category: ['quality', 'genai', 'copilot', 'tests', 'efficiency'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/askAI/askAI_CR.cm',
  config: '* A PR is created or new code has been committed to the PR.\n* The PR has a label "askai cr"\n\n* Add a comment with a code review generated by an AI model\n',
  config_actions: ['Add a comment with a code review generated by an AI model'],
  config_conditions: ['A PR is created or new code has been committed to the PR', 'The PR has a label "askai cr"'],
  config_intro: 'Use AI to perform a comprehensive code review, identify bugs, security risks, performance issues, deprecated methods, and style guide violations, and suggests improvements.',
  date: '2024-09-08T12:47:58+03:00',
  description: "Use gitStream's integration with AI services to perform a comprehensive code review to your code",
  file: 'docs/automations/integrations/askAI/code-review/README.md',
  image: null,
  id: 'ask-ai-for-a-code-review',
  link: 'https://docs.gitstream.cm/automations/integrations/askAI/code-review',
  logo: 'https://docs.gitstream.cm/automations/integrations/askAI/code-review/askAI-cr.svg',
  name: 'Ask AI for a Code Review',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'ask_ai_tests',
  category: ['quality', 'genai', 'copilot', 'tests', 'efficiency'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/askAI/askAI_tests.cm',
  config: '* A PR is created or new code has been committed to the PR.\n* The PR has a label "askai tests"\n\n* Add a comment with suggested tests generated by an AI model\n',
  config_actions: ['Add a comment with suggested tests generated by an AI model'],
  config_conditions: ['A PR is created or new code has been committed to the PR', 'The PR has a label "askai tests"'],
  config_intro: 'Use AI to suggests additional test cases for uncovered or modified functions in the PR, including edge cases.',
  date: '2024-09-08T12:47:58+03:00',
  description: "Use gitStream's integration with AI services to suggests additional tests",
  file: 'docs/automations/integrations/askAI/add-tests/README.md',
  image: null,
  id: 'ask-ai-to-suggest-tests',
  link: 'https://docs.gitstream.cm/automations/integrations/askAI/add-tests',
  logo: 'https://docs.gitstream.cm/automations/integrations/askAI/add-tests/askAI-tests.svg',
  name: 'Ask AI to Suggest Tests',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'ask_ai_document',
  category: ['quality', 'genai', 'copilot', 'tests', 'efficiency'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/askAI/askAI_document.cm',
  config: '* A PR is created, or new code has been committed to the PR.\n* The PR has a label "askai document"\n\n* Add a comment with a summary of the PR\n',
  config_actions: ['Add a comment with a summary of the PR'],
  config_conditions: ['A PR is created, or new code has been committed to the PR', 'The PR has a label "askai document"'],
  config_intro: 'Use AI to generate documentation for the newly added features and changes based on the code diff.',
  date: '2024-09-08T12:47:58+03:00',
  description: "Use gitStream's integration with AI services to generate conscious documentation of the changes in the PR.",
  file: 'docs/automations/integrations/askAI/document/README.md',
  image: null,
  id: 'ask-ai-to-provide-pr-documentation',
  link: 'https://docs.gitstream.cm/automations/integrations/askAI/document',
  logo: 'https://docs.gitstream.cm/automations/integrations/askAI/document/askAI-document.svg',
  name: 'Ask AI to provide PR documentation',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'ask_ai_summarize',
  category: ['quality', 'genai', 'copilot', 'tests', 'efficiency'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/askAI/askAI_summarize.cm',
  config: '* A PR is created or new code has been committed to the PR.\n* The PR has a label "askai summarize"\n\n* Add a comment with a summary of the PR\n',
  config_actions: ['Add a comment with a summary of the PR'],
  config_conditions: ['A PR is created or new code has been committed to the PR', 'The PR has a label "askai summarize"'],
  config_intro: 'Use AI to generate a concise bullet-point summary of the changes in the pull request.',
  date: '2024-09-08T12:47:58+03:00',
  description: "Use gitStream's integration with AI services to generate a summary of the changes in the PR.",
  file: 'docs/automations/integrations/askAI/summarize-pr/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/askAI/summarize-pr/summarized-pr.png',
  id: 'ask-ai-to-summarize-the-changes-in-a-pr',
  link: 'https://docs.gitstream.cm/automations/integrations/askAI/summarize-pr',
  logo: 'https://docs.gitstream.cm/automations/integrations/askAI/summarize-pr/askAI-summarize.svg',
  name: 'Ask AI to Summarize the Changes in a PR',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'ask_ai_improve',
  category: ['quality', 'genai', 'copilot', 'tests', 'efficiency'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/askAI/askAI_improve.cm',
  config: '* A PR is created, or a new code has been committed to the PR.\n* The PR has a label "askai improve"\n\n* Add a comment with improvement suggestions for the added code\n',
  config_actions: ['Add a comment with improvement suggestions for the added code'],
  config_conditions: ['A PR is created, or a new code has been committed to the PR', 'The PR has a label "askai improve"'],
  config_intro: 'Use AI to generate suggestions for improvement in the code changes.',
  date: '2024-09-08T12:47:58+03:00',
  description: "Use gitStream's integration with AI services to generate code suggestions to improve the PR.",
  file: 'docs/automations/integrations/askAI/improve/README.md',
  image: null,
  id: 'ask-ai-for-code-suggestions-to-improve-the-pr',
  link: 'https://docs.gitstream.cm/automations/integrations/askAI/improve',
  logo: 'https://docs.gitstream.cm/automations/integrations/askAI/improve/askAI-improve.svg',
  name: 'Ask AI for code suggestions to improve the PR',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_jsdoc_large',
  category: ['docs', 'javascript'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/jsdoc/review_jsdoc_large.cm',
  config: '* The PR changes more than 25% of a JavaScript class.\n\nAutomation Actions:\n\n* Post a comment asking the author to review all relevant JSDoc to identify necessary updates.\n* Require a review from the `ORG/tech-writers` team.\n* Apply a yellow `⚠️ Missing JSDoc` Label\n',
  config_actions: ['Post a comment asking the author to review all relevant JSDoc to identify necessary updates', 'Require a review from the `ORG/tech-writers` team', 'Apply a yellow `⚠️ Missing JSDoc` Label'],
  config_conditions: ['The PR changes more than 25% of a JavaScript class'],
  config_intro: 'Require more extensive reviews for large JavaScript changes that lack JSDoc updates.',
  date: '2023-07-24T13:50:33-04:00',
  description: 'Automatically flag large PRs that may require JSDoc updates.',
  file: 'docs/automations/integrations/jsdoc/review-jsdoc-large/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/jsdoc/review-jsdoc-large/review-jsdoc-large.png',
  id: 'review-jsdoc-for-large-changes',
  link: 'https://docs.gitstream.cm/automations/integrations/jsdoc/review-jsdoc-large',
  logo: 'https://docs.gitstream.cm/automations/integrations/jsdoc/review-jsdoc-large/review-jsdoc-input.svg',
  name: 'Review JSDoc for Large Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_jsdoc_input',
  category: ['docs', 'javascript'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/jsdoc/review_jsdoc_input.cm',
  config: '* The PR changes an input parameter in one or more JavaScript methods.\n* The PR lacks changes to ‘@param’ declarations.\n\nAutomation Actions:\n\n* Post a comment warning the user to review the method’s JSDoc to identify necessary updates.\n',
  config_actions: ['Post a comment warning the user to review the method’s JSDoc to identify necessary updates'],
  config_conditions: ['The PR changes an input parameter in one or more JavaScript methods', 'The PR lacks changes to ‘@param’ declarations'],
  config_intro: 'Warn PR authors when they change JavaScript function or constructor input parameters without updating JSDoc content.',
  date: '2023-07-24T13:50:33-04:00',
  description: 'Automatically flag PRs that may require JSDoc updates.',
  file: 'docs/automations/integrations/jsdoc/review-jsdoc-input/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/jsdoc/review-jsdoc-input/review-jsdoc-input.png',
  id: 'review-jsdoc-input-parameters',
  link: 'https://docs.gitstream.cm/automations/integrations/jsdoc/review-jsdoc-input',
  logo: 'https://docs.gitstream.cm/automations/integrations/jsdoc/review-jsdoc-input/review-jsdoc-input.svg',
  name: 'Review JSDoc Input Parameters',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_jsdoc_new_class',
  category: ['docs', 'javascript'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/jsdoc/review_jsdoc_new_class.cm',
  config: '* The PR creates a new JavaScript class.\n* The PR lacks JSDoc content.\n\nAutomation Actions:\n\n* Request changes and post a comment explaining that JSDoc is required\n* Apply a yellow `⚠️ Missing JSDoc` label.\n',
  config_actions: ['Request changes and post a comment explaining that JSDoc is required', 'Apply a yellow `⚠️ Missing JSDoc` label'],
  config_conditions: ['The PR creates a new JavaScript class', 'The PR lacks JSDoc content'],
  config_intro: 'Require JSDoc for all new JavaScript classes.',
  date: '2023-07-24T13:50:33-04:00',
  description: 'Enforce JSDoc requirements for PRs.',
  file: 'docs/automations/integrations/jsdoc/review-jsdoc-new-class/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/jsdoc/review-jsdoc-new-class/review-jsdoc-new-class.png',
  id: 'enforce-jsdoc-for-new-javascript-classes',
  link: 'https://docs.gitstream.cm/automations/integrations/jsdoc/review-jsdoc-new-class',
  logo: 'https://docs.gitstream.cm/automations/integrations/jsdoc/review-jsdoc-new-class/review-jsdoc-input.svg',
  name: 'Enforce JSDoc for New JavaScript Classes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_jsdoc',
  category: ['docs', 'javascript'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/jsdoc/review_jsdoc.cm',
  config: '* The PR only affects JavaScript and TypeScript files\n* The PR only contains changes to JSDoc content.\n\nAutomation Actions:\n\n* Assign the `ORG/tech-writers` team.\n* Apply a green `📓 JSDoc Only label`\n* Approve the PR\n',
  config_actions: ['Assign the `ORG/tech-writers` team', 'Apply a green `📓 JSDoc Only label`', 'Approve the PR'],
  config_conditions: ['The PR only affects JavaScript and TypeScript files', 'The PR only contains changes to JSDoc content'],
  config_intro: 'Approve PRs that only contain changes to JSDoc and assign optional reviewers.',
  date: '2023-07-24T13:50:33-04:00',
  description: 'Automatically approve PRs for JSDoc changes.',
  file: 'docs/automations/integrations/jsdoc/review-jsdoc/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/jsdoc/review-jsdoc/review-jsdoc.png',
  id: 'review-jsdoc-changes',
  link: 'https://docs.gitstream.cm/automations/integrations/jsdoc/review-jsdoc',
  logo: 'https://docs.gitstream.cm/automations/integrations/jsdoc/review-jsdoc/review-jsdoc-input.svg',
  name: 'Review JSDoc Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_sonar_alerts',
  category: ['security', 'sonarcloud'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/sonar/review_sonar_alerts.cm',
  config: '* The SonarCloud quality gate check fails to pass for code smells, vulnerabilities, or security hotspots.\n\nAutomation Actions:\n\n* Require a review from the `my-organization/security-team` team. Customize this to match your organization.\n* Post a comment explaining why this PR requires additional review.\n',
  config_actions: ['Require a review from the `my-organization/security-team` team. Customize this to match your organization', 'Post a comment explaining why this PR requires additional review'],
  config_conditions: ['The SonarCloud quality gate check fails to pass for code smells, vulnerabilities, or security hotspots'],
  config_intro: 'Require additional reviews for Sonar security alerts. gitStream will remove this requirement if the alerts are resolved.',
  date: '2023-05-23T14:54:34-04:00',
  description: 'Automatically flag SonarCloud security alerts for additional review.',
  file: 'docs/automations/integrations/sonar/review-sonar-alerts/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/sonar/review-sonar-alerts/review-sonar-alerts.png',
  id: 'review-sonarcloud-security-alerts',
  link: 'https://docs.gitstream.cm/automations/integrations/sonar/review-sonar-alerts',
  logo: 'https://docs.gitstream.cm/automations/integrations/sonar/review-sonar-alerts/review-sonar-alerts.svg',
  name: 'Review SonarCloud Security Alerts',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_sonar_duplications',
  category: ['security', 'sonarcloud'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/sonar/review_sonar_duplications.cm',
  config: '* The PR contains more than 3% duplicated code.\n\nAutomation Actions:\n\n* Apply a label that indicates how much duplicated code Sonar detected.\n* Request changes and post a comment explaining why.\n',
  config_actions: ['Apply a label that indicates how much duplicated code Sonar detected', 'Request changes and post a comment explaining why'],
  config_conditions: ['The PR contains more than 3% duplicated code'],
  config_intro: 'Request changes when Sonar reports an excessive level of duplicated code.',
  date: '2023-05-23T14:54:34-04:00',
  description: 'Automatically request changes when SonarCloud detects duplicated code.',
  file: 'docs/automations/integrations/sonar/review-sonar-duplications/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/sonar/review-sonar-duplications/review-sonar-duplications.png',
  id: 'review-sonarcloud-duplications',
  link: 'https://docs.gitstream.cm/automations/integrations/sonar/review-sonar-duplications',
  logo: 'https://docs.gitstream.cm/automations/integrations/sonar/review-sonar-duplications/review-sonar-alerts.svg',
  name: 'Review SonarCloud Duplications',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'approve_sonar_clean_code',
  category: ['security', 'sonarcloud'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/sonar/approve_sonar_clean_code.cm',
  config: "* SonarCloud reports an 'A' rating for vulnerabilities, bugs, security hotspots, and code smells.\n* There is no duplicated code.\n\nAutomation Actions:\n\n* Apply a `Sonar: Clean Code` label to the PR.\n* Approve the PR.\n* Post a comment that explains why the PR was approved.\n",
  config_actions: ['Apply a `Sonar: Clean Code` label to the PR', 'Approve the PR', 'Post a comment that explains why the PR was approved'],
  config_conditions: ["SonarCloud reports an 'A' rating for vulnerabilities, bugs, security hotspots, and code smells", 'There is no duplicated code'],
  config_intro: "Approve PRs that pass SonarCloud's quality gate.",
  date: '2023-05-23T14:54:34-04:00',
  description: "Automatically approve PRs that pass SonarCloud's quality gate.",
  file: 'docs/automations/integrations/sonar/approve-sonar-clean-code/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/sonar/approve-sonar-clean-code/approve-sonar-clean-code.png',
  id: 'approve-sonarcloud-clean-code',
  link: 'https://docs.gitstream.cm/automations/integrations/sonar/approve-sonar-clean-code',
  logo: 'https://docs.gitstream.cm/automations/integrations/sonar/approve-sonar-clean-code/review-sonar-alerts.svg',
  name: 'Approve SonarCloud Clean Code',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_sonar',
  category: ['security', 'sonarcloud'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/sonar/label_sonar.cm',
  config: '* There is at least one vulnerability, code smell, security hotspot, or bug reported by SonarCloud. Uses the [`extractSonarFindings`](https://docs.gitstream.cm/filter-functions/#extractsonarfindings) filter function\n\nAutomation Actions:\n\n* Apply color-coded labels to indicate the number of vulnerabilities, code smells, security hotspots, and bugs.\n',
  config_actions: ['Apply color-coded labels to indicate the number of vulnerabilities, code smells, security hotspots, and bugs'],
  config_conditions: ['There is at least one vulnerability, code smell, security hotspot, or bug reported by SonarCloud. Uses the [`extractSonarFindings`](https://docs.gitstream.cm/filter-functions/#extractsonarfindings) filter function'],
  config_intro: 'Label the number of bugs, vulnerabilities, security hotspots, and code smells reported by SonarCloud.',
  date: '2023-05-23T14:54:34-04:00',
  description: 'Automatically label PRs with SonarCloud insights.',
  file: 'docs/automations/integrations/sonar/label-sonar/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/sonar/label-sonar/label-sonar.png',
  id: 'label-sonarcloud-quality-reports',
  link: 'https://docs.gitstream.cm/automations/integrations/sonar/label-sonar',
  logo: 'https://docs.gitstream.cm/automations/integrations/sonar/label-sonar/review-sonar-alerts.svg',
  name: 'Label SonarCloud Quality Reports',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'approve_snyk',
  category: ['security', 'snyk'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/snyk/approve-snyk/approve_snyk.cm',
  config: '* The PR author is Snyk.\n\n* Approve the PR\n* Apply an `approved-snyk` label to the PR\n* Merge the PR if all status checks pass.\n',
  config_actions: ['Approve the PR', 'Apply an `approved-snyk` label to the PR', 'Merge the PR if all status checks pass'],
  config_conditions: ['The PR author is Snyk'],
  config_intro: 'Approve PRs from Snyk',
  date: '2024-01-16T12:43:49+02:00',
  description: 'Automatically approve and merge Snyk PRs.',
  file: 'docs/automations/integrations/snyk/approve-snyk/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/snyk/approve-snyk/approve-snyk.png',
  id: 'approve-and-merge-snyk-changes',
  link: 'https://docs.gitstream.cm/automations/integrations/snyk/approve-snyk',
  logo: 'https://docs.gitstream.cm/automations/integrations/snyk/approve-snyk/approve-snyk.svg',
  name: 'Approve and Merge Snyk Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'jira_change_status',
  category: ['project', 'project', 'jira'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/jira/jira_change_status.cm',
  config: '* A PR is created that references a Jira ticket in the title or description.\n\nAutomation Actions:\n\n* Make an HTTP request to a Jira webhook that is pre-configured to update the ticket status.\n',
  config_actions: ['Make an HTTP request to a Jira webhook that is pre-configured to update the ticket status'],
  config_conditions: ['A PR is created that references a Jira ticket in the title or description'],
  config_intro: 'Automatically update the status of Jira tickets when a PR is opened.',
  date: '2024-05-03T16:18:53-04:00',
  description: 'Automatically update the status of Jira tickets when a PR is opened.',
  file: 'docs/automations/integrations/jira/jira-change-status/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/jira/jira-change-status/jira-change-status-jira.png',
  id: 'automatic-jira-status-updates',
  link: 'https://docs.gitstream.cm/automations/integrations/jira/jira-change-status',
  logo: 'https://docs.gitstream.cm/automations/integrations/jira/jira-change-status/jira_update.svg',
  name: 'Automatic Jira Status Updates',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'jira_update_field',
  category: [],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/jira/jira_update_field.cm',
  config: '* A PR is created that contains a Jira ticket reference in the title or branch name.\n\nAutomation Actions:\n\n* Send a webhook to Jira containing metadata to add to the Issue.\n',
  config_actions: ['Send a webhook to Jira containing metadata to add to the Issue'],
  config_conditions: ['A PR is created that contains a Jira ticket reference in the title or branch name'],
  config_intro: 'Automatically update Jira tickets with pull request information. You can modify this to send any PR metadata to Jira.',
  date: '2024-05-03T16:18:53-04:00',
  description: 'Automatically update Jira tickets with pull request information.',
  file: 'docs/automations/integrations/jira/jira-update-field/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/jira/jira-update-field/jira-update-field-jira.png',
  id: 'automatic-jira-updates',
  link: 'https://docs.gitstream.cm/automations/integrations/jira/jira-update-field',
  logo: 'https://docs.gitstream.cm/automations/integrations/jira/jira-update-field/jira_update.svg',
  name: 'Automatic Jira Updates',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'automatic_jira_task',
  category: ['quality', 'project', 'jira'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/jira/create_jira_issue.cm',
  config: '* The PR description contains the text `- [x] Auto-create Jira Issue`\n* No existing Jira issues reference the PRs URL.\n\nAutomation Actions:\n\n* Send an HTTP request to create a new Jira issue.\n',
  config_actions: ['Send an HTTP request to create a new Jira issue'],
  config_conditions: ['The PR description contains the text `- [x] Auto-create Jira Issue`', 'No existing Jira issues reference the PRs URL'],
  config_intro: 'Automatically create Jira tickets for new pull/merge requests.',
  date: '2024-05-03T16:18:53-04:00',
  description: 'Automatically create Jira issues for new PRs.',
  file: 'docs/automations/integrations/jira/create-jira-issue/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/jira/create-jira-issue/create-jira-issue-jira.png',
  id: 'automatically-create-jira-issues',
  link: 'https://docs.gitstream.cm/automations/integrations/jira/create-jira-issue',
  logo: 'https://docs.gitstream.cm/automations/integrations/jira/create-jira-issue/jira_create.svg',
  name: 'Automatically Create Jira Issues',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_missing_jira_info',
  category: ['project', 'jira', 'quality', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/jira/label_missing_jira_info.cm',
  config: '* The PR lacks a Jira ticket number in the title, or a link to a Jira ticket in the PR description.\n\nAutomation Actions:\n\n* Apply a `missing-jira` label.\n',
  config_actions: ['Apply a `missing-jira` label'],
  config_conditions: ['The PR lacks a Jira ticket number in the title, or a link to a Jira ticket in the PR description'],
  config_intro: "Label PRs that don't reference a Jira ticket in the title or description. This uses regex to detect Jira ticket formats in the title (e.g. ABC-1234), and URLs to Jira tickets in the description.",
  date: '2023-05-02T16:30:21-04:00',
  description: 'Automatically flag PRs that are missing required references to Jira issues.',
  file: 'docs/automations/integrations/jira/label-missing-jira-info/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/jira/label-missing-jira-info/label_missing_jira_info.png',
  id: 'label-missing-jira-info',
  link: 'https://docs.gitstream.cm/automations/integrations/jira/label-missing-jira-info',
  logo: 'https://docs.gitstream.cm/automations/integrations/jira/label-missing-jira-info/label_missing_jira_info.svg',
  name: 'Label Missing Jira Info',
  quickstart: true,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'jira_assign',
  category: [],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/jira/jira_assign.cm',
  config: '* The PR description contains the slash command: `/gitstream assign-jira` followed by a Jira username.\n\nAutomation Actions:\n\n* Trigger a Jira webhook to update the assignee field with the username provided in the slash command.\n',
  config_actions: ['Trigger a Jira webhook to update the assignee field with the username provided in the slash command'],
  config_conditions: ['The PR description contains the slash command: `/gitstream assign-jira` followed by a Jira username'],
  config_intro: 'Automatically assign Jira tickets based on code review actions.',
  date: '2024-05-03T16:18:53-04:00',
  description: 'Automatically assign Jira tickets based on code review actions.',
  file: 'docs/automations/integrations/jira/jira-assign/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/jira/jira-assign/jira-assign-jira.png',
  id: 'automatically-assign-jira-tickets',
  link: 'https://docs.gitstream.cm/automations/integrations/jira/jira-assign',
  logo: 'https://docs.gitstream.cm/automations/integrations/jira/jira-assign/jira_assign.svg',
  name: 'Automatically Assign Jira Tickets',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'link_jira',
  category: ['quality', 'project', 'jira'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/jira/link_jira.cm',
  config: '* The PR contains a reference to an Jira card in the title or branch name.\n\nAutomation Actions:\n\n* Post a comment that provides a link to the associated Jira Card.\n',
  config_actions: ['Post a comment that provides a link to the associated Jira Card'],
  config_conditions: ['The PR contains a reference to an Jira card in the title or branch name'],
  config_intro: 'Provide automatic links to Jira issues that are associated with PRs.',
  date: '2023-09-06T14:26:58-04:00',
  description: 'Provide automatic links to Jira issues that are associated with PRs.',
  file: 'docs/automations/integrations/jira/link-jira/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/link-issue-tracker/link-issue-tracker.png',
  id: 'automatically-link-prs-to-related-jira-issues',
  link: 'https://docs.gitstream.cm/automations/integrations/jira/link-jira',
  logo: 'https://docs.gitstream.cm/automations/integrations/jira/link-jira/link_jira.svg',
  name: 'Automatically Link PRs to Related Jira Issues',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_jit',
  category: ['security', 'jit'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/jit/label_jit_alerts.cm',
  config: '* Jit reports one or more high, medium, or low risk security vulnerabilities for the PR.\n\nAutomation Actions:\n\n* Apply labels to indicate the number of each type of vulnerability\n',
  config_actions: ['Apply labels to indicate the number of each type of vulnerability'],
  config_conditions: ['Jit reports one or more high, medium, or low risk security vulnerabilities for the PR'],
  config_intro: 'Label the number of high, medium, and low risk vulnerabilities Jit reports for PRs.',
  date: '2023-05-26T09:58:02-04:00',
  description: 'Automatically label PRs with Jit findings.',
  file: 'docs/automations/integrations/jit/label-jit-alerts/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/jit/label-jit-alerts/label-jit-alerts.png',
  id: 'label-jit-alerts',
  link: 'https://docs.gitstream.cm/automations/integrations/jit/label-jit-alerts',
  logo: 'https://docs.gitstream.cm/automations/integrations/jit/label-jit-alerts/review-jit-alerts.svg',
  name: 'Label Jit Alerts',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_jit_secret',
  category: ['security', 'jit'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/jit/review_jit_secret.cm',
  config: '* Jit detects a secret in the PR.\n\n* Close the PR\n* Post a comment explaining why this action was taken and to outline the necessary steps to remedy the situation.\n',
  config_actions: ['Close the PR', 'Post a comment explaining why this action was taken and to outline the necessary steps to remedy the situation'],
  config_conditions: ['Jit detects a secret in the PR'],
  config_intro: 'Close PRs where Jit detects a secret and post a comment explaining steps to remedy the situation.',
  date: '2023-05-26T09:58:02-04:00',
  description: 'Automatically block PRs that contain secrets.',
  file: 'docs/automations/integrations/jit/review-jit-secret/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/jit/review-jit-secret/review-jit-secret.png',
  id: 'review-jit-secret-detection',
  link: 'https://docs.gitstream.cm/automations/integrations/jit/review-jit-secret',
  logo: 'https://docs.gitstream.cm/automations/integrations/jit/review-jit-secret/review-jit-alerts.svg',
  name: 'Review Jit Secret Detection',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_jit_ignore_accept',
  category: ['security', 'jit'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/jit/review_jit_ignore_accept.cm',
  config: '* Someone [ignores and accepts](https://docs.jit.io/docs/ongoing-monitoring-of-pull-requests#the-developer-addresses-the-finding) a Jit finding\n\n* Request review from the organization’s security team.\n* Label the PR to indicate someone accepted the risk of a Jit security alert.\n* Post a comment explaining why this action was taken.\n',
  config_actions: ['Request review from the organization’s security team', 'Label the PR to indicate someone accepted the risk of a Jit security alert', 'Post a comment explaining why this action was taken'],
  config_conditions: ['Someone [ignores and accepts](https://docs.jit.io/docs/ongoing-monitoring-of-pull-requests#the-developer-addresses-the-finding) a Jit finding'],
  config_intro: 'Notify your Security team when someone ignores a Jit vulnerability report and accepts the risk.',
  date: '2023-05-26T09:58:02-04:00',
  description: 'Automatically notify your security team when someone ignores Jit vulnerabilities.',
  file: 'docs/automations/integrations/jit/review-jit-ignore-accept/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/jit/review-jit-ignore-accept/review-jit-ignore-accept.png',
  id: 'review-jit-ignore-and-accept',
  link: 'https://docs.gitstream.cm/automations/integrations/jit/review-jit-ignore-accept',
  logo: 'https://docs.gitstream.cm/automations/integrations/jit/review-jit-ignore-accept/review-jit-alerts.svg',
  name: 'Review Jit Ignore and Accept',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_jit_high_alerts',
  category: ['security', 'jit'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/jit/review_jit_alerts.cm',
  config: '* Jit reports one or more high vulnerabilities for the PR\n* Require a review from the organization’s security team.\n* Require 2 reviewers.\n* Post a comment explaining why this action was taken.\n\n**Review Jit Medium Alerts**\n\n* Conditions (all must be true):\n* Jit reports one or more medium vulnerabilities for the PR\n* Automation Actions:\n* Require 2 reviewers\n* Post a comment explaining why this action was taken.\n',
  config_actions: ['Require a review from the organization’s security team', 'Require 2 reviewers', 'Post a comment explaining why this action was taken', 'Review Jit Medium Alerts**', 'Conditions (all must be true):', 'Jit reports one or more medium vulnerabilities for the PR', 'Automation Actions:', 'Require 2 reviewers', 'Post a comment explaining why this action was taken'],
  config_conditions: ['Jit reports one or more high vulnerabilities for the PR'],
  config_intro: 'Manage review assignment for high and medium risk Jit security alerts.',
  date: '2023-05-26T09:58:02-04:00',
  description: 'Automatically assign PR reviewers for Jit security alerts.',
  file: 'docs/automations/integrations/jit/review-jit-alerts/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/jit/review-jit-alerts/review-jit-alerts.png',
  id: 'review-jit-security-alerts',
  link: 'https://docs.gitstream.cm/automations/integrations/jit/review-jit-alerts',
  logo: 'https://docs.gitstream.cm/automations/integrations/jit/review-jit-alerts/review-jit-alerts.svg',
  name: 'Review Jit Security Alerts',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'send_teams_security',
  category: ['devex', 'msteams'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/teams/teams_send_notification.cm',
  config: '* The PR meets one or more of the specified trigger criteria for MS Teams notifications.\n\n* Post an MS Teams message based on the contents of the PR.\n',
  config_actions: ['Post an MS Teams message based on the contents of the PR'],
  config_conditions: ['The PR meets one or more of the specified trigger criteria for MS Teams notifications'],
  config_intro: 'Automatically send Slack notifications to specific channels based on the contents of a pull request.',
  date: '2024-01-23T15:22:13-05:00',
  description: 'Automatically send Slack notifications to specific channels based on the contents of a pull request.',
  file: 'docs/automations/integrations/teams/teams-send-notification/README.md',
  image: null,
  id: 'automatically-notify-ms-teams-channels',
  link: 'https://docs.gitstream.cm/automations/integrations/teams/teams-send-notification',
  logo: 'https://docs.gitstream.cm/automations/integrations/teams/teams-send-notification/teams-send-notification.svg',
  name: 'Automatically Notify MS Teams Channels',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'teams_auto_recognition',
  category: ['devex', 'msteams'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/teams/teams_auto_recognition.cm',
  config: '* The PR contains updates to tests.\n* The PR has fewer than 5 modified files.\n* The PR branch references a Jira ticket.\n* The PR has fewer than 150 lines of code changed.\n\n* Post an MS Teams message that automatically recognizes the PR author and provides a link to the PR.\n',
  config_actions: ['Post an MS Teams message that automatically recognizes the PR author and provides a link to the PR'],
  config_conditions: ['The PR contains updates to tests', 'The PR has fewer than 5 modified files', 'The PR branch references a Jira ticket', 'The PR has fewer than 150 lines of code changed'],
  config_intro: 'Automatically post positive recognition messages in MS Teams for well-structured PRs.',
  date: '2024-01-23T15:22:13-05:00',
  description: 'Automatically post positive recognition messages in MS Teams for well-structured PRs.',
  file: 'docs/automations/integrations/teams/teams-auto-recognition/README.md',
  image: null,
  id: 'automatic-ms-teams-notifications',
  link: 'https://docs.gitstream.cm/automations/integrations/teams/teams-auto-recognition',
  logo: 'https://docs.gitstream.cm/automations/integrations/teams/teams-auto-recognition/teams-auto-recognition.svg',
  name: 'Automatic MS Teams Notifications',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_windsurf_pr',
  category: ['quality', 'genai', 'windsurf', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/windsurf/label_windsurf_by_prompt.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: 'Automatically apply labels to PRs that are assisted by Windsurf. You can apply labels based on a known list of Windsurf users, PR tags, or by prompting the PR author to indicate if they used Windsurf.',
  date: '2025-05-01T13:27:06-07:00',
  description: 'Automatically apply labels to PRs that are assisted by Windsurf',
  file: 'docs/automations/integrations/windsurf/flag-windsurf-pr/README.md',
  image: null,
  id: 'label-windsurf-prs-label-by-prompt',
  link: 'https://docs.gitstream.cm/automations/integrations/windsurf/flag-windsurf-pr',
  logo: null,
  name: 'Label Windsurf PRs - Label by Prompt',
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_windsurf_contributors',
  category: ['quality', 'genai', 'windsurf', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/windsurf/label_windsurf_by_contributors.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: 'Automatically apply labels to PRs that are assisted by Windsurf. You can apply labels based on a known list of Windsurf users, PR tags, or by prompting the PR author to indicate if they used Windsurf.',
  date: '2025-05-01T13:27:06-07:00',
  description: 'Automatically apply labels to PRs that are assisted by Windsurf',
  file: 'docs/automations/integrations/windsurf/flag-windsurf-pr/README.md',
  image: null,
  id: 'label-windsurf-prs-label-by-known-users',
  link: 'https://docs.gitstream.cm/automations/integrations/windsurf/flag-windsurf-pr',
  logo: null,
  name: 'Label Windsurf PRs - Label by Known Users',
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_windsurf',
  category: ['quality', 'genai', 'windsurf', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/windsurf/label_windsurf_by_tag.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: 'Automatically apply labels to PRs that are assisted by Windsurf. You can apply labels based on a known list of Windsurf users, PR tags, or by prompting the PR author to indicate if they used Windsurf.',
  date: '2025-05-01T13:27:06-07:00',
  description: 'Automatically apply labels to PRs that are assisted by Windsurf',
  file: 'docs/automations/integrations/windsurf/flag-windsurf-pr/README.md',
  image: null,
  id: 'label-windsurf-prs-label-by-tag',
  link: 'https://docs.gitstream.cm/automations/integrations/windsurf/flag-windsurf-pr',
  logo: null,
  name: 'Label Windsurf PRs - Label by Tag',
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'slack_auto_recognition',
  category: ['devex', 'slack'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/slack/slack_auto_recognition.cm',
  config: '* The PR contains updates to tests.\n* The PR has fewer than 5 modified files.\n* The PR branch references a Jira ticket.\n* The PR has fewer than 150 lines of code changed.\n\n* Post a Slack message that automatically recognizes the PR author and provides a link to the PR.\n',
  config_actions: ['Post a Slack message that automatically recognizes the PR author and provides a link to the PR'],
  config_conditions: ['The PR contains updates to tests', 'The PR has fewer than 5 modified files', 'The PR branch references a Jira ticket', 'The PR has fewer than 150 lines of code changed'],
  config_intro: 'Automatically post positive recognition messages in Slack for well-structured PRs.',
  date: '2024-01-22T14:14:14-05:00',
  description: 'Automatically post positive recognition messages in Slack for well-structured PRs.',
  file: 'docs/automations/integrations/slack/slack-auto-recognition/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/slack/slack-auto-recognition/slack-auto-recognition.png',
  id: 'automatic-slack-messages',
  link: 'https://docs.gitstream.cm/automations/integrations/slack/slack-auto-recognition',
  logo: 'https://docs.gitstream.cm/automations/integrations/slack/slack-auto-recognition/slack-auto-recognition.svg',
  name: 'Automatic Slack Messages',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'send_slack_security',
  category: ['devex', 'slack'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/slack/slack_send_notification.cm',
  config: '* The PR meets one or more of the specified trigger criteria for Slack notifications.\n\n* Post a Slack message based on the contents of the PR.\n',
  config_actions: ['Post a Slack message based on the contents of the PR'],
  config_conditions: ['The PR meets one or more of the specified trigger criteria for Slack notifications'],
  config_intro: 'Automatically send Slack notifications to specific channels based on the contents of a pull request.',
  date: '2024-01-22T14:14:14-05:00',
  description: 'Automatically send Slack notifications from your git repos with gitStream.',
  file: 'docs/automations/integrations/slack/slack-send-notification/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/slack/slack-send-notification/slack-send-notification.png',
  id: 'send-slack-notifications',
  link: 'https://docs.gitstream.cm/automations/integrations/slack/slack-send-notification',
  logo: 'https://docs.gitstream.cm/automations/integrations/slack/slack-send-notification/slack-auto-recognition.svg',
  name: 'Send Slack Notifications',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'approve_swimm_changes',
  category: ['quality', 'docs', 'swimm'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/swimm/approve_swimm.cm',
  config: '* The PR only affects files that end in a `.swm` extension.\n\nAutomation Actions:\n\n* Add a `swimm-docs-only` label\n* Approve the PR\n* Post a comment that explains that this is a Swimm docs change only.\n',
  config_actions: ['Add a `swimm-docs-only` label', 'Approve the PR', 'Post a comment that explains that this is a Swimm docs change only'],
  config_conditions: ['The PR only affects files that end in a `.swm` extension'],
  config_intro: 'Approve changes that only affectSwimmdocumentation.',
  date: '2023-05-15T12:13:15-04:00',
  description: 'Automatically approve PRs that only change Swimm documentation.',
  file: 'docs/automations/integrations/swimm/approve-swimm/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/swimm/approve-swimm/approve-swimm.png',
  id: 'approve-swimm-changes',
  link: 'https://docs.gitstream.cm/automations/integrations/swimm/approve-swimm',
  logo: 'https://docs.gitstream.cm/automations/integrations/swimm/approve-swimm/approve-swimm.svg',
  name: 'Approve Swimm Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_ff_devcycle',
  category: ['quality', 'feature-flag', 'devcycle'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/devcycle/label-ff-devcycle/label_ff_devcycle.cm',
  config: '* The PR adds one or more feature flag keys.\n\n* Label the PR for each feature flag key introduced in the PR.\n',
  config_actions: ['Label the PR for each feature flag key introduced in the PR'],
  config_conditions: ['The PR adds one or more feature flag keys'],
  config_intro: 'Automatically label code that contians specified feature flags.',
  date: '2024-01-11T16:27:55+02:00',
  description: 'Automatically label code that contians specified feature flags.',
  file: 'docs/automations/integrations/devcycle/label-ff-devcycle/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/devcycle/label-ff-devcycle/label-ff-devcycle.png',
  id: 'label-prs-based-on-devcycle-feature-flags',
  link: 'https://docs.gitstream.cm/automations/integrations/devcycle/label-ff-devcycle',
  logo: null,
  name: 'Label PRs Based on Devcycle Feature Flags',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'link_azure_boards',
  category: ['quality', 'project', 'azure'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/azure-boards/link_azure_boards.cm',
  config: '* The PR contains a reference to an Azure Boards resource in the title or branch name.\n\nAutomation Actions:\n\n* Post a comment that provides a link to the associated Azure Boards Resource.\n',
  config_actions: ['Post a comment that provides a link to the associated Azure Boards Resource'],
  config_conditions: ['The PR contains a reference to an Azure Boards resource in the title or branch name'],
  config_intro: 'Provide automatic links to Azure Boards resources that are associated with PRs.',
  date: '2023-09-06T14:26:58-04:00',
  description: 'Provide automatic links to Azure Boards resources that are associated with PRs.',
  file: 'docs/automations/integrations/azure-boards/link-azure-boards/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/link-issue-tracker/link-issue-tracker.png',
  id: 'automatically-link-prs-to-related-azure-boards-resources',
  link: 'https://docs.gitstream.cm/automations/integrations/azure-boards/link-azure-boards',
  logo: 'https://docs.gitstream.cm/automations/integrations/azure-boards/link-azure-boards/link-azure-boards.svg',
  name: 'Automatically Link PRs to Related Azure Boards Resources',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_missing_azure',
  category: ['quality', 'project', 'azure'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/azure-boards/label_missing_azure_boards.cm',
  config: '* The PR is missing one of the following:\n* An Azure Boards ticket reference in the PR title.\n* A link to an Azure Boards resource in the PR description.\n\n* Apply a red `⚠️ Missing Azure Boards Link` label\n* Post a comment that asks the author to add an Azure Boards reference to the PR.\n',
  config_actions: ['Apply a red `⚠️ Missing Azure Boards Link` label', 'Post a comment that asks the author to add an Azure Boards reference to the PR'],
  config_conditions: ['The PR is missing one of the following:', 'An Azure Boards ticket reference in the PR title', 'A link to an Azure Boards resource in the PR description'],
  config_intro: 'Automatically label PRs that are missing references to Azure Boards resources.',
  date: '2023-09-01T12:49:00-04:00',
  description: 'Automatically label PRs that are missing references to Azure Boards resources.',
  file: 'docs/automations/integrations/azure-boards/label-missing-azure-boards/README.md',
  image: 'https://docs.gitstream.cm/automations/label-missing-project-tracker/label-missing-project-tracker.png',
  id: 'label-missing-azure-boards-info',
  link: 'https://docs.gitstream.cm/automations/integrations/azure-boards/label-missing-azure-boards',
  logo: 'https://docs.gitstream.cm/automations/integrations/azure-boards/label-missing-azure-boards/link-azure-boards.svg',
  name: 'Label Missing Azure Boards Info',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_javadoc',
  category: ['docs', 'java'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/javadoc/review_javadoc_changes.cm',
  config: '* The PR only contains changes to Javadoc content.\n\n\nAutomation Actions:\n\n* Assign the `org/tech-writers`team for optional review.\n* Apply a green `📓 Javadoc Only` label\n* Approve the PR\n',
  config_actions: ['Assign the `org/tech-writers`team for optional review', 'Apply a green `📓 Javadoc Only` label', 'Approve the PR'],
  config_conditions: ['The PR only contains changes to Javadoc content'],
  config_intro: 'Unblock PRs that only change Javadoc content.',
  date: '2023-07-17T15:15:57-04:00',
  description: 'Automatically approve PRs that only contain Javadoc changes.',
  file: 'docs/automations/integrations/javadoc/review-javadoc/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/javadoc/review-javadoc/review-javadoc.png',
  id: 'review-javadoc-changes',
  link: 'https://docs.gitstream.cm/automations/integrations/javadoc/review-javadoc',
  logo: 'https://docs.gitstream.cm/automations/integrations/javadoc/review-javadoc/review-javadoc.svg',
  name: 'Review Javadoc Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_javadoc_large',
  category: ['docs', 'java'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/javadoc/review_javadoc_large_change.cm',
  config: '* The PR changes more than 25% of a Java class.\n* The PR lacks Javadoc changes.\n\nAutomation Actions:\n\n* Post a comment asking the author to review all relevant Javadoc to identify necessary updates.\n* Require a review from the `my-organization/tech-writers` team.\n* Apply a yellow `⚠️ Missing Javadoc` Label\n',
  config_actions: ['Post a comment asking the author to review all relevant Javadoc to identify necessary updates', 'Require a review from the `my-organization/tech-writers` team', 'Apply a yellow `⚠️ Missing Javadoc` Label'],
  config_conditions: ['The PR changes more than 25% of a Java class', 'The PR lacks Javadoc changes'],
  config_intro: 'Require more extensive reviews for large Java changes that lack Javadoc updates.',
  date: '2023-07-17T15:15:57-04:00',
  description: 'Automatically flag large PRs that may require Javadoc updates.',
  file: 'docs/automations/integrations/javadoc/review-javadoc-large-change/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/javadoc/review-javadoc-large-change/review-javadoc-large-change.png',
  id: 'review-javadoc-for-large-changes',
  link: 'https://docs.gitstream.cm/automations/integrations/javadoc/review-javadoc-large-change',
  logo: 'https://docs.gitstream.cm/automations/integrations/javadoc/review-javadoc-large-change/review-javadoc.svg',
  name: 'Review Javadoc for Large Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_new_class_javadoc',
  category: ['docs', 'java'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/javadoc/review_new_class_javadoc.cm',
  config: '* The PR creates a new Java class.\n* The PR lacks Javadoc content.\n\nAutomation Actions:\n\n* Apply a `⚠️ Missing Javadoc` label.\n* Request changes, and post a comment explaining that Javadoc is required\n',
  config_actions: ['Apply a `⚠️ Missing Javadoc` label', 'Request changes, and post a comment explaining that Javadoc is required'],
  config_conditions: ['The PR creates a new Java class', 'The PR lacks Javadoc content'],
  config_intro: 'Automatically request changes when someone creates a new Java class that lacks Javadoc content.',
  date: '2023-07-17T15:15:57-04:00',
  description: 'Automatically request changes for PRs that fail to meet Javadoc requirements.',
  file: 'docs/automations/integrations/javadoc/review-new-class-javadoc/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/javadoc/review-new-class-javadoc/review-new-class-javadoc.png',
  id: 'enforce-javadoc-requirements-for-new-classes',
  link: 'https://docs.gitstream.cm/automations/integrations/javadoc/review-new-class-javadoc',
  logo: 'https://docs.gitstream.cm/automations/integrations/javadoc/review-new-class-javadoc/review-javadoc.svg',
  name: 'Enforce Javadoc Requirements for New Classes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_javadoc_input_parameters',
  category: ['docs', 'java'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/javadoc/review_javadoc_input_parameters.cm',
  config: '* The PR changes one or more input parameters in Java methods.\n* Note: This may not trigger for methods with annotations, methods that throw exceptions, multi-line method definitions, and other non-standard use cases.\n* The PR lacks changes to ‘@param’ declarations.\n\n\nAutomation Actions:\n\n* Post a comment warning the user to review the method’s Javadoc to identify necessary updates.\n',
  config_actions: ['Post a comment warning the user to review the method’s Javadoc to identify necessary updates'],
  config_conditions: ['The PR changes one or more input parameters in Java methods', 'Note: This may not trigger for methods with annotations, methods that throw exceptions, multi-line method definitions, and other non-standard use cases', 'The PR lacks changes to ‘@param’ declarations'],
  config_intro: 'If a PR modifies the input parameters for a Java method, but not the associated Javadocs, notify reviewers to check for Javadoc updates.',
  date: '2023-07-17T15:15:57-04:00',
  description: 'Notify PR authors to ensure proper Javadoc coverage.',
  file: 'docs/automations/integrations/javadoc/review-javadoc-input-parameters/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/javadoc/review-javadoc-input-parameters/review-javadoc-input-parameters.png',
  id: 'review-java-input-parameters-for-javadoc-changes',
  link: 'https://docs.gitstream.cm/automations/integrations/javadoc/review-javadoc-input-parameters',
  logo: 'https://docs.gitstream.cm/automations/integrations/javadoc/review-javadoc-input-parameters/review-javadoc.svg',
  name: 'Review Java Input Parameters for Javadoc Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_rdoc_new_class',
  category: ['quality', 'docs', 'ruby'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/rdoc/review_rdoc_new_class.cm',
  config: '* The PR creates a new Ruby class.\n* The PR lacks RDoc content.\n\n* Request changes and post a comment explaining that RDoc is required\n* Apply a yellow `⚠️ Missing RDoc` label.\n',
  config_actions: ['Request changes and post a comment explaining that RDoc is required', 'Apply a yellow `⚠️ Missing RDoc` label'],
  config_conditions: ['The PR creates a new Ruby class', 'The PR lacks RDoc content'],
  config_intro: 'Require RDoc for all new Ruby classes.',
  date: '2023-09-19T12:28:49-04:00',
  description: 'Enforce RDoc requirements for new Ruby code.',
  file: 'docs/automations/integrations/rdoc/review-rdoc-new-class/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/rdoc/review-rdoc-new-class/review-rdoc-new-class.png',
  id: 'enforce-rdoc-for-new-ruby-classes',
  link: 'https://docs.gitstream.cm/automations/integrations/rdoc/review-rdoc-new-class',
  logo: null,
  name: 'Enforce RDoc for New Ruby Classes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_rdoc_large',
  category: ['quality', 'docs', 'ruby'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/rdoc/review_rdoc_large.cm',
  config: '* The PR changes more than 150 lines of Ruby code.\n\n* Post a comment asking the author to review all relevant RDoc to identify necessary updates.\n* Require a review from the `ORG/tech-writers` team.\n* Apply a yellow `⚠️ Missing RDoc` Label\n',
  config_actions: ['Post a comment asking the author to review all relevant RDoc to identify necessary updates', 'Require a review from the `ORG/tech-writers` team', 'Apply a yellow `⚠️ Missing RDoc` Label'],
  config_conditions: ['The PR changes more than 150 lines of Ruby code'],
  config_intro: 'Require more extensive reviews for large Ruby changes that lack RDoc updates.',
  date: '2023-09-19T12:28:49-04:00',
  description: 'Automatically flag large PRs that may require RDoc updates.',
  file: 'docs/automations/integrations/rdoc/review-rdoc-large/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/rdoc/review-rdoc-large/review-rdoc-large.png',
  id: 'review-rdoc-for-large-changes',
  link: 'https://docs.gitstream.cm/automations/integrations/rdoc/review-rdoc-large',
  logo: null,
  name: 'Review RDoc for Large Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_rdoc',
  category: ['efficiency', 'docs', 'ruby'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/rdoc/review_rdoc.cm',
  config: '* The PR only contains changes to RDoc content.\n\n* Assign the org/tech-writers team for optional review.\n* Apply a green `📓 RDoc Only` label\n* Approve the PR\n',
  config_actions: ['Assign the org/tech-writers team for optional review', 'Apply a green `📓 RDoc Only` label', 'Approve the PR'],
  config_conditions: ['The PR only contains changes to RDoc content'],
  config_intro: 'Approve PRs that only contain changes to RDoc and assign optional reviewers.',
  date: '2023-09-19T12:28:49-04:00',
  description: 'Automatically approve PRs for RDoc changes.',
  file: 'docs/automations/integrations/rdoc/review-rdoc/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/rdoc/review-rdoc/review-rdoc.png',
  id: 'approve-rdoc-changes',
  link: 'https://docs.gitstream.cm/automations/integrations/rdoc/review-rdoc',
  logo: null,
  name: 'Approve RDoc Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_rdoc_input',
  category: ['quality', 'docs', 'ruby'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/rdoc/review_rdoc_input.cm',
  config: '* The PR changes one or more input parameters in Ruby methods.\n* The PR lacks RDoc updates.\n\n* Post a comment warning the user to review the method’s RDoc to identify necessary updates.\n',
  config_actions: ['Post a comment warning the user to review the method’s RDoc to identify necessary updates'],
  config_conditions: ['The PR changes one or more input parameters in Ruby methods', 'The PR lacks RDoc updates'],
  config_intro: 'Warn PR authors when they change Ruby function or constructor input parameters without updating RDoc content.',
  date: '2023-09-19T12:28:49-04:00',
  description: 'Automatically flag PRs that may require RDoc updates.',
  file: 'docs/automations/integrations/rdoc/review-rdoc-input/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/rdoc/review-rdoc-input/review-rdoc-input.png',
  id: 'review-rdoc-input-parameters',
  link: 'https://docs.gitstream.cm/automations/integrations/rdoc/review-rdoc-input',
  logo: null,
  name: 'Review RDoc Input Parameters',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'merge_renovate_minor',
  category: ['efficiency', 'renovate', 'security', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/renovate/approve_renovate_minor.cm',
  config: "* The PR author is Renovate.\n* The branch name includes 'renovate'\n* The dependency change is a patch or minor update.\n\n* Approve the PR\n* Apply an `approved-renovate` label to the PR\n* Merge the PR if all status checks pass.\n\n",
  config_actions: ['Approve the PR', 'Apply an `approved-renovate` label to the PR', 'Merge the PR if all status checks pass'],
  config_conditions: ['The PR author is Renovate', "The branch name includes 'renovate'", 'The dependency change is a patch or minor update'],
  config_intro: 'Auto-merge Renovate PRs',
  date: '2024-01-16T12:43:49+02:00',
  description: 'Automatically approve and merge Renovate PRs.',
  file: 'docs/automations/integrations/renovate/approve-renovate/README.md',
  image: null,
  id: 'approve-and-merge-renovate-changes-by-release-type',
  link: 'https://docs.gitstream.cm/automations/integrations/renovate/approve-renovate',
  logo: 'https://docs.gitstream.cm/automations/integrations/renovate/approve-renovate/approve-renovate.svg',
  name: 'Approve and Merge Renovate Changes - By Release Type',
  quickstart: true,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'approve_renovate',
  category: ['efficiency', 'renovate', 'security', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/renovate/approve_renovate.cm',
  config: "* The PR author is Renovate.\n* The branch name includes 'renovate'\n\n* Approve the PR\n* Apply an `approved-renovate` label to the PR\n* Merge the PR if all status checks pass.\n\n\n",
  config_actions: ['Approve the PR', 'Apply an `approved-renovate` label to the PR', 'Merge the PR if all status checks pass'],
  config_conditions: ['The PR author is Renovate', "The branch name includes 'renovate'"],
  config_intro: 'Auto-merge Renovate PRs',
  date: '2024-01-16T12:43:49+02:00',
  description: 'Automatically approve and merge Renovate PRs.',
  file: 'docs/automations/integrations/renovate/approve-renovate/README.md',
  image: null,
  id: 'approve-and-merge-renovate-changes-all-updates',
  link: 'https://docs.gitstream.cm/automations/integrations/renovate/approve-renovate',
  logo: 'https://docs.gitstream.cm/automations/integrations/renovate/approve-renovate/approve-renovate.svg',
  name: 'Approve and Merge Renovate Changes - All Updates',
  quickstart: true,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'link_asana',
  category: ['efficiency', 'quality', 'project', 'asana'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/asana/link_asana.cm',
  config: '* The PR contains a reference to an Asana card in the title or branch name.\n\nAutomation Actions:\n\n* Post a comment that provides a link to the associated Asana Card.\n',
  config_actions: ['Post a comment that provides a link to the associated Asana Card'],
  config_conditions: ['The PR contains a reference to an Asana card in the title or branch name'],
  config_intro: 'Provide automatic links to Asana cards that are associated with PRs.',
  date: '2023-09-06T14:26:58-04:00',
  description: 'Provide automatic links to Asana cards that are associated with PRs.',
  file: 'docs/automations/integrations/asana/link-asana/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/link-issue-tracker/link-issue-tracker.png',
  id: 'automatically-link-prs-to-related-asana-cards',
  link: 'https://docs.gitstream.cm/automations/integrations/asana/link-asana',
  logo: 'https://docs.gitstream.cm/automations/integrations/asana/link-asana/link-asana.svg',
  name: 'Automatically Link PRs to Related Asana Cards',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_missing_asana',
  category: ['quality', 'project', 'labeling'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/asana/label_missing_asana.cm',
  config: '* The PR is missing an Asana ticket reference in the PR title and a link to an Asana resource in the PR description.\n\n* Apply a red `⚠️ Missing Asana Link` label\n* Post a comment that asks the author to add an Asana reference to the PR.\n',
  config_actions: ['Apply a red `⚠️ Missing Asana Link` label', 'Post a comment that asks the author to add an Asana reference to the PR'],
  config_conditions: ['The PR is missing an Asana ticket reference in the PR title and a link to an Asana resource in the PR description'],
  config_intro: 'Automatically label PRs that are missing references to Asana resources.',
  date: '2023-09-01T12:49:00-04:00',
  description: 'Automatically label PRs that are missing references to Asana resources.',
  file: 'docs/automations/integrations/asana/label-missing-asana/README.md',
  image: 'https://docs.gitstream.cm/automations/label-missing-project-tracker/label-missing-project-tracker.png',
  id: 'label-missing-asana',
  link: 'https://docs.gitstream.cm/automations/integrations/asana/label-missing-asana',
  logo: 'https://docs.gitstream.cm/automations/integrations/asana/label-missing-asana/label-missing-asana.svg',
  name: 'Label Missing Asana',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_ff_unleash',
  category: ['featureflag', 'unleash'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/unleash/label-ff-unleash/label_ff_unleash.cm',
  config: '* The PR adds one or more feature flag keys.\n\n* Label the PR for each feature flag key introduced in the PR.\n',
  config_actions: ['Label the PR for each feature flag key introduced in the PR'],
  config_conditions: ['The PR adds one or more feature flag keys'],
  config_intro: 'Automatically label code that contians specified feature flags.',
  date: '2024-01-11T16:27:55+02:00',
  description: 'Automatically label code that contians specified feature flags.',
  file: 'docs/automations/integrations/unleash/label-ff-unleash/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/unleash/label-ff-unleash/label-ff-unleash.png',
  id: 'label-prs-based-on-unleash-feature-flags',
  link: 'https://docs.gitstream.cm/automations/integrations/unleash/label-ff-unleash',
  logo: null,
  name: 'Label PRs Based on Unleash Feature Flags',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_orca_alerts',
  category: ['security', 'orca'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/orca/review_orca_alerts.cm',
  config: "* The PR contains a vulnerability, IAC problem, or secret that is flagged as High or Medium.\n\nAutomation Actions:\n\n* Require review from your organization's security team.\n* Post a comment explaining the requirement.\n",
  config_actions: ["Require review from your organization's security team", 'Post a comment explaining the requirement'],
  config_conditions: ['The PR contains a vulnerability, IAC problem, or secret that is flagged as High or Medium'],
  config_intro: 'Automatically require review from your SecOps team for Orca Security violations in pull requests.',
  date: '2024-01-24T17:18:29-05:00',
  description: 'Automatically require review from your SecOps team for Orca Security violations in pull requests.',
  file: 'docs/automations/integrations/orca/review-orca-alerts/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/orca/review-orca-alerts/review-orca-alerts-2-dark.png#only-dark',
  id: 'review-orca-security-alerts',
  link: 'https://docs.gitstream.cm/automations/integrations/orca/review-orca-alerts',
  logo: 'https://docs.gitstream.cm/automations/integrations/orca/review-orca-alerts/review-orca-alerts.svg',
  name: 'Review Orca Security Alerts',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_orca',
  category: ['security', 'orca'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/orca/label_orca_scan_results.cm',
  config: '* Orca Security detects one or more issues with the code in the PR.\n\nAutomation Actions:\n\n* Apply a label that indicates which issue was identified.\n',
  config_actions: ['Apply a label that indicates which issue was identified'],
  config_conditions: ['Orca Security detects one or more issues with the code in the PR'],
  config_intro: 'Automatically apply labels to PRs that indicate the result of Orca Security scans.',
  date: '2024-01-16T11:08:25-05:00',
  description: 'Automatically apply labels to PRs that indicate the result of Orca Security scans.',
  file: 'docs/automations/integrations/orca/label-orca-scan-results/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/orca/label-orca-scan-results/label-orca-scan-results.png#only-light',
  id: 'auto-label-orca-scan-results',
  link: 'https://docs.gitstream.cm/automations/integrations/orca/label-orca-scan-results',
  logo: 'https://docs.gitstream.cm/automations/integrations/orca/label-orca-scan-results/review-orca-alerts.svg',
  name: 'Auto-Label Orca Scan Results',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'merge_dependabot_minor',
  category: ['efficiency', 'dependabot', 'security', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/dependabot/approve_dependabot_minor.cm',
  config: "* The PR author is Dependabot.\n* The branch name includes 'dependabot'\n* The dependency change is a patch or minor update.\n\n* Approve the PR\n* Apply an `approved-dependabot` label to the PR\n* Merge the PR if all status checks pass.\n\n",
  config_actions: ['Approve the PR', 'Apply an `approved-dependabot` label to the PR', 'Merge the PR if all status checks pass'],
  config_conditions: ['The PR author is Dependabot', "The branch name includes 'dependabot'", 'The dependency change is a patch or minor update'],
  config_intro: 'Auto-merge Dependabot PRs',
  date: '2023-05-19T15:15:31-04:00',
  description: 'Automatically approve and merge Dependabot PRs.',
  file: 'docs/automations/integrations/dependabot/approve-dependabot/README.md',
  image: null,
  id: 'approve-and-merge-dependabot-changes-by-release-type',
  link: 'https://docs.gitstream.cm/automations/integrations/dependabot/approve-dependabot',
  logo: 'https://docs.gitstream.cm/automations/integrations/dependabot/approve-dependabot/approve-dependabot.svg',
  name: 'Approve and Merge Dependabot Changes - By Release Type',
  quickstart: true,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'approve_dependabot',
  category: ['efficiency', 'dependabot', 'security', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/dependabot/approve_dependabot.cm',
  config: "* The PR author is Dependabot.\n* The branch name includes 'dependabot'\n\n* Approve the PR\n* Apply an `approved-dependabot` label to the PR\n* Merge the PR if all status checks pass.\n\n\n",
  config_actions: ['Approve the PR', 'Apply an `approved-dependabot` label to the PR', 'Merge the PR if all status checks pass'],
  config_conditions: ['The PR author is Dependabot', "The branch name includes 'dependabot'"],
  config_intro: 'Auto-merge Dependabot PRs',
  date: '2023-05-19T15:15:31-04:00',
  description: 'Automatically approve and merge Dependabot PRs.',
  file: 'docs/automations/integrations/dependabot/approve-dependabot/README.md',
  image: null,
  id: 'approve-and-merge-dependabot-changes-all-updates',
  link: 'https://docs.gitstream.cm/automations/integrations/dependabot/approve-dependabot',
  logo: 'https://docs.gitstream.cm/automations/integrations/dependabot/approve-dependabot/approve-dependabot.svg',
  name: 'Approve and Merge Dependabot Changes - All Updates',
  quickstart: true,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'linearb_ai_review',
  category: ['quality', 'genai', 'efficiency', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/LinearBAI/code-review.cm',
  config: '* A PR is created or new code has been committed to the PR.\n* The PR is not on Draft staten and was not created by a bot.\n\n* Perform an AI-driven code review and append the review comments to the PR.\n',
  config_actions: ['Perform an AI-driven code review and append the review comments to the PR'],
  config_conditions: ['A PR is created or new code has been committed to the PR', 'The PR is not on Draft staten and was not created by a bot'],
  config_intro: "Use LinearB's AI with the `code-review` action to automatically review the introduced changes to the code.",
  date: '2024-09-08T12:47:58+03:00',
  description: "Use gitStream's integration with LinearB's AI service to automate code reviews.",
  file: 'docs/automations/integrations/LinearBAI/code-review/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/LinearBAI/code-review/LinearB-AI-code-review.png',
  id: 'code-review-using-linearb-s-ai-for-github',
  link: 'https://docs.gitstream.cm/automations/integrations/LinearBAI/code-review',
  logo: 'https://docs.gitstream.cm/automations/integrations/LinearBAI/code-review/LinearB-AI-code-review.svg',
  name: "Code Review Using LinearB's AI - For GitHub",
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'linearb_ai_review',
  category: ['quality', 'genai', 'efficiency', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/LinearBAI/code-review-gl.cm',
  config: null,
  config_actions: ['Perform an AI-driven code review and append the review comments to the PR'],
  config_conditions: ['A PR is created or new code has been committed to the PR', 'The PR is not on Draft staten and was not created by a bot'],
  config_intro: "Use LinearB's AI with the `code-review` action to automatically review the introduced changes to the code.",
  date: '2024-09-08T12:47:58+03:00',
  description: "Use gitStream's integration with LinearB's AI service to automate code reviews.",
  file: 'docs/automations/integrations/LinearBAI/code-review/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/LinearBAI/code-review/LinearB-AI-code-review.png',
  id: 'code-review-using-linearb-s-ai-for-gitlab',
  link: 'https://docs.gitstream.cm/automations/integrations/LinearBAI/code-review',
  logo: 'https://docs.gitstream.cm/automations/integrations/LinearBAI/code-review/LinearB-AI-code-review.svg',
  name: "Code Review Using LinearB's AI - For GitLab",
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'linearb_ai_review',
  category: ['quality', 'genai', 'efficiency', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/LinearBAI/code-review-bb.cm',
  config: null,
  config_actions: ['Perform an AI-driven code review and append the review comments to the PR'],
  config_conditions: ['A PR is created or new code has been committed to the PR', 'The PR is not on Draft staten and was not created by a bot'],
  config_intro: "Use LinearB's AI with the `code-review` action to automatically review the introduced changes to the code.",
  date: '2024-09-08T12:47:58+03:00',
  description: "Use gitStream's integration with LinearB's AI service to automate code reviews.",
  file: 'docs/automations/integrations/LinearBAI/code-review/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/LinearBAI/code-review/LinearB-AI-code-review.png',
  id: 'code-review-using-linearb-s-ai-for-bitbucket',
  link: 'https://docs.gitstream.cm/automations/integrations/LinearBAI/code-review',
  logo: 'https://docs.gitstream.cm/automations/integrations/LinearBAI/code-review/LinearB-AI-code-review.svg',
  name: "Code Review Using LinearB's AI - For Bitbucket",
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'linearb_ai_description',
  category: ['quality', 'genai', 'efficiency', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/LinearBAI/describe-pr.cm',
  config: '* A PR is created or new code has been committed to the PR.\n\n* Append the AI-generated description to the PR description.\n',
  config_actions: ['Append the AI-generated description to the PR description'],
  config_conditions: ['A PR is created or new code has been committed to the PR'],
  config_intro: 'Use the `describe-changes` automation action to automatically generate and append a concise, AI-generated description to a pull request. This ensures that all PRs include meaningful and helpful descriptions, improving review efficiency.',
  date: '2024-09-08T12:47:58+03:00',
  description: "Use gitStream's integration with LinearB's AI service to summarize the PR changes.",
  file: 'docs/automations/integrations/LinearBAI/describe-pr/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/LinearBAI/describe-pr/LinearB-AI-describe-pr.png',
  id: 'add-pr-description-using-linearb-s-ai-for-github',
  link: 'https://docs.gitstream.cm/automations/integrations/LinearBAI/describe-pr',
  logo: 'https://docs.gitstream.cm/automations/integrations/LinearBAI/describe-pr/LinearB-AI-describe-pr.svg',
  name: "Add PR Description Using LinearB's AI - For GitHub",
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'linearb_ai_description',
  category: ['quality', 'genai', 'efficiency', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/LinearBAI/describe-pr-gl.cm',
  config: null,
  config_actions: ['Append the AI-generated description to the PR description'],
  config_conditions: ['A PR is created or new code has been committed to the PR'],
  config_intro: 'Use the `describe-changes` automation action to automatically generate and append a concise, AI-generated description to a pull request. This ensures that all PRs include meaningful and helpful descriptions, improving review efficiency.',
  date: '2024-09-08T12:47:58+03:00',
  description: "Use gitStream's integration with LinearB's AI service to summarize the PR changes.",
  file: 'docs/automations/integrations/LinearBAI/describe-pr/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/LinearBAI/describe-pr/LinearB-AI-describe-pr.png',
  id: 'add-pr-description-using-linearb-s-ai-for-gitlab',
  link: 'https://docs.gitstream.cm/automations/integrations/LinearBAI/describe-pr',
  logo: 'https://docs.gitstream.cm/automations/integrations/LinearBAI/describe-pr/LinearB-AI-describe-pr.svg',
  name: "Add PR Description Using LinearB's AI - For GitLab",
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'linearb_ai_description',
  category: ['quality', 'genai', 'efficiency', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/LinearBAI/describe-pr-bb.cm',
  config: null,
  config_actions: ['Append the AI-generated description to the PR description'],
  config_conditions: ['A PR is created or new code has been committed to the PR'],
  config_intro: 'Use the `describe-changes` automation action to automatically generate and append a concise, AI-generated description to a pull request. This ensures that all PRs include meaningful and helpful descriptions, improving review efficiency.',
  date: '2024-09-08T12:47:58+03:00',
  description: "Use gitStream's integration with LinearB's AI service to summarize the PR changes.",
  file: 'docs/automations/integrations/LinearBAI/describe-pr/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/LinearBAI/describe-pr/LinearB-AI-describe-pr.png',
  id: 'add-pr-description-using-linearb-s-ai-for-bitbucket',
  link: 'https://docs.gitstream.cm/automations/integrations/LinearBAI/describe-pr',
  logo: 'https://docs.gitstream.cm/automations/integrations/LinearBAI/describe-pr/LinearB-AI-describe-pr.svg',
  name: "Add PR Description Using LinearB's AI - For Bitbucket",
  quickstart: true,
  starter_kits: ['genai'],
  visible: true
}, {
  always: false,
  automation_in_cm: 'skip_github_action_branch',
  category: ['efficiency', 'ci', 'github'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/github-actions/skip-github-action/skip_github_action_branch.cm',
  config: '* The target branch name includes a specified keyword. Optionally, you can modify this to detect the source branch name.\n\n* Skip the specified CI pipelines.\n\n',
  config_actions: ['Skip the specified CI pipelines'],
  config_conditions: ['The target branch name includes a specified keyword. Optionally, you can modify this to detect the source branch name'],
  config_intro: 'Automatically skip GitHub Actions based on branch names, modified resource, slash commands, and more.',
  date: '2023-09-13T14:25:23-04:00',
  description: 'Automatically skip GitHub Actions based on branch names, modified resource, slash commands, and more.',
  file: 'docs/automations/integrations/github-actions/skip-github-action/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/github-actions/skip-github-action/skip-github-action.png',
  id: 'skip-required-github-actions-by-branch',
  link: 'https://docs.gitstream.cm/automations/integrations/github-actions/skip-github-action',
  logo: 'https://docs.gitstream.cm/automations/integrations/github-actions/skip-github-action/dispatch-github-action.svg',
  name: 'Skip Required GitHub Actions - By Branch',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'skip_github_action_label',
  category: ['efficiency', 'ci', 'github'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/github-actions/skip-github-action/skip_github_action_label.cm',
  config: '* Someone applies one or more specified labels to a PR.\n\n* Skip the specified CI pipelines.\n\n',
  config_actions: ['Skip the specified CI pipelines'],
  config_conditions: ['Someone applies one or more specified labels to a PR'],
  config_intro: 'Automatically skip GitHub Actions based on branch names, modified resource, slash commands, and more.',
  date: '2023-09-13T14:25:23-04:00',
  description: 'Automatically skip GitHub Actions based on branch names, modified resource, slash commands, and more.',
  file: 'docs/automations/integrations/github-actions/skip-github-action/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/github-actions/skip-github-action/skip-github-action.png',
  id: 'skip-required-github-actions-using-labels',
  link: 'https://docs.gitstream.cm/automations/integrations/github-actions/skip-github-action',
  logo: 'https://docs.gitstream.cm/automations/integrations/github-actions/skip-github-action/dispatch-github-action.svg',
  name: 'Skip Required GitHub Actions - Using Labels',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'skip_github_action_resource',
  category: ['efficiency', 'ci', 'github'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/github-actions/skip-github-action/skip_github_action_resource.cm',
  config: '* A PR modifies specific files or directories.\n\n* Skip a specified GitHub Action.\n\n',
  config_actions: ['Skip a specified GitHub Action'],
  config_conditions: ['A PR modifies specific files or directories'],
  config_intro: 'Automatically skip GitHub Actions based on branch names, modified resource, slash commands, and more.',
  date: '2023-09-13T14:25:23-04:00',
  description: 'Automatically skip GitHub Actions based on branch names, modified resource, slash commands, and more.',
  file: 'docs/automations/integrations/github-actions/skip-github-action/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/github-actions/skip-github-action/skip-github-action.png',
  id: 'skip-required-github-actions-by-modified-resource',
  link: 'https://docs.gitstream.cm/automations/integrations/github-actions/skip-github-action',
  logo: 'https://docs.gitstream.cm/automations/integrations/github-actions/skip-github-action/dispatch-github-action.svg',
  name: 'Skip Required GitHub Actions - By Modified Resource',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'dispatch_github_action_branch',
  category: ['efficiency', 'ci', 'github'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/github-actions/dispatch-github-action/dispatch_github_action_branch.cm',
  config: '* The PR source or target branch matches a specified format.\n\n* Trigger a manual dispatch for the specified CI pipeline.\n\n',
  config_actions: ['Trigger a manual dispatch for the specified CI pipeline'],
  config_conditions: ['The PR source or target branch matches a specified format'],
  config_intro: 'Automatically trigger GitHub Actions based on PR content like changed resources, source or target branch, slash commands, and more.',
  date: '2023-09-13T14:25:23-04:00',
  description: 'Automatically trigger GitHub Actions based on PR content like changed resources, source or target branch, slash commands, and more.',
  file: 'docs/automations/integrations/github-actions/dispatch-github-action/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/github-actions/dispatch-github-action/dispatch-github-action.png',
  id: 'dispatch-github-actions-by-branch',
  link: 'https://docs.gitstream.cm/automations/integrations/github-actions/dispatch-github-action',
  logo: 'https://docs.gitstream.cm/automations/integrations/github-actions/dispatch-github-action/dispatch-github-action.svg',
  name: 'Dispatch GitHub Actions - By Branch',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'dispatch_github_action_label',
  category: ['efficiency', 'ci', 'github'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/github-actions/dispatch-github-action/dispatch_github_action_label.cm',
  config: '* The PR has one or more specified labels applied to it.\n\n* Trigger a manual dispatch for the specified CI pipeline.\n\n',
  config_actions: ['Trigger a manual dispatch for the specified CI pipeline'],
  config_conditions: ['The PR has one or more specified labels applied to it'],
  config_intro: 'Automatically trigger GitHub Actions based on PR content like changed resources, source or target branch, slash commands, and more.',
  date: '2023-09-13T14:25:23-04:00',
  description: 'Automatically trigger GitHub Actions based on PR content like changed resources, source or target branch, slash commands, and more.',
  file: 'docs/automations/integrations/github-actions/dispatch-github-action/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/github-actions/dispatch-github-action/dispatch-github-action.png',
  id: 'dispatch-github-actions-using-labels',
  link: 'https://docs.gitstream.cm/automations/integrations/github-actions/dispatch-github-action',
  logo: 'https://docs.gitstream.cm/automations/integrations/github-actions/dispatch-github-action/dispatch-github-action.svg',
  name: 'Dispatch GitHub Actions - Using Labels',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'dispatch_github_action_resource',
  category: ['efficiency', 'ci', 'github'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/integrations/github-actions/dispatch-github-action/dispatch_github_action_resource.cm',
  config: '* The PR modifies one or more specified resources.\n\n* Trigger a manual dispatch for the specified CI pipeline.\n\n',
  config_actions: ['Trigger a manual dispatch for the specified CI pipeline'],
  config_conditions: ['The PR modifies one or more specified resources'],
  config_intro: 'Automatically trigger GitHub Actions based on PR content like changed resources, source or target branch, slash commands, and more.',
  date: '2023-09-13T14:25:23-04:00',
  description: 'Automatically trigger GitHub Actions based on PR content like changed resources, source or target branch, slash commands, and more.',
  file: 'docs/automations/integrations/github-actions/dispatch-github-action/README.md',
  image: 'https://docs.gitstream.cm/automations/integrations/github-actions/dispatch-github-action/dispatch-github-action.png',
  id: 'dispatch-github-actions-by-modified-resources',
  link: 'https://docs.gitstream.cm/automations/integrations/github-actions/dispatch-github-action',
  logo: 'https://docs.gitstream.cm/automations/integrations/github-actions/dispatch-github-action/dispatch-github-action.svg',
  name: 'Dispatch GitHub Actions - By Modified Resources',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'review_deprecated_component',
  category: ['quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/change_deprecated_components.cm',
  config: '* A PR contains one or more references to functions, methods, or classes that have been designated as deprecated.\n\nAutomation Actions:\n\n* Add a `deprecated-component` label to the PR\n* Request changes to the PR and post a comment that explains what deprecated component was included and what the alternative is.\n',
  config_actions: ['Add a `deprecated-component` label to the PR', 'Request changes to the PR and post a comment that explains what deprecated component was included and what the alternative is'],
  config_conditions: ['A PR contains one or more references to functions, methods, or classes that have been designated as deprecated'],
  config_intro: 'Request changes when a PR includes one or more deprecated components.',
  date: '2023-04-28T09:40:04-04:00',
  description: 'Automatically detect the use of deprecated components and services in PRs.',
  file: 'docs/automations/change-deprecated-components/README.md',
  image: 'https://docs.gitstream.cm/automations/change-deprecated-components/change_deprecated_components.png',
  id: 'change-deprecated-components',
  link: 'https://docs.gitstream.cm/automations/change-deprecated-components',
  logo: null,
  name: 'Change Deprecated Components',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'percent_new_code',
  category: ['efficiency', 'review'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/percent_new_code.cm',
  config: '* Any PR\n\nAutomation Actions:\n\n* Use the `changes` custom expression to post a comment that indicates what percentage of the PR is new code.\n',
  config_actions: ['Use the `changes` custom expression to post a comment that indicates what percentage of the PR is new code'],
  config_conditions: ['Any PR'],
  config_intro: 'Post a comment that indicates what percentage of the PR contains new code.',
  date: '2023-05-02T16:30:21-04:00',
  description: 'Indicate the amount of new code contained in a PR.',
  file: 'docs/automations/percent-new-code/README.md',
  image: 'https://docs.gitstream.cm/automations/percent-new-code/percent_new_code.png',
  id: 'calculate-the-percentage-of-new-code',
  link: 'https://docs.gitstream.cm/automations/percent-new-code',
  logo: 'https://docs.gitstream.cm/automations/percent-new-code/Calculate-percentage-of-new-code.svg',
  name: 'Calculate the Percentage of New Code',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'checklist',
  category: [],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/pr_checklist_general.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: 'Automatically evaluate PRs against code requirement checklists.',
  date: '2024-04-18T23:36:20-05:00',
  description: 'Automatically evaluate PRs against code requirement checklists.',
  file: 'docs/automations/pr-checklist-general/README.md',
  image: 'https://docs.gitstream.cm/automations/standard/pr-checklist-general/pr-checklist-general.png',
  id: 'pr-checklist-general',
  link: 'https://docs.gitstream.cm/automations/pr-checklist-general',
  logo: null,
  name: 'PR Checklist General',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_missing_project_tracker',
  category: ['project', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/label_missing_project_tracker.cm',
  config: '* The PR lacks a project tracker ticket number in the title, or a link to a project tracker resource in the PR description.\n\n* Apply Label : `⚠️ Missing Project Tracker`\n* Post a comment asking the author to reference the associated project tracker resource.\n',
  config_actions: ['Apply Label : `⚠️ Missing Project Tracker`', 'Post a comment asking the author to reference the associated project tracker resource'],
  config_conditions: ['The PR lacks a project tracker ticket number in the title, or a link to a project tracker resource in the PR description'],
  config_intro: 'Label PRs that lack a reference to a project tracker issue (Jira, Azure Boards, Shortcut and Asana) in the PR title or description.',
  date: '2023-08-30T19:16:45+05:30',
  description: 'Automatically flag PRs that lack references to related project tracking issues.',
  file: 'docs/automations/label-missing-project-tracker/README.md',
  image: 'https://docs.gitstream.cm/automations/label-missing-project-tracker/label-missing-project-tracker.png',
  id: 'flag-missing-project-tracking-info',
  link: 'https://docs.gitstream.cm/automations/label-missing-project-tracker',
  logo: 'https://docs.gitstream.cm/automations/label-missing-project-tracker/Flag-missing-project-tracking-info.svg',
  name: 'Flag Missing Project Tracking Info',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'label_prs_without_tests',
  category: ['review', 'quality'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/label_prs_without_tests.cm',
  config: '* The PR has no changes to a test.\n\nAutomation Actions:\n\n* Apply a `missing-tests` label.\n',
  config_actions: ['Apply a `missing-tests` label'],
  config_conditions: ['The PR has no changes to a test'],
  config_intro: "Apply a `missing-tests` label to any PRs that don't update tests. gitStream will remove this label if the contributor adds a test change to the PR.",
  date: '2023-04-27T16:44:38-04:00',
  description: 'Automatically label PRs that lack required tests.',
  file: 'docs/automations/label-prs-without-tests/README.md',
  image: 'https://docs.gitstream.cm/automations/label-prs-without-tests/label_prs_without_tests.png',
  id: 'label-prs-without-tests',
  link: 'https://docs.gitstream.cm/automations/label-prs-without-tests',
  logo: 'https://docs.gitstream.cm/automations/label-prs-without-tests/label-prs-without-tests.svg',
  name: 'Label PRs Without Tests',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'request_screenshot',
  category: ['quality', 'review', 'quickstart'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/request_screenshot.cm',
  config: '* The PR description lacks an image or link to an image.\n\nAutomation Actions:\n\n* Apply a `no-screenshot` label.\n* Post a comment that requests a screenshot. Update this action to provide specific context for your project.\n',
  config_actions: ['Apply a `no-screenshot` label', 'Post a comment that requests a screenshot. Update this action to provide specific context for your project'],
  config_conditions: ['The PR description lacks an image or link to an image'],
  config_intro: 'If the PR lacks an image file, or link to an image in the description, apply a `no-screenshot` label and post a comment to request a screenshot. If the PR author updates the description, gitStream will remove the label.',
  date: '2023-04-28T12:59:40-04:00',
  description: 'Automatically ensure PRs contain screenshots to help illustrate the changes.',
  file: 'docs/automations/request-screenshot/README.md',
  image: 'https://docs.gitstream.cm/automations/request-screenshot/request-screenshot.png',
  id: 'request-screenshot',
  link: 'https://docs.gitstream.cm/automations/request-screenshot',
  logo: 'https://docs.gitstream.cm/automations/request-screenshot/Request-screenshot.svg',
  name: 'Request Screenshot',
  quickstart: true,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'generate_pr_desc',
  category: ['quality', 'productivity'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/generate_pr_description.cm',
  config: '* A PR is created or has commits added to it.\n\nAutomation Actions:\n\n* Update the PR description with auto-generated content based on commit messages.\n',
  config_actions: ['Update the PR description with auto-generated content based on commit messages'],
  config_conditions: ['A PR is created or has commits added to it'],
  config_intro: 'Automatically generate Pull Request descriptions based on commit messages. This automation helps ensure PR descriptions are consistent and informative.',
  date: '2024-08-08T18:28:37+03:00',
  description: 'Automatically generate Pull Request descriptions based on commit messages.',
  file: 'docs/automations/generate-pr-description/README.md',
  image: 'https://docs.gitstream.cm/automations/generate-pr-description/generate-pr-description-example.png',
  id: 'generate-pr-description-from-commit-messages',
  link: 'https://docs.gitstream.cm/automations/generate-pr-description',
  logo: null,
  name: 'Generate PR Description from Commit Messages',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'approve_tiny_change',
  category: ['efficiency'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/approve_tiny_changes.cm',
  config: '* If the PR contains a one-line change to a single file.\n\nAutomation Actions:\n\n* Apply a `single-line` label.\n* Approve the PR.\n* Post a comment explaining why the PR was approved.\n',
  config_actions: ['Apply a `single-line` label', 'Approve the PR', 'Post a comment explaining why the PR was approved'],
  config_conditions: ['If the PR contains a one-line change to a single file'],
  config_intro: 'Approve single-line changes to a single file.',
  date: '2023-01-06T07:49:24+02:00',
  description: 'Automatically approve small PRs.',
  file: 'docs/automations/approve-tiny-changes/README.md',
  image: 'https://docs.gitstream.cm/automations/approve-tiny-changes/approve_tiny_change.png',
  id: 'approve-tiny-changes',
  link: 'https://docs.gitstream.cm/automations/approve-tiny-changes',
  logo: 'https://docs.gitstream.cm/automations/approve-tiny-changes/Approve-tiny-changes.svg',
  name: 'Approve Tiny Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'add_first_team_reviewer',
  category: ['efficiency'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/assign-team-to-prs-by-their-member.cm',
  config: null,
  config_actions: [],
  config_conditions: [],
  config_intro: 'Assign PR reviewer based on the owner team membership.',
  date: '2023-05-02T16:30:21-04:00',
  description: 'Automatically assign teammates to review PRs.',
  file: 'docs/automations/assign-team-members-as-reviewers/README.md',
  image: null,
  id: 'assign-team-members-as-reviewers',
  link: 'https://docs.gitstream.cm/automations/assign-team-members-as-reviewers',
  logo: null,
  name: 'Assign team members as reviewers',
  quickstart: false,
  starter_kits: [],
  visible: true
}, {
  always: false,
  automation_in_cm: 'safe_changes',
  category: ['efficiency'],
  cm: 'https://docs.gitstream.cm/downloads/automation-library/approve-safe-changes.cm',
  config: '* The PR only contains documentation, images, tests, or formatting changes.\n\nAutomation Actions:\n\n* Add a `safe-change` label\n* Approve the PR\n* Post a comment that explains that this is a safe change\n',
  config_actions: ['Add a `safe-change` label', 'Approve the PR', 'Post a comment that explains that this is a safe change'],
  config_conditions: ['The PR only contains documentation, images, tests, or formatting changes'],
  config_intro: 'Automatically approve PRs that change docs, tests, and other safe assets.',
  date: '2022-12-17T12:24:49+02:00',
  description: 'Automatically approve PRs that change docs, tests, and other safe assets.',
  file: 'docs/automations/approve-safe-changes/README.md',
  image: 'https://docs.gitstream.cm/automations/approve-safe-changes/approve-safe-changes.png',
  id: 'approve-safe-changes',
  link: 'https://docs.gitstream.cm/automations/approve-safe-changes',
  logo: 'https://docs.gitstream.cm/automations/approve-safe-changes/Approve-safe-changes.svg',
  name: 'Approve Safe Changes',
  quickstart: false,
  starter_kits: [],
  visible: true
}];

/**
 * Force Update State enum
 * Refrest/Logout/Upgrade
 */
var ForceUpdateState;

(function (ForceUpdateState) {
  ForceUpdateState["NONE"] = "none";
  ForceUpdateState["REFRESH"] = "refresh";
  ForceUpdateState["LOGOUT"] = "logout";
  ForceUpdateState["UPGRADE"] = "upgrade";
})(ForceUpdateState || (ForceUpdateState = {}));

var ProgrammingLanguagesExtensionMapper = {
  js: 'javascript',
  java: 'java',
  py: 'python',
  rb: 'ruby',
  cpp: 'cplusplus',
  c: 'c',
  html: 'html',
  css: 'css',
  php: 'php',
  swift: 'swift',
  ts: 'typescript',
  jsx: 'javascript',
  tsx: 'typescript',
  go: 'go',
  sh: 'bash',
  pl: 'perl',
  r: 'r',
  asm: 'assembly',
  lua: 'lua',
  scala: 'scala',
  kt: 'kotlin',
  cs: 'csharp',
  sql: 'sql',
  json: 'json',
  yaml: 'yaml',
  xml: 'xml',
  md: 'markdown',
  svg: 'svg',
  hbs: 'handlebars',
  coffee: 'coffeescript',
  scss: 'css',
  sass: 'sass',
  less: 'less',
  groovy: 'groovy',
  vb: 'visualbasic',
  dart: 'dart',
  ps1: 'powershell',
  elm: 'elm',
  nim: 'nim',
  cob: 'cobol',
  erl: 'erlang',
  ocaml: 'ocaml',
  jl: 'julia',
  sc: 'scala',
  plsql: 'postgresql',
  pr: 'prolog',
  clj: 'clojure',
  cljs: 'clojure',
  f: 'fortran',
  f90: 'fortran',
  f95: 'fortran',
  bat: 'bash',
  "for": 'fortran',
  yml: 'yaml',
  tf: 'terraform'
};

var SAVED_FILTER_SET_TYPES = {
  FILTER_SET: 'filter_set',
  PROJECT: 'project'
};
var SAVED_FILTER_SET_VISIBILITIES = {
  PRIVATE: 'private',
  PUBLIC: 'public',
  CUSTOM: 'custom'
};

var _USER_DEFAULT_INTREST;

var USER_ROLES = {
  DEVELOPER: 'Developer',
  TEAM_LEADER: 'Team Leader',
  GROUP_MANAGER: 'Group Manager',
  VP_ENGINEERING: 'VP Engineering',
  CTO: 'CTO',
  PRODUCT_MANAGER: 'Product Manager',
  PROJECT_MANAGER: 'Project Manager',
  OTHER: 'Other'
};
var USER_YEARS_OF_EXPERIENCE = {
  ZERO_TO_THREE: '0-3',
  THREE_TO_FIVE: '3-5',
  FIVE_TO_TEN: '5-10',
  TEN_TO_FIFTEEN: '10-15',
  MORE_THEN_FIFTEEN: '15+'
};
var USER_INTERESTS = ['Operational Excellence', 'Identify Bottlenecks', 'Reduce Cognitive Load', 'Forecasting Modules', 'Deploy Workflow Automations', 'Quality', 'Velocity', 'Identify Delay Risks', 'Productivity', 'Coach teams', 'Dev Flow', 'Predictability', 'Developer Experience', 'Sprint Tracking', 'Manage R&D Costs', 'Maximise R&D ROI', 'Get Project Insights'];
var USER_DEFAULT_INTRESTS_BY_ROLE = (_USER_DEFAULT_INTREST = {}, _USER_DEFAULT_INTREST[USER_ROLES.DEVELOPER] = ['Reduce Cognitive Load', 'Developer Experience', 'Deploy Workflow Automations', 'Quality', 'Identify Delay Risks', 'Dev Flow'], _USER_DEFAULT_INTREST[USER_ROLES.TEAM_LEADER] = ['Developer Experience', 'Deploy Workflow Automations', 'Quality', 'Productivity', 'Coach teams', 'Identify Delay Risks', 'Sprint Tracking', 'Dev Flow', 'Identify Bottlenecks', 'Velocity'], _USER_DEFAULT_INTREST[USER_ROLES.GROUP_MANAGER] = ['Coach teams', 'Identify Delay Risks', 'Sprint Tracking', 'Operational Excellence', 'Get Project Insights', 'Identify Bottlenecks', 'Velocity', 'Forecasting Modules', 'Predictability', 'Manage R&D Costs'], _USER_DEFAULT_INTREST[USER_ROLES.VP_ENGINEERING] = ['Operational Excellence', 'Identify Delay Risks', 'Identify Bottlenecks', 'Forecasting Modules', 'Predictability', 'Manage R&D Costs', 'Maximise R&D ROI', 'Developer Experience'], _USER_DEFAULT_INTREST[USER_ROLES.CTO] = ['Operational Excellence', 'Identify Delay Risks', 'Identify Bottlenecks', 'Forecasting Modules', 'Predictability', 'Manage R&D Costs', 'Maximise R&D ROI', 'Developer Experience'], _USER_DEFAULT_INTREST[USER_ROLES.PROJECT_MANAGER] = ['Operational Excellence', 'Identify Delay Risks', 'Forecasting Modules', 'Predictability', 'Quality', 'Get Project Insights', 'Sprint Tracking'], _USER_DEFAULT_INTREST[USER_ROLES.PRODUCT_MANAGER] = ['Operational Excellence', 'Identify Delay Risks', 'Forecasting Modules', 'Predictability', 'Quality', 'Get Project Insights', 'Sprint Tracking'], _USER_DEFAULT_INTREST);

var MERGE_CONTRIBUTOR_SUGGESTION_STATE = {
  PENDING: 'pending',
  MERGED: 'merged',
  REJECTED: 'rejected',
  MANUALLY_UNMERGED: 'manually_unmerged',
  AUTO_MERGED: 'auto_merged'
};

/**
 * An object representing the different user types.
 *
 * @property {string} GIT_GIT - Represents a user with both Git and Git permissions.
 * @property {string} GIT_PM - Represents a user with Git and Project Management permissions.
 * @property {string} PM_PM - Represents a user with both Project Management permissions.
 */
var UserType = {
  GIT_GIT: 'git_git',
  GIT_PM: 'git_pm',
  PM_PM: 'pm_pm'
};
/**
 * An object representing the possible states of a user.
 *
 * @property {string} MERGED - Indicates that the user has been merged.
 * @property {string} REJECTED - Indicates that the user has been rejected.
 * @property {string} PENDING - Indicates that the user's status is pending.
 */

var UserState = {
  MERGED: 'merged',
  REJECTED: 'rejected',
  PENDING: 'pending'
};

/*
Enum for flow tracker events. Defines the status of the events flow.
Explicitly reported by service:
- FLOW_FINISHED - used by services. It's a status finalizing a flow. Other statuses are calculated explicitly:
Calculated States:
- FLOW_NOT_STARTED - Means there are no events found.
- FLOW_STARTED - Means there are events found but there is no event with status FLOW_FINISHED.
- FLOW_FAILED - At least one of the events, related to the flow, has failed.
 */
var FLOW_TRACKER_FLOW_STATUS;

(function (FLOW_TRACKER_FLOW_STATUS) {
  FLOW_TRACKER_FLOW_STATUS["FLOW_NOT_STARTED"] = "flow_not_started";
  FLOW_TRACKER_FLOW_STATUS["FLOW_STARTED"] = "flow_started";
  FLOW_TRACKER_FLOW_STATUS["FLOW_FAILED"] = "flow_failed";
  FLOW_TRACKER_FLOW_STATUS["FLOW_FINISHED"] = "flow_finished";
})(FLOW_TRACKER_FLOW_STATUS || (FLOW_TRACKER_FLOW_STATUS = {}));
/* Enum for the service states of flow tracker events. All states are explicitly reported by service. */


var FLOW_TRACKER_SERVICE_STATUS;

(function (FLOW_TRACKER_SERVICE_STATUS) {
  FLOW_TRACKER_SERVICE_STATUS["SERVICE_STARTED"] = "service_started";
  FLOW_TRACKER_SERVICE_STATUS["SERVICE_COMPLETED"] = "service_completed";
  FLOW_TRACKER_SERVICE_STATUS["SERVICE_FAILED"] = "service_failed";
})(FLOW_TRACKER_SERVICE_STATUS || (FLOW_TRACKER_SERVICE_STATUS = {}));
/*
Enum for Vision insights statuses.
Explicitly reported by service:
- insight_created - Any of events statuses is INSIGHT_CREATED.
- insight_not_created - Any of events statuses is INSIGHT_NOT_CREATED, means insight can't been created.
Calculated States:
- insight_not_started - No events found.
- insight_started - There are events, but no events in statuses INSIGHT_CREATED or INSIGHT_NOT_CREATED.
- insight_failed - Not found INSIGHT_CREATED or INSIGHT_NOT_CREATED and at least one event in SERVICE_FAILED.
 */


var FLOW_TRACKER_INSIGHT_STATUS;

(function (FLOW_TRACKER_INSIGHT_STATUS) {
  FLOW_TRACKER_INSIGHT_STATUS["INSIGHT_NOT_STARTED"] = "insight_not_started";
  FLOW_TRACKER_INSIGHT_STATUS["INSIGHT_STARTED"] = "insight_started";
  FLOW_TRACKER_INSIGHT_STATUS["INSIGHT_CREATED"] = "insight_created";
  FLOW_TRACKER_INSIGHT_STATUS["INSIGHT_NOT_CREATED"] = "insight_not_created";
  FLOW_TRACKER_INSIGHT_STATUS["INSIGHT_FAILED"] = "insight_failed";
})(FLOW_TRACKER_INSIGHT_STATUS || (FLOW_TRACKER_INSIGHT_STATUS = {}));

var buildAmplitudeAccountName = function buildAmplitudeAccountName(account) {
  var email = _.get(account, 'email', '');

  var emailParts = email.split('@');
  return emailParts.length === 2 ? emailParts[0] : 'unknown';
};
var getEmailDashIdUserId = function getEmailDashIdUserId(account) {
  return buildAmplitudeAccountName(account) + "-" + account.id;
};
var getUserTrackingId = function getUserTrackingId(account) {
  var email = _.get(account, 'email', '');

  var userId = getEmailDashIdUserId(account); // Condense the user ID and email for cypress integration tests

  if (email.startsWith('_cy-') && email.endsWith('linearb.io')) {
    email = '_cypress_e2e@linearb.io';
    userId = '_cypress_e2e';
  }

  return {
    userId: userId,
    email: email
  };
};

var MetricUnitType;

(function (MetricUnitType) {
  MetricUnitType["Timespan"] = "timespan";
  MetricUnitType["Count"] = "count";
  MetricUnitType["NonAvgCount"] = "nonAvgCount";
  MetricUnitType["Percentage"] = "percentage";
  MetricUnitType["PercentageWholeNumber"] = "percentageWholeNumber";
})(MetricUnitType || (MetricUnitType = {}));

var MetricCalculationStrategy;

(function (MetricCalculationStrategy) {
  MetricCalculationStrategy["avg"] = "avg";
  MetricCalculationStrategy["p50"] = "p50";
  MetricCalculationStrategy["p75"] = "p75";
  MetricCalculationStrategy["p90"] = "p90";
})(MetricCalculationStrategy || (MetricCalculationStrategy = {}));

var MetricAggregation;

(function (MetricAggregation) {
  MetricAggregation["avg"] = "avg";
  MetricAggregation["sum"] = "sum";
  MetricAggregation["p50"] = "p50";
  MetricAggregation["p75"] = "p75";
  MetricAggregation["count"] = "count";
  MetricAggregation["default"] = "default";
  MetricAggregation["raw"] = "raw";
  MetricAggregation["count_distinct"] = "count_distinct";
  MetricAggregation["array_distinct"] = "array_distinct";
  MetricAggregation["max"] = "max";
  MetricAggregation["min"] = "min";
  MetricAggregation["p90"] = "p90";
})(MetricAggregation || (MetricAggregation = {}));

var Rollup;

(function (Rollup) {
  Rollup["1d"] = "1d";
  Rollup["1w"] = "1w";
  Rollup["1mo"] = "1mo";
  Rollup["custom"] = "custom";
})(Rollup || (Rollup = {}));

var GroupBy;

(function (GroupBy) {
  GroupBy["Team"] = "team";
  GroupBy["Organization"] = "organization";
  GroupBy["Contributor"] = "contributor";
  GroupBy["CustomMetric"] = "custom_metric";
  GroupBy["Label"] = "label";
  GroupBy["Repository"] = "repository";
})(GroupBy || (GroupBy = {}));

export { ACCOUNT_CREATION_SOURCE, ACCOUNT_TYPES_MAP, ACCOUNT_TYPES_NAMES, ARTICLE_IDS, AUTH, AUTH_ERROR, AVAILABLE_METRICS_WIDGETS_MAP, AggregationRangesEnum, BENCHMARKS_STATES, BENCHMARK_ORG_SIZE_KEYS, BRANCH_STATS_REGEX_FIELDS, CAN_EDIT_ACCOUNT_TYPES, CFR_INCIDENT_STRATEGY, CURRENCIES, CUSTOM_DASHBOARD_INTERNAL_TYPES, CUSTOM_PM_METRICS_TYPES, CUSTOM_STAGES_DEPLOY_FREQUENCY_REGEX, CYCLE_TIME_METRICS_BENCHMARKS_VALUES, DefinitionLevels, FEATURE_FLAGS_NAMES, FLOW_TRACKER_FLOW_STATUS, FLOW_TRACKER_INSIGHT_STATUS, FLOW_TRACKER_SERVICE_STATUS, ForceUpdateState, GITHUB_TOKEN_TYPES, GOALS_METRIC_NAMES, GRANULARITY, GROUP_BY_MAP, GroupBy, INCIDENTS_STRATEGIES, INCIDENTS_SUPPORTED_METRICS, INVITATION_TYPE, ISSUE_COUNT_CALCULATION_STRATEGY, ISSUE_COUNT_METRIC_NAME, ISSUE_TRANSITION_METRIC_NAME, LICENSE_PLAN_NAMES, LICENSE_PLAN_TIER_TYPE, MEDIAN_METRICS, MEDIAN_VALUES, MERGE_CONTRIBUTOR_SUGGESTION_STATE, MESSAGE_TYPES, METRICS_BENCHMARKS, METRICS_CALCULATION_STRATEGY_LABEL, METRICS_LIST, METRICS_WITH_INSPECTION_SUPPORTED, MTTR_STRATEGY, MetricAggregation, MetricCalculationStrategy, MetricUnitType, ORG_SIZE_CYCLE_TIME_METRICS_BENCHMARKS_VALUES, ORG_SIZE_METRICS_BENCHMARKS, OrderOptionsEnum, PERMISSION_ACTION, PERMISSION_DOMAIN, PERMISSION_SCOPE_ALL_TEAMS_ID, PERMISSION_SCOPE_TYPE, PM_CALCULATION_STRATEGY, PM_METRICS_ISSUES_STATES, PM_V3_METRICS, PROJECT_STATUS, PUSHER_DEFAULT_CHANNEL_PREFIX, PUSHER_EVENTS, ProgrammingLanguagesExtensionMapper, ProjectProgressionAggregatedTableTypeEnum, ProjectProgressionLinearBStatusCategoriesEnum, ProjectProgressionOverTimeChartTypeEnum, RBAC_ALL_TEAMS_SCOPE, REPOS_AUTO_DISCOVERY_STATE_TYPE, REPOS_AUTO_DISCOVERY_VISIBILITY_TYPE, REPOS_COLLECTOR_FILTER_MODE, Rollup, SAVED_FILTER_SET_TYPES, SAVED_FILTER_SET_VISIBILITIES, SENSORS_MAP, SENSOR_NAMES, SENSOR_PROVIDER_DETAILS, SENSOR_STATES, SENSOR_TYPES, STORY_POINTS_CALCULATION_STRATEGY, SettingValues, TEAM_INITIALS, TEAM_NAMES, TEAM_NAME_TYPES, TEAM_TYPE_MAP, TIME_TO_CUSTOM_STAGES_REGEX, USER_DEFAULT_INTRESTS_BY_ROLE, USER_INTERESTS, USER_ROLES, USER_YEARS_OF_EXPERIENCE, UserState, UserType, V3_METRICS, buildAmplitudeAccountName, generatePusherPrivateChannelName, getEmailDashIdUserId, getUserTrackingId, marketPlaceAutomations, metricDisplayValues, metricNames, metricsScales, resourceAllocationAggregationRangesEnum, resourceAllocationEpicStatusEnum, resourceAllocationIssueStatusEnum, resourceAllocationTypesEnum, rollup, sortingOrderEnum };
//# sourceMappingURL=linjs-common.esm.js.map
